/* eslint-disable prettier/prettier */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  LEGACY_TEMPLATEFAMILY_ID,
  NO_PREVIEW_ID,
} from "../shared/constConfig/config.js";
import orderBy from "lodash/orderBy";
import keyBy from "lodash/keyBy";
import InfoTooltip from "../InfoTooltip";
import get from "lodash/get";
import removeMarkdown from "remove-markdown";
import { useFormik } from "formik";
import Sticky from "react-sticky-el";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import { draftToMarkdown, markdownToDraft } from "markdown-draft-js";
import Highlighter from "react-highlight-words";

import Box from "@material-ui/core/Box";
import { Checkbox, FormControlLabel, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import Alert from "@material-ui/lab/Alert";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import MuiToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { useSnackbar } from "notistack";

import AddIcon from "@material-ui/icons/Add";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

import Preview from "../Preview";
import ImageUpload from "../ImageUpload";
import Input from "../shared/Input";
import Loader from "../shared/Loader";
import LocaleSelect from "../shared/LocaleSelect";
import MarkdownEditorV2 from "../shared/MarkdownEditorV2";
import OutlinedButton from "../OutlinedButton";
import Timestamps from "../Timestamps";
import useConfirmLeave from "../../hooks/useConfirmLeave";
import { getFieldProps, multilineInputProps, removeEmpty } from "../utils";
import { useAppContext } from "../../api/AppContext";
import { parseDidList } from "../Simulation";
import { useModals } from "../../hooks/useModals";
import { contentTypesConfig } from "../Journey/contentTypes";
import useModal from "../../hooks/useModal";
import useStickyHeight from "../../hooks/useStickyHeight";
import SpecialConditions, {
  SPECIAL_CONDITION_TYPES,
  CDP_SPECIAL_CONDITION_TYPES,
} from "./SpecialConditions";
import getData from "../../lib/getData";
import {
  getScheduledSlotName,
  getScheduledSlotDatetimeIntervalString,
  getScheduledSlotSpecificIntervalString,
} from "../../lib/scheduledSlotUtilities";
import {
  hasUnsupportedTeamsMarkdown,
} from "./utils/hasUnsupportedTeamsMarkdown";
// import {
//   interactionPeriods,
//   formatScheduledSlot,
// } from "../../lib/interactionPeriods";
// import format from "date-fns/format";
import UserStatePathSelect from "./UserStatePathSelect";
import TemplateFamilySelect from "./TemplateFamilySelect";
import CallBehaviourSelect, {
  getCallBehaviourOptions,
} from "../shared/CallBehaviourSelect";
import SemanticTemplateSelect from "./SemanticTemplateSelect";
// import SemanticPreviewTemplateSelect from "./SemanticPreviewTemplateSelect";
import JourneysSelect from "../shared/JourneysSelect";
import Link from "@material-ui/core/Link";
import AlertWithShowMore from "../AlertWithShowMore";
import SaveButtons from "../SaveButtons";
import FontFamilySelect from "../shared/FontFamilySelect.js";
// import GetAppIcon from "@material-ui/icons/GetApp";
import ImageIcon from "@material-ui/icons/Image";
import useLocalStorage from "../../hooks/useLocalStorage.js";
import AiIntegration from "./AiIntegration.js";
import AnimationSelect from "../AnimationSelect";
import { loadImageOriginalSize } from "./utils/loadImageOriginalSize";
import { parsePxToNumber } from "./utils/parsePxToNumber";
//import { loadAnimationTemplates } from "../../api/tmpData/animationTemplates.js";
import {
  CDP_COMPANY_ID,
  DIGITALATTITUDE_COMPANY_ID as DA_COMPANY_ID,
  SNAM_COMPANY_ID,
  getUserCompanies,
  isCdpOnlyUser,
  isSnamOnlyUser,
} from "../../lib/companyAccess";

const CDP_SPECIAL_LINK_IDS = [
  "link-74dbcf1b-02bf-4d89-853e-506cec48f575", // Home
  "link-6e693bad-453a-4150-82e6-9c7702d65b5e", // Learning Material
  "link-d5ea52e0-fcd6-4c31-a07d-862b5270f6a2", // Cyber tips
  "link-dcb88c03-b526-4b06-bd9d-c4b0aa62ecd4", // Diary
];

const FOREVER_NDAYS = 10000;
const CP_FINISHED_FROM = "cpFinished";

const CHANNEL_VALIDITY_OPTIONS = [
  { value: "any", label: "Any (once for a given user)" },
  { value: "client", label: "Only client" },
  { value: "teams", label: "Only Teams" },
  { value: "embedded", label: "Only embedded" },
  { value: "browser_plugin", label: "Only browser plugin" },
];

const SIMULATION_DESTINATION_CHANNEL_OPTIONS = CHANNEL_VALIDITY_OPTIONS.filter(
  ({ value }) => value !== "any"
);

const getLockedViewTypeForChannelValidity = (channelValidity) => {
  switch (channelValidity) {
    case "client":
    case "embedded":
    case "browser_plugin":
      return "client";
    case "teams":
      return "teams_app";
    default:
      return null;
  }
};

// Fast and easy token generation for preview rerender
// length-hash(base32) -> 8421-k3z9f2
const getPreviewRerenderToken = (interaction) => {
  const serializedInteraction = JSON.stringify(interaction ?? {});
  let hash = 0;

  for (let i = 0; i < serializedInteraction.length; i += 1) {
    hash = (hash * 31 + serializedInteraction.charCodeAt(i)) >>> 0;
  }

  return `${serializedInteraction.length}-${hash.toString(36)}`;
};

// import AnalyticsReport from "../AnalyticsReport/index";
const SelectorAlignedTypography = withStyles({
  root: {
    lineHeight: "2",
  },
})(Typography);

const Title = withStyles({
  root: {
    fontWeight: "bold",
    marginBottom: 6,
  },
})(Typography);

const SecondsSelector = withStyles({
  root: {
    paddingRight: 8,
    width: 120,
  },
})(TextField);

const SecondsSelectorWithinTypography = withStyles({
  root: {
    paddingLeft: 8,
  },
})(SecondsSelector);

const TimesSelector = withStyles({
  root: {
    paddingRight: 8,
    width: 120,
  },
})(TextField);

const Subtitle = withStyles({
  root: {
    fontSize: "14px",
  },
})(Typography);

const ToggleButton = withStyles(({ spacing }) => ({
  root: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
}))(MuiToggleButton);

const UnsupportedTeamsMarkdownAlert = () => (
  <Alert severity="warning" style={{ marginTop: "0.75rem" }}>
    Warning: unsupported markdown has been detected. Blockquotes, links, tables,
    and inline code are not supported in Teams. The preview may not match the
    card that is actually sent in Teams.
  </Alert>
);

const CTATypeSelect = ({ types, value, user, ...props }) => {
  const shouldFilterTypes = user?.companies?.includes(SNAM_COMPANY_ID) && 
                            !user?.groups?.includes("Admins");
  const isCdpUser = isCdpOnlyUser(user);
  
  const shouldShowType = (typeName) => {
    if (!shouldFilterTypes) return true;
    // Filter out types that include "Bloom", "Prompt", or "Skilling"
    const lowerTypeName = typeName.toLowerCase();
    return !lowerTypeName.includes("bloom") && 
           !lowerTypeName.includes("prompt") && 
           !lowerTypeName.includes("welfare") &&
           !lowerTypeName.includes("wecare") &&
           !lowerTypeName.includes("skilling");
  };

  return (
    <TextField
      fullWidth
      select
      InputLabelProps={{ shrink: true }}
      label="CTA action"
      placeholder="Select action type"
      variant="outlined"
      {...props}
      value={value || (!types || types.includes("Close") ? "Close" : value)}
    >
      {(!types || types.includes("Semantic")) && (
        <MenuItem value="Semantic">Semantic flow (next semantic)</MenuItem>
      )}
      {(!types || types.includes("Dashboard Material")) && (
        <MenuItem value="Dashboard Material">
          Link a material in Dashboard
        </MenuItem>
      )}
      {(!types || types.includes("External Link")) && (
        <MenuItem value="External Link">Link an external material</MenuItem>
      )}
      {(!types || types.includes("Special Link")) && (
        <MenuItem value="Special Link">Special link</MenuItem>
      )}
      {(!types || types.includes("Welfare")) && shouldShowType("Welfare") && !isCdpUser && (
        <MenuItem value="Welfare">Link a WeCare Welfare</MenuItem>
      )}
      {(!types || types.includes("News")) && shouldShowType("WeCare News") && !isCdpUser && (
        <MenuItem value="News">Link a WeCare News</MenuItem>
      )}
      {(!types || types.includes("NewsPage")) && !isCdpUser && (
        <MenuItem value="NewsPage">Link a News</MenuItem>
      )}
      {(!types || types.includes("Dashboard Step")) && (
        <MenuItem value="Dashboard Step">Step in dashboard</MenuItem>
      )}
      {(!types || types.includes("Survey")) && !isCdpUser && (
        <MenuItem value="Survey">Survey</MenuItem>
      )}
      {(!types || types.includes("Close")) && (
        <MenuItem value="Close">Close tip</MenuItem>
      )}

      {(!types || types.includes("Prompt Tool")) && shouldShowType("Prompt Tool") && !isCdpUser && (
        <MenuItem value="Prompt Tool">Link a prompt of fame Tool</MenuItem>
      )}

      {(!types || types.includes("Prompt")) && shouldShowType("Prompt") && !isCdpUser && (
        <MenuItem value="Prompt">Link a prompt of fame Prompt</MenuItem>
      )}

      {(!types || types.includes("Bloom Seed")) && shouldShowType("Bloom Seed") && !isCdpUser && (
        <MenuItem value="Bloom Seed">Link a Bloom Seed</MenuItem>
      )}

      {(!types || types.includes("AI Skilling Prompt")) && shouldShowType("AI Skilling Prompt") && !isCdpUser && (
        <MenuItem value="AI Skilling Prompt">Link an AI Skilling Prompt</MenuItem>
      )}

      {(!types || types.includes("Cyber Tip")) &&
        (isCdpUser || user?.companies?.includes(DA_COMPANY_ID)) && (
        <MenuItem value="Cyber Tip">Link a specific cyber tip</MenuItem>
      )}
    </TextField>
  );
};

// const TriggerSelect = ({ triggers, uiConfigs, ...props }) => (
//   <TextField
//     fullWidth
//     select
//     InputLabelProps={{ shrink: true }}
//     label="Trigger"
//     placeholder="Select trigger"
//     variant="outlined"
//     {...props}
//   >
//     {triggers.map(({ stimulusId, name, uiConfig }) => (
//       <MenuItem key={stimulusId} value={stimulusId}>
//         {name || "-"} (
//         {uiConfig?.anchor ||
//           uiConfigs[stimulusId]?.anchor ||
//           "notification_area"}
//         )
//       </MenuItem>
//     ))}
//   </TextField>
// );

const CTA = ({
  formik,
  index,
  isDisabled,
  materials = [],
  interactions,
  isMaterialsLoading,
  isSpecialLinksLoading,
  specialLinks,
  handleCreateMaterial,
  handleCreateSpecialLink,
  types,
  steps,
  surveys,
  isListJourneyBenefitsLoading,
  journeyBenefits,
  journeyNews,
  isListJourneyNewsLoading,
  isSurveysLoading,
  fieldName = "Button",
  user,
  ctaTypeFieldName = `cta${index || 1}Type`,
  ctaMaterialFieldName = `cta${index || 1}LinkId`,
  ctaTargetFieldName = `cta${index || 1}Target`,
  ctaWelfareFieldName = `cta${index || 1}LinkId`,
  ctaNewsPageFieldName = `cta${index || 1}LinkId`,
  isCTATitleShown = true,
  tools,
  prompts,
  seeds,
  aiSkillingPrompts,
  cyberTipsCdpPrompts,
  aiResult,
  copilotNews,
  isCopilotNewsLoading,
  isRichTextEnabled = false,
}) => {
  const indexString = index ? `${fieldName} ${index}` : fieldName;
  const type = get(formik.values, ctaTypeFieldName);
  const [selectedMaterialUrl, setSelectedMaterialUrl] = useState(null);

  useEffect(() => {
    const materialId = formik.values[ctaMaterialFieldName];
    if (materialId) {
      const selectedMaterial = materials?.find((m) => m.id === materialId);
      setSelectedMaterialUrl(selectedMaterial?.ctaUrl || null);
    }
  }, [ctaMaterialFieldName, formik.values, materials]);

  const handleLinkedMaterialChange = useCallback(
    (e, value) => {
      if (value.props.value === "new") {
        return;
      }
      formik.setFieldValue(ctaMaterialFieldName, value.props.value);
      formik.setFieldTouched(ctaMaterialFieldName, true);

      const selectedMaterial = materials?.find(
        (m) => m.id === value.props.value
      );
      setSelectedMaterialUrl(selectedMaterial?.ctaUrl || null);
    },
    [formik, materials, ctaMaterialFieldName]
  );

  const handleLinkedWelfareChange = useCallback(
    (e, value) => {
      if (value.props.value === "new") {
        return;
      }
      formik.setFieldValue(ctaWelfareFieldName, value.props.value);
      formik.setFieldTouched(ctaWelfareFieldName, true);
    },
    [formik, index]
  );

  const handleLinkedNewsPageChange = useCallback(
    (e, value) => {
      formik.setFieldValue(ctaNewsPageFieldName, value.props.value);
      formik.setFieldTouched(ctaNewsPageFieldName, true);
    },
    [formik, ctaNewsPageFieldName]
  );

  const handleNextInteractionChange = useCallback(
    (e, value) => {
      formik.setFieldValue(ctaTargetFieldName, value.props.value);
      formik.setFieldTouched(ctaTargetFieldName, true);
    },
    [formik, index]
  );

  const handleCTATypeChange = useCallback(
    (e) => {
      formik.setFieldValue(ctaTypeFieldName, e.target.value);
      formik.setFieldTouched(ctaTypeFieldName, true);
      formik.setFieldValue(ctaMaterialFieldName, undefined);
      formik.setFieldTouched(ctaMaterialFieldName, true);
      formik.setFieldValue(ctaWelfareFieldName, undefined); // linkId
      formik.setFieldTouched(ctaWelfareFieldName, true);
      formik.setFieldValue(ctaNewsPageFieldName, undefined);
      formik.setFieldTouched(ctaNewsPageFieldName, true);
    },
    [
      formik,
      ctaTypeFieldName,
      ctaMaterialFieldName,
      ctaWelfareFieldName,
      ctaNewsPageFieldName,
    ]
  );

  return (
    <Grid container spacing={4}>
      {(!types || types.length > 1) && (
        <Grid item xs={isCTATitleShown || (type && type !== "Close") ? 6 : 12}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <CTATypeSelect
                label={`${indexString} action`}
                {...getFieldProps(formik, {
                  disabled: isDisabled,
                  name: ctaTypeFieldName,
                })}
                types={types}
                user={user}
                onChange={handleCTATypeChange}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={!types || types.length > 1 ? 6 : 12}>
        <Grid container spacing={4}>
          {isCTATitleShown && (
            <Grid item xs={12}>
              {isRichTextEnabled ? (
                <MarkdownEditorV2
                  autoLink={false}
                  disableBlockTypeSelect={true}
                  disableBoldItalicUnderline={["underline"]}
                  disableCreateLink={true}
                  disableListsToggle={true}
                  error={false}
                  placeHolder={`${indexString} text`}
                  value={get(formik.values, `cta${index || 1}Text`) || ""}
                  onChange={(val) => {
                    formik.setFieldValue(`cta${index || 1}Text`, val);
                    formik.setFieldTouched(`cta${index || 1}Text`, true);
                  }}
                />
              ) : (
                <Input
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: `cta${index || 1}Text`,
                  })}
                  helperText={`${
                    (get(formik.values, `cta${index || 1}Text`) || "").length
                  }/25 characters (suggested max)`}
                  label={`${indexString} text`}
                  placeholder="Be accurate, specific, explicit. Don't be vague."
                />
              )}
            </Grid>
          )}
          {type && type !== "Close" && (!types || types.length > 1) && (
            <Grid item xs={12}>
              {type === "External Link" && (
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label={`${indexString} link`}
                  placeholder="https://"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaTargetFieldName,
                  })}
                />
              )}
              {type === "Semantic" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label={`Next ${
                    formik.values.type === "PRIME" ? "tip" : "nudge"
                  }`}
                  placeholder={`Select next ${
                    formik.values.type === "PRIME" ? "tip" : "nudge"
                  }`}
                  {...getFieldProps(formik, {
                    name: ctaTargetFieldName,
                    isDisabled,
                  })}
                  variant="outlined"
                  onChange={handleNextInteractionChange}
                >
                  {interactions
                    ?.filter(({ id }) => id !== formik.values.id)
                    .map(({ id, title, text }) => (
                      <MenuItem key={id} value={id}>
                        <ListItemText primary={title} secondary={text} />
                      </MenuItem>
                    ))}
                </TextField>
              )}
              {type === "Dashboard Material" && (
                <>
                  <TextField
                    fullWidth
                    select
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          {isMaterialsLoading && <CircularProgress size={25} />}
                        </InputAdornment>
                      ),
                    }}
                    label="Learning material"
                    placeholder="Select Material"
                    {...getFieldProps(formik, {
                      name: ctaMaterialFieldName,
                      isDisabled: isMaterialsLoading || isDisabled,
                    })}
                    variant="outlined"
                    onChange={handleLinkedMaterialChange}
                  >
                    <MenuItem value="new" onClick={handleCreateMaterial}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width="100%"
                      >
                        <ListItemText primary="Add new material" />
                        <Box alignItems="center" display="flex">
                          <AddIcon />
                        </Box>
                      </Box>
                    </MenuItem>
                    <Divider />
                    {materials?.map(({ id, name, description }) => (
                      <MenuItem key={id} value={id}>
                        <ListItemText primary={name} secondary={description} />
                      </MenuItem>
                    ))}
                  </TextField>
                  {selectedMaterialUrl?.includes("/diary") && (
                    <TextField
                      fullWidth
                      select
                      InputLabelProps={{ shrink: true }}
                      label="Diary Sections"
                      placeholder="Select Diary Section"
                      {...getFieldProps(formik, {
                        isDisabled: isDisabled,
                        name: `cta${index || 1}DiarySection`,
                      })}
                      style={{ marginTop: "16px" }}
                      variant="outlined"
                    >
                      <MenuItem value="section=EVOLUZIONE&isCover=true">
                        Evoluzione Cover
                      </MenuItem>
                      <MenuItem value="section=EVOLUZIONE">
                        Evoluzione Section
                      </MenuItem>
                      <MenuItem value="section=VELOCITA&isCover=true">
                        Velocità Cover
                      </MenuItem>
                      <MenuItem value="section=VELOCITA">
                        Velocità Section
                      </MenuItem>
                      <MenuItem value="section=FIDUCIA&isCover=true">
                        Fiducia Cover
                      </MenuItem>
                      <MenuItem value="section=FIDUCIA">
                        Fiducia Section
                      </MenuItem>
                      <MenuItem value="section=CORAGGIO&isCover=true">
                        Coraggio Cover
                      </MenuItem>
                      <MenuItem value="section=CORAGGIO">
                        Coraggio Section
                      </MenuItem>
                      <MenuItem value="section=IMPATTO&isCover=true">
                        Impatto Cover
                      </MenuItem>
                      <MenuItem value="section=IMPATTO">
                        Impatto Section
                      </MenuItem>
                    </TextField>
                  )}
                </>
              )}
              {type === "Welfare" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="end">
                        {isListJourneyBenefitsLoading && (
                          <CircularProgress size={25} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  label="Welfares"
                  placeholder="Select Welfare"
                  {...getFieldProps(formik, {
                    isDisabled: isListJourneyBenefitsLoading || isDisabled,
                    name: ctaWelfareFieldName,
                  })}
                  variant="outlined"
                  onChange={handleLinkedWelfareChange}
                >
                  <Divider />
                  {journeyBenefits?.map(({ id, name, description }) => (
                    <MenuItem key={id} value={id}>
                      <ListItemText primary={name} secondary={description} />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "News" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="end">
                        {isListJourneyNewsLoading && (
                          <CircularProgress size={25} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  label="News"
                  placeholder="Select News"
                  {...getFieldProps(formik, {
                    isDisabled: isListJourneyNewsLoading || isDisabled,
                    name: ctaWelfareFieldName,
                  })}
                  variant="outlined"
                  onChange={handleLinkedWelfareChange}
                >
                  <Divider />
                  {journeyNews?.map(({ id, text_default }) => (
                    <MenuItem key={id} value={id}>
                      <ListItemText
                        primary={text_default?.title}
                        secondary={text_default?.summary}
                      />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "NewsPage" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="end">
                        {isCopilotNewsLoading && <CircularProgress size={25} />}
                      </InputAdornment>
                    ),
                  }}
                  label="News"
                  placeholder="Select News"
                  {...getFieldProps(formik, {
                    isDisabled: isCopilotNewsLoading || isDisabled,
                    name: ctaNewsPageFieldName,
                  })}
                  variant="outlined"
                  onChange={handleLinkedNewsPageChange}
                >
                  <Divider />
                  {copilotNews?.map(({ id, text_default }) => (
                    <MenuItem key={id} value={id}>
                      <ListItemText
                        primary={text_default?.title}
                        secondary={text_default?.summary}
                      />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "Special Link" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="end">
                        {isSpecialLinksLoading && (
                          <CircularProgress size={25} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  label="Special Link"
                  placeholder="Select Special Link"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    name: ctaMaterialFieldName,
                    disabled: isSpecialLinksLoading || isDisabled,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {!(
                    (user.companies?.includes(SNAM_COMPANY_ID) &&
                      !user.groups.includes("Admins")) ||
                    isCdpOnlyUser(user)
                  ) && (
                    <>
                      <MenuItem value="new" onClick={handleCreateSpecialLink}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          width="100%"
                        >
                          <ListItemText primary="Add new special link" />
                          <Box alignItems="center" display="flex">
                            <AddIcon />
                          </Box>
                        </Box>
                      </MenuItem>
                      <Divider />
                    </>
                  )}
                  {specialLinks
                    ?.filter(({ id, name }) => {
                      if (isCdpOnlyUser(user)) {
                        return CDP_SPECIAL_LINK_IDS.includes(id);
                      }
                      const isRestrictedUser =
                        user.companies?.includes(SNAM_COMPANY_ID) &&
                        !user.groups.includes("Admins");
                      if (isRestrictedUser) {
                        return (
                          name === "Dashboard Home" ||
                          name === "Dashboard Settings"
                        );
                      }
                      return true;
                    })
                    .map(({ id, name, url }) => (
                      <MenuItem key={id} value={id}>
                        <ListItemText primary={name} secondary={url} />
                      </MenuItem>
                    ))}
                </TextField>
              )}
              {type === "Dashboard Step" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Dashboard step"
                  placeholder="Select dashboard step"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    name: ctaMaterialFieldName,
                    disabled: isDisabled,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {steps.map(({ id, name, description }) => (
                    <MenuItem key={id} value={id}>
                      <ListItemText primary={name} secondary={description} />
                    </MenuItem>
                  ))}
                </TextField>
              )}

              {type === "Prompt Tool" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Prompt Tool"
                  placeholder="Select tool"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaMaterialFieldName,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {tools
                    .slice()
                    .sort((a, b) => a.toolname.localeCompare(b.toolname))
                    .map((tool) => (
                    <MenuItem key={tool.id} value={tool.toolname}>
                      <ListItemText primary={tool.toolname} />
                    </MenuItem>
                  ))}
                </TextField>
              )}

              {type === "Prompt" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Prompt"
                  placeholder="Select prompt"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaMaterialFieldName,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {prompts
                    .slice()
                    .sort((a, b) => a.title.it.localeCompare(b.title.it))
                    .map((prompt) => (
                    <MenuItem key={prompt.id} value={prompt.id}>
                      <ListItemText primary={prompt.title.it} />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "Bloom Seed" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Seed"
                  placeholder="Select seed"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaMaterialFieldName,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {seeds.map((seed) => (
                    <MenuItem key={seed.id} value={seed.id}>
                      <ListItemText primary={seed.title.it} />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "AI Skilling Prompt" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Prompt"
                  placeholder="Select prompt"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaMaterialFieldName,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {aiSkillingPrompts
                    .slice()
                    .sort((a, b) => a.title.it.localeCompare(b.title.it))
                    .map((aiskilling) => (
                    <MenuItem key={aiskilling.id} value={aiskilling.id}>
                      <ListItemText primary={aiskilling.title.it} />
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {type === "Cyber Tip" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Cyber tip"
                  placeholder="Select cyber tip"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    disabled: isDisabled,
                    name: ctaMaterialFieldName,
                  })}
                  onChange={handleLinkedMaterialChange}
                >
                  {(cyberTipsCdpPrompts || [])
                    .slice()
                    .sort((a, b) =>
                      (a.title?.it || a.title?.en || "").localeCompare(
                        b.title?.it || b.title?.en || ""
                      )
                    )
                    .map((cyberTip) => (
                      <MenuItem key={cyberTip.id} value={cyberTip.id}>
                        <ListItemText
                          primary={cyberTip.title?.it || cyberTip.title?.en}
                        />
                      </MenuItem>
                    ))}
                </TextField>
              )}
              {type === "Survey" && (
                <TextField
                  fullWidth
                  select
                  InputLabelProps={{ shrink: true }}
                  label="Survey"
                  placeholder="Select survey"
                  variant="outlined"
                  {...getFieldProps(formik, {
                    name: ctaMaterialFieldName,
                    disabled: isDisabled,
                  })}
                  InputProps={{
                    startAdornment: isSurveysLoading && (
                      <InputAdornment position="end">
                        <CircularProgress size={25} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleLinkedMaterialChange}
                >
                  {surveys
                    .filter((survey) => survey.type !== "hi")
                    .map(({ id, name, description }) => (
                      <MenuItem key={id} value={id}>
                        <ListItemText primary={name} secondary={description} />
                      </MenuItem>
                    ))}
                </TextField>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

const validationSchema = (interaction, days) =>
  Yup.object().shape({
    afterCallDelay: Yup.number().when("callBehaviour", {
      is: "delay",
      then: Yup.number()
        .integer()
        .min(0, "Must be greater than or equal to 0")
        .required("required"),
    }),
    callBehaviour: Yup.string().when("callRelatedCustomization", {
      is: true,
      then: Yup.string()
        .nullable()
        .required("If the user is in call behaviour is a required field"),
      otherwise: Yup.string().nullable(),
    }),

    semanticTemplateId: Yup.string().when("viewType", {
      is: "client",
      then: Yup.string()
        .nullable()
        .required("Card Template is a required field"),
      otherwise: Yup.string().nullable(),
    }),
    semanticPreview: Yup.object().when("isFirstInFlow", {
      is: true,
      then: Yup.object().shape({
        semanticPreviewTemplateId: Yup.string()
          .nullable()
          .required("Preview Template is a required field"),
      }),
    }),
    callRelatedCustomization: Yup.boolean().nullable(),
    conditions: Yup.array().of(
      Yup.object({
        type: Yup.mixed()
          .oneOf([
            "hour",
            "weekday",
            "day",
            "month",
            "activeDays",
            "userStatePath",
            "survey",
            "subscribedToWelfare",
            "listOfUsers",
          ])
          .required(),
        values: Yup.mixed().when("type", {
          is: (type) =>
            ![
              "hour",
              "activeDays",
              "userStatePath",
              "survey",
              "subscribedToWelfare",
              "lmconsumed",
              "listOfUsers",
            ].includes(type),
          then: Yup.array().min(1).required(),
          otherwise: Yup.string().nullable(),
        }),
        from: Yup.mixed().when("type", {
          is: (type) => type === "hour",
          then: Yup.object({
            hours: Yup.number().min(0).max(23),
            minutes: Yup.number().min(0).max(59),
          })
            .nullable()
            .required(),
          otherwise: Yup.mixed().when("type", {
            is: (type) => type === "activeDays",
            then: Yup.mixed().test(
              "activeDays-from",
              `This Journey is ${days} days long. You cannot exceed ${
                days + 1
              } days.`,
              (value) => {
                if (value == null || value === "") {
                  return true;
                }
                if (value === CP_FINISHED_FROM) {
                  return true;
                }
                const n = Number(value);
                return Number.isFinite(n) && n >= 1 && n <= days + 1;
              }
            ),
          }),
        }),
        to: Yup.mixed().when("type", {
          is: (type) => type === "hour",
          then: Yup.object({
            hours: Yup.number().min(0).max(23),
            minutes: Yup.number().min(0).max(59),
          })
            .nullable()
            .required(),
          otherwise: Yup.number().when("type", {
            is: (type) => type === "activeDays",
            then: Yup.number().min(1).max(
              FOREVER_NDAYS
              // days + 1,
              // `This Journey is ${days} days long. You cannot exceed ${
              //   days + 1
              // } days.`
            ),
          }),
        }),
      })
    ),
    cta1LinkId: Yup.mixed()
      .when("cta1Type", {
        is: (type) => ["Special Link"].includes(type),
        then: Yup.string().required("Special link is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["Welfare"].includes(type),
        then: Yup.string().required("Welfare is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["News"].includes(type),
        then: Yup.string().required("News is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["NewsPage"].includes(type),
        then: Yup.string().required("News is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["Prompt Tool"].includes(type),
        then: Yup.string().required("Prompt Tool is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["Prompt"].includes(type),
        then: Yup.string().required("Prompt is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["Bloom Seed"].includes(type),
        then: Yup.string().required("Seed is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["AI Skilling Prompt"].includes(type),
        then: Yup.string().required("Prompt is a required field"),
      })
      .when("cta1Type", {
        is: (type) => ["Cyber Tip"].includes(type),
        then: Yup.string().required("Cyber tip is a required field"),
      }),
    cta2LinkId: Yup.mixed()
      .when("cta2Type", {
        is: (type) => ["Special Link"].includes(type),
        then: Yup.string().required("Special link is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["Welfare"].includes(type),
        then: Yup.string().required("Welfare is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["News"].includes(type),
        then: Yup.string().required("News is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["NewsPage"].includes(type),
        then: Yup.string().required("News is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["Prompt Tool"].includes(type),
        then: Yup.string().required("Prompt Tool is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["Prompt"].includes(type),
        then: Yup.string().required("Prompt is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["Bloom Seed"].includes(type),
        then: Yup.string().required("Seed is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["AI Skilling Prompt"].includes(type),
        then: Yup.string().required("Prompt is a required field"),
      })
      .when("cta2Type", {
        is: (type) => ["Cyber Tip"].includes(type),
        then: Yup.string().required("Cyber tip is a required field"),
      }),
    miniTipAutoProgress: Yup.boolean().nullable(),
    miniTipAutoProgressDelay: Yup.number().when("miniTipAutoProgress", {
      is: true,
      then: Yup.number()
        .integer()
        .min(0, "Must be greater than or equal to 0")
        .required("required"),
    }),
    miniTipAutoProgressOnlyIfIgnored: Yup.boolean().nullable(),
    miniTipAutoProgressOnlyIfIgnoredTimes: Yup.number().when(
      "miniTipAutoProgressOnlyIfIgnored",
      {
        is: true,
        then: Yup.number()
          .integer()
          .min(1, "Must be greater than or equal to 1")
          .required("required"),
      }
    ),
    dropdownData: Yup.array().of(
      Yup.object({
        label: Yup.string().required("Required field"),
        value: Yup.string().required("Value is a required field"),
      })
    ),
    tipgroup: Yup.string().nullable(),
    titleForPowerBI: Yup.string().nullable(),
    channelValidity: Yup.string().required(
      "Channel Validity is a required field"
    ),
    viewType: Yup.string(),
    teams: Yup.object().when("viewType", {
      is: "teams_app",
      then: Yup.object()
        .shape({
          backgrColorImage: Yup.string().nullable(),
          backgroundColor: Yup.string().nullable(),
          backgroundImage: Yup.string().nullable(),
          horizontalAlignment: Yup.string().nullable(),
          image1HorizontalAlignment: Yup.string().nullable(),
          image2HorizontalAlignment: Yup.string().nullable(),
          imageHeight: Yup.string().nullable(),
          imageWidth: Yup.string().nullable(),
          image1: Yup.string().nullable(),
          image1Width: Yup.string().nullable(),
          image1Height: Yup.string().nullable(),
          image2: Yup.string().nullable(),
          image2Width: Yup.string().nullable(),
          image2Height: Yup.string().nullable(),
          mainImage: Yup.string().nullable(),
          semanticTemplateId: Yup.string().required(
            "Card Template is a required field"
          ),
          size: Yup.string().nullable(),
          image1Size: Yup.string().nullable(),
          image2Size: Yup.string().nullable(),
          templateFamilyId: Yup.string().required(
            "Family Template is a required field"
          ),
          textColor: Yup.string().nullable(),
          textSize: Yup.string().nullable(),
          titleColor: Yup.string().nullable(),
          titleSize: Yup.string().nullable(),
        })
        .nullable(),
    }),
  });

const filterOptions = createFilterOptions({
  stringify: (option) => `${option.name} ${option.day} ${option.date}`,
});

const Option = ({
  aiResult,
  formik,
  isDisabled,
  onDropdownDataChange,
  onDropdownDataDelete,
  label,
  value,
  i,
  journeys,
  locale,
  materials,
  steps,
  surveys,
  tools,
  prompts,
  seeds,
  aiSkillingPrompts,
  cyberTipsCdpPrompts,
  copilotNews,
  isCopilotNewsLoading,
  isListJourneyBenefitsLoading,
  journeyBenefits,
  journeyNews,
  isListJourneyNewsLoading,
  isSurveysLoading,
  specialLinks,
  interactions,
  isMaterialsLoading,
  isSpecialLinksLoading,
  onCreateMaterial,
  onCreateSpecialLink,
  isDeleteEnabled = true,
  user,
}) => {
  const optionLabelLength = (label || "").length;

  return (
    <Fragment>
      <Grid item md={3} xs={12}>
        <Input
          {...getFieldProps(formik, {
            name: `dropdownData.${i + 1}.label`,
          })}
          fullWidth
          required
          InputLabelProps={{ shrink: true }}
          disabled={isDisabled}
          helperText={`${optionLabelLength}/25 characters (suggested max)`}
          label={`Option ${i + 1} text`}
          value={label}
          variant="outlined"
          onChange={onDropdownDataChange(i + 1, "label")}
        />
      </Grid>
      <Grid item md={9} xs={12}>
        <Grid container spacing={4}>
          <Grid item md={4} xs={12}>
            {(formik.values.userStatePath === "currentJourney" && (
              <JourneysSelect
                disableClearable
                {...getFieldProps(formik, {
                  name: `dropdownData.${i + 1}.value`,
                  helperText:
                    "Select the current Journey if you don't want to have user changing Journey",
                })}
                journeys={journeys}
                label="Journey"
                lable="Journey"
                value={value}
                onChange={onDropdownDataChange(i + 1, "value")}
              />
            )) ||
              (formik.values.userStatePath === "locale" && (
                <LocaleSelect
                  required
                  label="Language"
                  {...getFieldProps(formik, {
                    name: `dropdownData.${i + 1}.value`,
                    helperText: "Select the language",
                  })}
                  value={value}
                  onChange={onDropdownDataChange(i + 1, "value")}
                />
              )) || (
                <TextField
                  {...getFieldProps(formik, {
                    name: `dropdownData.${i + 1}.value`,
                  })}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  disabled={isDisabled}
                  label={`Option ${i + 1} value`}
                  value={value}
                  variant="outlined"
                  onChange={onDropdownDataChange(i + 1, "value")}
                />
              )}
          </Grid>
          <Grid item style={{ flex: 1, display: "" }}>
            <CTA
              aiSkillingPrompts={aiSkillingPrompts}
              copilotNews={copilotNews}
              ctaMaterialFieldName={`dropdownData.${i + 1}.ctaTarget`}
              ctaNewsPageFieldName={`dropdownData.${i + 1}.ctaTarget`}
              ctaTargetFieldName={`dropdownData.${i + 1}.ctaTarget`}
              ctaTypeFieldName={`dropdownData.${i + 1}.ctaType`}
              ctaWelfareFieldName={`dropdownData.${i + 1}.ctaTarget`}
              cyberTipsCdpPrompts={cyberTipsCdpPrompts}
              fieldName="Option"
              formik={formik}
              handleCreateMaterial={onCreateMaterial}
              handleCreateSpecialLink={onCreateSpecialLink}
              index={i + 1}
              interactions={interactions}
              isCTATitleShown={false}
              isCopilotNewsLoading={isCopilotNewsLoading}
              isDisabled={isDisabled}
              isListJourneyBenefitsLoading={isListJourneyBenefitsLoading}
              isListJourneyNewsLoading={isListJourneyNewsLoading}
              isMaterialsLoading={isMaterialsLoading}
              isSpecialLinksLoading={isSpecialLinksLoading}
              isSurveysLoading={isSurveysLoading}
              journeyBenefits={journeyBenefits}
              journeyNews={journeyNews}
              materials={materials}
              prompts={prompts}
              seeds={seeds}
              specialLinks={specialLinks}
              steps={steps}
              surveys={surveys}
              tools={tools}
              user={user}
            />
          </Grid>
          {isDeleteEnabled && (
            <Grid item>
              <IconButton
                disabled={isDisabled}
                onClick={onDropdownDataDelete(i + 1)}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

const Interaction = ({
  interaction,
  interactions,
  journeyId,
  locale,
  name,
  isNew,
  journey,
  ...props
}) => {
  const {
    triggers,
    updateJourneySemantic,
    materials,
    fetchMaterials,
    fetchJourneyBenefits,
    fetchJourneyNews,
    templateFamilies,
    teamsTemplateFamilies,
    fetchTemplateFamilies,
    fetchTeamsTemplateFamilies,
    fetchSemanticTemplates,
    fetchTeamsSemanticTemplates,
    fetchSemanticPreviewTemplates,
    fetchSpecialLinks,
    isListJourneyBenefitsLoading,
    isListJourneyNewsLoading,
    isMaterialsLoading,
    specialLinks,
    isSpecialLinksLoading,
    updateJourneyMaterial,
    deleteJourneySemantic,
    groups,
    updateJourneyGroup,
    updateSpecialLink,
    triggerConfigs,
    updateTriggerConfig,
    journeys,
    flowRelations,
    semantics,
    semanticTemplates,
    teamsSemanticTemplates,
    //semanticPreviewTemplates,
    isScheduledSlotsLoading,
    scheduledSlots,
    deleteFlowRelation,
    createFlowRelation,
    userStatePaths,
    isUserStatePathsLoading,
    fetchUserStatePaths,
    isSurveysLoading,
    surveys,
    journeyBenefits,
    journeyNews,
    user,
    tools,
    fetchTools,
    prompts,
    seeds,
    fetchPrompts,
    aiSkillingPrompts,
    cyberTipsCdpPrompts,
    fetchAllSurveysForUser: fetchSurveys,
    fetchTipGroups,
    tipGroups,
    //teamsGalleryImages = [],
    //fetchTeamsGalleryImages,
    listofusers,
    copilotNews,
    fetchCopilotNews,
    isCopilotNewsLoading,
    getJourneyDaySlots,
    daySlotsByDayId,
    linkJourneyFlowToDaySlot,
    unlinkJourneyFlowToDaySlot,
    simulateSemantic,
    isSimulateSemanticLoading,
  } = useAppContext();
  const location = useLocation();
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [wizardVisible, setWizardVisible] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [savedRelations, setSavedRelations] = useState(null);
  const [maintainAspectRatioImage1, setMaintainAspectRatioImage1] = useState(true);
  const [maintainAspectRatioImage2, setMaintainAspectRatioImage2] = useState(true);
  const [maintainAspectRatioMainImage, setMaintainAspectRatioMainImage] = useState(true);

  const [localViewType, setLocalViewType] = useLocalStorage(
    `viewType`,
    "client"
  );
  const [simulationDeviceIds, setSimulationDeviceIds] = useState("");
  const [simulationDestinationChannel, setSimulationDestinationChannel] =
    useState("client");
  const { enqueueSnackbar } = useSnackbar();

  const updateAiServiceResult = (result) => {
    setAiResult(result);
  };
  // const handleAiClick = () => {
  //   setWizardVisible(true);
  // };

  const { flowRelationsByFlowId, primesByFlowId } = useMemo(
    () => getData({ flowRelations, semantics, days: journey?.days }),
    [flowRelations, semantics, journey?.days]
  );

  const daysById = useMemo(
    () => keyBy(journey?.days || [], "id"),
    [journey?.days]
  );

  if (Array.isArray(interaction.dropdownData)) {
    interaction.dropdownData[0] = {
      ...interaction.dropdownData[0],
      label: interaction.dropdownData[0]?.label ?? "Placeholder",
      value: interaction.dropdownData[0]?.value ?? "Placeholder",
    };
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...interaction,
      afterCallDelay: interaction?.afterCallDelay ?? 60,
      callBehaviour: interaction?.callBehaviour,
      callRelatedCustomization:
        interaction?.callRelatedCustomization ||
        Boolean(interaction?.callBehaviour),
      templateFamilyId: interaction.templateFamilyId
        ? interaction.templateFamilyId
        : LEGACY_TEMPLATEFAMILY_ID,
      templateFonts: {
        ctafontfamily: interaction.templateFonts?.ctafontfamily ?? null,
        ctafontsize: interaction.templateFonts?.ctafontsize ?? null,
        textfontfamily: interaction.templateFonts?.textfontfamily ?? null,
        textfontsize: interaction.templateFonts?.textfontsize ?? null,
        titlefontfamily: interaction.templateFonts?.titlefontfamily ?? null,
        titlefontsize: interaction.templateFonts?.titlefontsize ?? null,
      },
      templateColors: {
        color1: interaction.templateColors?.color1 ?? null,
        color1cta: interaction.templateColors?.color1cta ?? null,
        color2: interaction.templateColors?.color2 ?? null,
        color2cta: interaction.templateColors?.color2cta ?? null,
        color3: interaction.templateColors?.color3 ?? null,
        color4: interaction.templateColors?.color4 ?? null,
        colordecoration1: interaction.templateColors?.colordecoration1 ?? null,
      },
      animationId: interaction.animationId ?? null,
      //animationLoop: interaction.animationLoop ?? false,
      //animationPlayReverse: interaction.animationPlayReverse ?? false,
      //animationSpeed: interaction.animationSpeed ?? null,
      animationColor: interaction.animationColor ?? null,
      //cssAnimationStartDelay: interaction.cssAnimationStartDelay ?? null,
      semanticTemplateId: interaction.semanticTemplateId ?? null,
      semanticPreview: {
        semanticPreviewTemplateId:
          interaction.semanticPreview?.semanticPreviewTemplateId ||
          NO_PREVIEW_ID,
        cta1Text: interaction.semanticPreview?.cta1Text || "",
        text: draftToMarkdown(
          markdownToDraft(interaction.semanticPreview?.text || "")
        ),
        title: draftToMarkdown(
          markdownToDraft(interaction.semanticPreview?.title || "")
        ),
        ctafontfamily: interaction.semanticPreview?.ctafontfamily ?? null,
        ctafontsize: interaction.templateFonts?.ctafontsize ?? null,
        textfontfamily: interaction.semanticPreview?.textfontfamily ?? null,
        textfontsize: interaction.semanticPreview?.textfontsize ?? null,
        titlefontfamily: interaction.semanticPreview?.titlefontfamily ?? null,
        titlefontsize: interaction.semanticPreview?.titlefontsize ?? null,
      },
      title: draftToMarkdown(markdownToDraft(interaction.title || "")),
      text: draftToMarkdown(markdownToDraft(interaction.text || "")),
      channelValidity: interaction?.channelValidity ?? "any",
      viewType: (() => {
        const lockedViewType = getLockedViewTypeForChannelValidity(
          interaction?.channelValidity ?? "any"
        );
        if (lockedViewType) {
          return lockedViewType;
        }
        return interaction?.viewType
          ? interaction.viewType
          : interaction.isNew
          ? localViewType
          : "client";
      })(),
      imageId: interaction?.imageId ?? null,
      imageIdOriginal: interaction?.imageIdOriginal ?? null,
      images: {
        image1: interaction?.images?.image1 ?? null,
        image1Original: interaction?.images?.image1Original ?? null,
        image2: interaction?.images?.image2 ?? null,
        image2Original: interaction?.images?.image2Original ?? null,
        bg1: interaction?.images?.bg1 ?? null,
        bg1Original: interaction?.images?.bg1Original ?? null,
        bg2: interaction?.images?.bg2 ?? null,
        bg2Original: interaction?.images?.bg2Original ?? null,
        cta: interaction?.images?.cta ?? null,
        ctaOriginal: interaction?.images?.ctaOriginal ?? null,
        cta2: interaction?.images?.cta2 ?? null,
        cta2Original: interaction?.images?.cta2Original ?? null,
      },
      image1Shadow: interaction?.image1Shadow ?? false,
      image1top: interaction?.image1top ?? null,
      image1left: interaction?.image1left ?? null,
      image1right: interaction?.image1right ?? null,
      image1width: interaction?.image1width ?? null, 
      image1height: interaction?.image1height ?? null,
      image2top: interaction?.image2top ?? null,
      image2right: interaction?.image2right ?? null,
      image2left: interaction?.image2left ?? null,
      image2width: interaction?.image2width ?? null,
      image2height: interaction?.image2height ?? null,
      ctashorizontalalignment: interaction?.ctashorizontalalignment ?? null,
      cardheight: interaction?.cardheight ?? null,
      cardwidth: interaction?.cardwidth ?? null,
      closeposx: interaction?.closeposx ?? null,
      closeposy: interaction?.closeposy ?? null,
      ctastrokecolor: interaction?.ctastrokecolor ?? null,
      ctastrokewidth: interaction?.ctastrokewidth ?? null,
      ctaheight: interaction?.ctaheight ?? null,
      ctawidth: interaction?.ctawidth ?? null,
      ctacornertopleftvalue:
        interaction?.ctacornertopleftvalue ?? null,
      ctacornertoplefttype: interaction?.ctacornertoplefttype ?? "Round",
      ctacornertoprightvalue:
        interaction?.ctacornertoprightvalue ?? null,
      ctacornertoprighttype:
        interaction?.ctacornertoprighttype ?? "Round",
      ctacornerbottomleftvalue:
        interaction?.ctacornerbottomleftvalue ?? null,
      ctacornerbottomlefttype:
        interaction?.ctacornerbottomlefttype ?? "Round",
      ctacornerbottomrightvalue:
        interaction?.ctacornerbottomrightvalue ?? null,
      ctacornerbottomrighttype:
        interaction?.ctacornerbottomrighttype ?? "Round",
      ctaposx: interaction?.ctaposx ?? null,
      ctaposy: interaction?.ctaposy ?? null,
      cta2strokecolor: interaction?.cta2strokecolor ?? null,
      cta2strokewidth: interaction?.cta2strokewidth ?? null,
      cta2height: interaction?.cta2height ?? null,
      cta2width: interaction?.cta2width ?? null,
      cta2cornertopleftvalue:
        interaction?.cta2cornertopleftvalue ??
        interaction?.cta2cornerradiustopleft ??
        null,
      cta2cornertoplefttype:
        interaction?.cta2cornertoplefttype ?? "Round",
      cta2cornertoprightvalue:
        interaction?.cta2cornertoprightvalue ??
        interaction?.cta2cornerradiustopright ??
        null,
      cta2cornertoprighttype:
        interaction?.cta2cornertoprighttype ?? "Round",
      cta2cornerbottomleftvalue:
        interaction?.cta2cornerbottomleftvalue ??
        interaction?.cta2cornerradiusbottomleft ??
        null,
      cta2cornerbottomlefttype:
        interaction?.cta2cornerbottomlefttype ?? "Round",
      cta2cornerbottomrightvalue:
        interaction?.cta2cornerbottomrightvalue ??
        interaction?.cta2cornerradiusbottomright ??
        null,
      cta2cornerbottomrighttype:
        interaction?.cta2cornerbottomrighttype ?? "Round",
      cta2posx: interaction?.cta2posx ?? null,
      cta2posy: interaction?.cta2posy ?? null,
      cta2fontfamily: interaction?.cta2fontfamily ?? null,
      cta2fontsize: interaction?.cta2fontsize ?? null,
      cta2colortext: interaction?.cta2colortext ?? null,
      cta2colorbackground: interaction?.cta2colorbackground ?? null,
      ctashadow: interaction?.ctashadow ?? "none",
      cta2shadow: interaction?.cta2shadow ?? "none",
      ctapictureheight: interaction?.ctapictureheight ?? null,
      ctapicturewidth: interaction?.ctapicturewidth ?? null,
      cta2pictureheight: interaction?.cta2pictureheight ?? null,
      cta2picturewidth: interaction?.cta2picturewidth ?? null,
      ctaposition: interaction?.ctaposition ?? "custom",
      cta2position: interaction?.cta2position ?? "custom",
      applysamectastyle: interaction?.applysamectastyle ?? true,
      teams: {
        backgrColorImage: interaction.teams?.backgrColorImage ?? null,
        backgroundColor: interaction.teams?.backgroundColor ?? null,
        backgroundImage: interaction.teams?.backgroundImage ?? null,
        backgroundImageOriginal: interaction.teams?.backgroundImageOriginal ?? null,
        horizontalAlignment: interaction.teams?.horizontalAlignment ?? null,
        image1HorizontalAlignment: interaction.teams?.image1HorizontalAlignment ?? null,
        image2HorizontalAlignment: interaction.teams?.image2HorizontalAlignment ?? null,
        imageHeight: interaction.teams?.imageHeight ?? null,
        imageWidth: interaction.teams?.imageWidth ?? null,
        image1: interaction.teams?.image1 ?? null,
        image1Original: interaction.teams?.image1Original ?? null,
        image1Width: interaction.teams?.image1Width ?? null,
        image1Height: interaction.teams?.image1Height ?? null,
        image2: interaction.teams?.image2 ?? null,
        image2Original: interaction.teams?.image2Original ?? null,
        image2Width: interaction.teams?.image2Width ?? null,
        image2Height: interaction.teams?.image2Height ?? null,
        mainImage: interaction.teams?.mainImage ?? null,
        mainImageOriginal: interaction.teams?.mainImageOriginal ?? null,
        semanticTemplateId: interaction.teams?.semanticTemplateId
          ? interaction.teams.semanticTemplateId
          : "crd-1c51bc52-ea39-41cf-beba-3dfb44f84744",
        size: interaction.teams?.size ?? null,
        image1Size: interaction.teams?.image1Size ?? null,
        image2Size: interaction.teams?.image2Size ?? null,
        templateFamilyId: interaction?.teams?.templateFamilyId
          ? interaction.teams.templateFamilyId
          : "fam-038da0d7-6481-4368-b1f4-a692e34929d2",
        textColor: interaction.teams?.textColor ?? "Default",
        textSize: interaction.teams?.textSize ?? "Default",
        titleColor: interaction.teams?.titleColor ?? "Default",
        titleSize: interaction.teams?.titleSize ?? "Default",
        ctaHorizontalAlignment: interaction.teams?.ctaHorizontalAlignment ?? "left",
        backgroundVerticalAlignment: interaction.teams?.backgroundVerticalAlignment ?? null,
      },
      tipgroup: interaction?.tipgroup ?? null,
      titleForPowerBI: interaction.titleForPowerBI || "",
      dropdownData: interaction.dropdownData || [
        {
          id: "placeholder",
          label: "Placeholder",
          value: "placeholder",
        },
        {
          id: "option1",
          label: "Option 1",
          value: "option1",
        },
      ],
      relation: flowRelationsByFlowId[interaction.flowId]?.[0] ?? null,
      relations: savedRelations ?? [
        // Scheduled-slot relations
        ...(flowRelationsByFlowId[interaction.flowId] || []).map(
          ({ relationId, type }) => ({
            relationId,
            type,
          })
        ),
        // Day slot relations
        ...Object.values(daySlotsByDayId || {})
          .flatMap((slots) => slots || [])
          .filter((slot) => slot.flowId === interaction.flowId)
          .map((slot) => ({
            relationId: slot.id,
            type: "daySlot",
          })),
      ],
    },
    validationSchema: validationSchema(interaction, journey?.days?.length),
    onSubmit: async ({ relation, relations, ...values }, { resetForm, setFieldValue }) => {
      if (values.tipgroup === null) {
        delete values.tipgroup;
      }
      if (values.callRelatedCustomization === false) {
        values.callBehaviour = null;
        values.afterCallDelay = null;
      }
      // For Teams View
      if (values.viewType === "teams_app") {
        if (values.teams?.backgroundColor && !values?.teams?.backgroundImage) {
          const imageUrl = generateImage(values.teams.backgroundColor);
          values.teams.backgrColorImage = imageUrl;
        }
        if (!values.teams?.backgroundColor) {
          values.teams.backgrColorImage = null;
        }
        if (values.teams.mainImage) {
          const { width, height } = await fetchImageDimensions("mainImage");
          values.teams.imageWidth = width;
          values.teams.imageHeight = height;
        }
        if (values.teams.image1) {
          const { width, height } = await fetchImageDimensions("image1");
          values.teams.image1Width = width;
          values.teams.image1Height = height;
        }
        if (values.teams.image2) {
          const { width, height } = await fetchImageDimensions("image2");
          values.teams.image2Width = width;
          values.teams.image2Height = height;
        }
      }
      // ==== START TODO: improve this; use yup etc.
      if (values.templateColors) {
        values.templateColors = removeEmpty(values.templateColors);
        const reg = /^#([0-9a-f]{3}){1,2}$/i; // hex colors
        Object.keys(values.templateColors).forEach((k) => {
          if (values.templateColors[k] && !reg.test(values.templateColors[k])) {
            window.alert(`Invalid Hex Color code ${k}; please correct asap`);
          }
        });
        // overwrite with color1 and color2, in case empty; feature removed in task-variousimprovements..
        // if (!values.templateColors?.color2cta && values.templateColors.color1) {
        //   values.templateColors.color2cta = values.templateColors.color1;
        // }
        // if (!values.templateColors?.color1cta && values.templateColors.color2) {
        //   values.templateColors.color1cta = values.templateColors.color2;
        // }
      }

      // If "#" and nothing else, transparent color
      if (values.templateColors.color4 === "#")
        values.templateColors.color4 = "#00000000";

      // If empty, use the default color (commented here, because we rely on the templating engine applying the default color)
      // if (values.templateColors.color4 === undefined)
      //   values.templateColors.color4 = "#B9B9B9";

      // Nullify userStatePath for CTA/DOUBLE_CTA only when saveUserStatePathCTA is off.
      // When saveUserStatePathCTA is on, keep userStatePath/userPathValueCta1/userPathValueCta2 for persistence.
      if (!values.saveUserStatePathCTA && values.ctaType !== "DROPDOWN" && values.userStatePath) {
        values.userStatePath = null;
        // Note: if you want to store data also with button click (not dropdown):
        // add cta1Value and/or cta2Value and userStatePath and change this part to avoid setting userStatePath to null in those cases
      }

      if (values.templateFonts) {
        values.templateFonts = removeEmpty(values.templateFonts);
        const reg = /[0-9]*px/i; // font-size values
        Object.keys(values.templateFonts)
          .filter((el) => el.endsWith("fontsize"))
          .forEach((k) => {
            if (values.templateFonts[k] && !reg.test(values.templateFonts[k])) {
              window.alert(
                `Invalid font size value ${k}; please correct asap (use px) `
              );
            }
          });
      }

      if (values.extras) {
        values.extras = removeEmpty(values.extras);
        const reg = /[0-9]*px/i; // extras values
        Object.keys(values.extras)
          .filter((el) => el.endsWith("width") || el.endsWith("height") || el.endsWith("top") || el.endsWith("left") || el.endsWith("right"))
          .forEach((k) => {
            if (values.extras[k] && !reg.test(values.extras[k])) {
              window.alert(`Invalid extra value ${k}; please correct asap (use px) `);
            }
          });
      }

      if (values.semanticPreview) {
        values.semanticPreview = removeEmpty(values.semanticPreview);
        const reg = /[0-9]*px/i; // font-size values
        Object.keys(values.semanticPreview)
          .filter((el) => el.endsWith("fontsize"))
          .forEach((k) => {
            if (
              values.semanticPreview[k] &&
              !reg.test(values.semanticPreview[k])
            ) {
              window.alert(
                `Invalid font size value ${k}; please correct asap (use px) `
              );
            }
          });
      }
      // ==== END TODO: improve this; use yup etc.

      if (values.isNew && values.type === "NUDGE") {
        // IMPORTANT NOTE: if you change defaults here, change also in copySemanticFlowLambda
        if (
          !triggerConfigs.find(
            ({ stimulusId }) => stimulusId === formik.values.stimulusId
          )
        ) {
          await updateTriggerConfig({
            journeyId,
            stimulusId: formik.values.stimulusId,
            tiers: [
              {
                from: 1,
                maxDailyOccurrences: 1,
                minOccurrencesInterval: 30,
                maxMonthlyOccurrences: undefined,
                maxWeeklyOccurrences: undefined,
                extendGlobalRulesToTips: false,
                dontShowNudges: false,
              },
            ],
            postJourneyTier: {
              maxDailyOccurrences: 6,
              minOccurrencesInterval: 60,
              maxMonthlyOccurrences: undefined,
              maxWeeklyOccurrences: undefined,
              extendGlobalRulesToTips: false,
              dontShowNudges: true,
            },
          });
        }

        const firstGroup = groups[values.stimulusId]?.[0];
        const group = firstGroup
          ? {
              flows: [
                { id: values.flowId, isPublished: true },
                ...firstGroup.flows,
              ],
              id: firstGroup.id,
            }
          : {
              flows: [{ id: values.flowId, isPublished: true }],
              inPastDaysNumber: 1,
              isNew: true,
              isTakeAll: true,
              journeyId,
              order: 1,
              stimulusId: values.stimulusId,
            };

        await updateJourneyGroup(group);
      }

      const allOldRelations = flowRelationsByFlowId[values.flowId] || [];
      const allNewRelations = relations || [];

      const oldScheduledRelations = allOldRelations.filter(
        ({ type }) => type === "scheduledSlot"
      );
      const newScheduledRelations = allNewRelations.filter(
        ({ type }) => type === "scheduledSlot"
      );

      const makeKey = ({ relationId, type }) => `${relationId}-${type}`;

      const oldByKey = new Map(
        oldScheduledRelations.map((rel) => [makeKey(rel), rel])
      );
      const newByKey = new Map(
        newScheduledRelations.map((rel) => [makeKey(rel), rel])
      );

      // Deleting removed scheduled-slot relations
      for (const [key, oldRel] of oldByKey.entries()) {
        if (!newByKey.has(key)) {
          await deleteFlowRelation(oldRel);
        }
      }

      // Creating newly added scheduled-slot relations
      for (const [key, newRel] of newByKey.entries()) {
        if (!oldByKey.has(key)) {
          await createFlowRelation({
            ...newRel,
            flowId: values.flowId,
            journeyId,
          });
        }
      }

      const allDaySlots = Object.values(daySlotsByDayId || {}).flatMap(
        (slots) => slots || []
      );

      const oldDaySlotIds = allDaySlots
        .filter((slot) => slot.flowId === values.flowId)
        .map((slot) => slot.id);

      const newDaySlotIds = allNewRelations
        .filter((rel) => rel.type === "daySlot")
        .map((rel) => rel.relationId);

      const oldDaySlotIdSet = new Set(oldDaySlotIds);
      const newDaySlotIdSet = new Set(newDaySlotIds);

      // Unlinking removed day slots
      for (const id of oldDaySlotIds) {
        if (!newDaySlotIdSet.has(id)) {
          await unlinkJourneyFlowToDaySlot({ journeyId, daySlotId: id });
        }
      }

      // Linking newly added day slots
      for (const id of newDaySlotIds) {
        if (!oldDaySlotIdSet.has(id)) {
          await linkJourneyFlowToDaySlot({
            journeyId,
            daySlotId: id,
            flowId: values.flowId,
          });
        }
      }

      if (
        values?.viewType === "client" &&
        values?.templateFamilyId === WHITEBOARD_FAMILY_ID &&
        values?.images?.bg2
      ) {
        await applyWhiteBoardCardDimensions({
          requestedHeight: values.cardheight,
          imageUrl: values.images.bg2,
        });
        values.cardheight = formikMethodsRef.current.values?.cardheight ?? values.cardheight;
        values.cardwidth = formikMethodsRef.current.values?.cardwidth ?? values.cardwidth;
      }
      if (
        values?.viewType === "client" &&
        values?.templateFamilyId === WHITEBOARD_FAMILY_ID &&
        values?.images?.cta
      ) {
        await applyWhiteBoardCtaPictureDimensions({
          requestedHeight: values.ctapictureheight,
          imageUrl: values.images.cta,
        });
        values.ctapictureheight =
          formikMethodsRef.current.values?.ctapictureheight ?? values.ctapictureheight;
        values.ctapicturewidth =
          formikMethodsRef.current.values?.ctapicturewidth ?? values.ctapicturewidth;
      }
      if (
        values?.viewType === "client" &&
        values?.templateFamilyId === WHITEBOARD_FAMILY_ID &&
        values?.ctaType === "DOUBLE_CTA" &&
        values?.images?.cta2
      ) {
        await applyWhiteBoardCta2PictureDimensions({
          requestedHeight: values.cta2pictureheight,
          imageUrl: values.images.cta2,
        });
        values.cta2pictureheight =
          formikMethodsRef.current.values?.cta2pictureheight ?? values.cta2pictureheight;
        values.cta2picturewidth =
          formikMethodsRef.current.values?.cta2picturewidth ?? values.cta2picturewidth;
      }

      await updateJourneySemantic(values, { optimisticUpdates: false });
      await getJourneyDaySlots({ journeyId });
      setSavedRelations(relations);
      await resetForm();
      setFieldValue("relations", relations, false);

      if (values.isNew) {
        history.replace({ ...location, state: null });
      }
    },
    validator: () => ({}),
  });

  // Store formik methods in ref for stable callback references
  // Formik's setFieldValue and setFieldTouched are stable, but we use a ref
  // to avoid dependency issues in useCallback
  const formikMethodsRef = useRef({
    setFieldValue: formik.setFieldValue,
    setFieldTouched: formik.setFieldTouched,
    values: formik.values,
  });

  // Update ref to always have latest methods (they're stable but this ensures correctness)
  formikMethodsRef.current.setFieldValue = formik.setFieldValue;
  formikMethodsRef.current.setFieldTouched = formik.setFieldTouched;
  formikMethodsRef.current.values = formik.values;

  // Store last valid aspect ratios for each image field pair to preserve aspect ratio
  // when user temporarily clears a field (e.g., deletes number leaving only "px")
  const lastValidAspectRatiosRef = useRef({});
  const whiteBoardAutoHeightModeRef = useRef(false);
  const whiteBoardAutoCtaHeightModeRef = useRef(false);
  const whiteBoardAutoCta2HeightModeRef = useRef(false);

  const calculateImageDimensions = (
    imagename,
    width,
    height,
    originalWidth,
    originalHeight
  ) => {
    const numericWidthValue = width ? parseInt(width.replace("px", "")) : null;
    const numericHeightValue = height
      ? parseInt(height.replace("px", ""))
      : null;
    const aspectRatio = originalWidth / originalHeight;

    const horizontalAlignmentFieldName = imagename === "mainImage" ? "horizontalAlignment" : `${imagename}HorizontalAlignment`;
    const sizeFieldName = imagename === "mainImage" ? "size" : `${imagename}Size`;
    if (numericWidthValue < originalWidth) {
      /*
      formik.setFieldValue("teams.horizontalAlignment", "center")
      formik.setFieldTouched("teams.horizontalAlignment", true);
      formik.setFieldValue("teams.size", null)
      formik.setFieldTouched("teams.size", true);
      */
      formik.values.teams[horizontalAlignmentFieldName] = "center";
      formik.values.teams[sizeFieldName] = null;
    } else if (numericWidthValue > originalWidth) {
      formik.values.teams[horizontalAlignmentFieldName] = null;
      formik.values.teams[sizeFieldName] = "stretch";
    }

    const pattern = /^\d+px$/;

    if ((width && !pattern.test(width)) || (height && !pattern.test(height))) {
      enqueueSnackbar("Invalid Image Size Input", {
        variant: "error",
      });
    }
    if (numericWidthValue && !numericHeightValue && !isNaN(aspectRatio)) {
      return {
        height: `${Math.round(numericWidthValue / aspectRatio)}px`,
        width: `${numericWidthValue}px`,
      };
    } else if (
      !numericWidthValue &&
      numericHeightValue &&
      !isNaN(aspectRatio)
    ) {
      return {
        height: `${numericHeightValue}px`,
        width: `${Math.round(numericHeightValue * aspectRatio)}px`,
      };
    } else if (numericWidthValue && numericHeightValue) {
      return {
        height: `${numericHeightValue}px`,
        width: `${numericWidthValue}px`,
      };
    } else {
      return {
        height: "180px",
        width: `${Math.round(180 * aspectRatio)}px`,
      };
    }
  };

  const fetchImageDimensions = async (imagename) => {
    let imageUrl;
    if (formik.values.teams[imagename]) {
      imageUrl = formik.values.teams[imagename];

      try {
        const img = new Image();
        img.src = imageUrl;
        await img.decode();

        const imageWidthFieldName = imagename === "mainImage" ? "imageWidth" : `${imagename}Width`;
        const imageHeightFieldName = imagename === "mainImage" ? "imageHeight" : `${imagename}Height`;
        const { width, height } = calculateImageDimensions(
          imagename,
          formik.values.teams[imageWidthFieldName],
          formik.values.teams[imageHeightFieldName],
          img.width,
          img.height
        );
        return { height, width };
      } catch (error) {
        console.error("Error fetching image dimensions:", error);
        return { height: null, width: null };
      }
    }
  };

  const generateImage = (color) => {
    // fillMode to cover
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = 10;
    canvas.height = 10;

    context.fillStyle = color;
    context.fillRect(0, 0, canvas.width, canvas.height);

    const imageURL = canvas.toDataURL();
    return imageURL;

    //console.log('Generated Image URL:', imageURL);
  };

  const lockedViewType = useMemo(
    () => getLockedViewTypeForChannelValidity(formik.values.channelValidity),
    [formik.values.channelValidity]
  );

  useEffect(() => {
    if (lockedViewType && formik.values.viewType !== lockedViewType) {
      formik.setFieldValue("viewType", lockedViewType);
    }
  }, [lockedViewType, formik.values.viewType, formik.setFieldValue]);

  useEffect(() => {
    const newValue = formik.values.viewType;
    setLocalViewType(newValue);
  }, [formik.values.viewType, setLocalViewType]);

  useEffect(() => {
    const newValue = formik.values.templateFamilyId;
    setSelectedTemplate(newValue);
  }, [formik.values.templateFamilyId]);

  useEffect(() => {
    const newValue = formik.values.templateFamilyId;
    setSelectedTemplate(newValue);
  }, [formik.values.templateFamilyId]);

  useEffect(() => {
    const defaultDropdownData = [
      {
        id: "placeholder",
        label: "Placeholder",
        value: "placeholder",
      },
      {
        id: "option1",
        label: "Option 1",
        value: "option1",
      },
    ];
    if (aiResult) {
      // This approach only works by deleting the values set for text and title
      // However does not work as expected and causes an issue while typing on the markdown editor

      /* formik.setFieldValue("title", aiResult.title);
      formik.setFieldTouched("title", true);
      formik.setFieldValue("text",   aiResult.text);
      formik.setFieldTouched("text", true); */

      if (aiResult.outputType !== "dropdown") {
        formik.setFieldValue("dropdownData", defaultDropdownData);
        formik.setFieldTouched("dropdownData", true);
      }
      if (aiResult.outputType === "dropdown") {
        const dropdownData = [
          {
            id: "label",
            label: aiResult.placeholder,
            value: aiResult.placeholder,
          },

          ...aiResult.answers.map((answer, index) => ({
            id: `option${index + 1}`,
            label: answer || `Option ${index + 1}`,
            value: index + 1 || `option${index + 1}`,
          })),
        ];
        formik.setFieldValue("cta1Text", aiResult.button);
        formik.setFieldTouched("cta1Text", true);
        formik.setFieldValue("dropdownData", dropdownData);
        formik.setFieldTouched("dropdownData", true);
        formik.setFieldValue("ctaType", "DROPDOWN");
        formik.setFieldTouched("ctaType", true);
      } else if (aiResult.outputType === "singleCTA") {
        formik.setFieldValue("cta1Text", aiResult.answers[0]);
        formik.setFieldTouched("cta1Text", true);
        formik.setFieldValue("ctaType", "CTA");
        formik.setFieldTouched("ctaType", true);
      } else if (aiResult.outputType === "doubleCTA") {
        formik.setFieldValue("cta1Text", aiResult.answers[0]);
        formik.setFieldTouched("cta1Text", true);
        formik.setFieldValue("cta2Text", aiResult.answers[1]);
        formik.setFieldTouched("cta2Text", true);
        formik.setFieldValue("ctaType", "DOUBLE_CTA");
        formik.setFieldTouched("ctaType", true);
      }
    }
  }, [aiResult]);

  const interactionIndex = useMemo(
    () => interactions.findIndex((item) => item.id === interaction.id),
    [interactions, interaction]
  );

  const trigger = useMemo(
    () =>
      triggers.find(({ stimulusId }) => stimulusId === interaction.stimulusId),
    [interaction.stimulusId, triggers]
  );

  const contentTypeConfig = useMemo(
    () => trigger && contentTypesConfig[trigger.contentType],
    [trigger]
  );

  const handleTypeChange = useCallback(
    (e, newType) => {
      if (!newType) {
        return;
      }
      formik.setFieldValue("ctaType", newType);
      formik.setFieldTouched("ctaType", true);
    },
    [formik]
  );

  const isDisabled = props.isDisabled || formik.isSubmitting;

  useEffect(() => {
    if (
      [
        formik.values.cta1Type,
        formik.values.cta2Type,
        ...formik.values.dropdownData.map(({ ctaType }) => ctaType),
      ].some((ctaType) => ctaType === "Dashboard Material")
    ) {
      fetchMaterials({ journeyId, locale });
    }

    if (
      [
        formik.values.cta1Type,
        formik.values.cta2Type,
        ...formik.values.dropdownData.map(({ ctaType }) => ctaType),
      ].some((ctaType) => ctaType === "Special Link")
    ) {
      fetchSpecialLinks();
    }

    if (
      !surveys.length &&
      (formik.values?.cta1Type === "Survey" ||
        formik.values?.cta2Type === "Survey" ||
        (formik.values.ctaType === "DROPDOWN" &&
          formik.values.dropdownData.length &&
          formik.values.dropdownData.some(
            ({ ctaType }) => ctaType === "Survey"
          )))
    ) {
      fetchSurveys({ journeyId });
    }

    if (
      !tools.length &&
      (formik.values?.cta1Type === "Prompt Tool" ||
        formik.values?.cta2Type === "Prompt Tool")
    ) {
      fetchTools();
    }
    if (
      !prompts.length &&
      (formik.values?.cta1Type === "Prompt" ||
        formik.values?.cta2Type === "Prompt")
    ) {
      fetchPrompts();
    }
    if (
      !seeds.length &&
      (formik.values?.cta1Type === "Bloom Seed" ||
        formik.values?.cta2Type === "Bloom Seed")
    ) {
      fetchPrompts("allitude");
    }
    if (
      !aiSkillingPrompts.length &&
      (formik.values?.cta1Type === "AI Skilling Prompt" ||
        formik.values?.cta2Type === "AI Skilling Prompt")
    ) {
      fetchPrompts("aiskilling");
    }
    if (
      !cyberTipsCdpPrompts.length &&
      (formik.values?.cta1Type === "Cyber Tip" ||
        formik.values?.cta2Type === "Cyber Tip" ||
        formik.values.dropdownData?.some(
          ({ ctaType }) => ctaType === "Cyber Tip"
        ))
    ) {
      fetchPrompts("cyber-tips-cdp");
    }
    if (
      [
        formik.values.cta1Type,
        formik.values.cta2Type,
        ...formik.values.dropdownData.map(({ ctaType }) => ctaType),
      ].some((ctaType) => ctaType === "News")
    ) {
      fetchJourneyNews({ journey_id: journeyId });
    }
    if (
      [
        formik.values.cta1Type,
        formik.values.cta2Type,
        ...formik.values.dropdownData.map(({ ctaType }) => ctaType),
      ].some((ctaType) => ctaType === "NewsPage")
    ) {
      fetchCopilotNews();
    }
    if (
      [
        formik.values.cta1Type,
        formik.values.cta2Type,
        ...formik.values.dropdownData.map(({ ctaType }) => ctaType),
      ].some((ctaType) => ctaType === "Welfare")
    ) {
      fetchJourneyBenefits({ journey_id: journeyId });
    }
  }, [
    journeyId,
    fetchCopilotNews,
    formik.values.dropdownData,
    formik.values.cta1Type,
    formik.values.cta2Type,
    locale,
  ]);

  useEffect(() => {
    const isDropdownCta = formik.values.ctaType === "DROPDOWN";
    const isSingleOrDoubleWithSaveResult =
      (formik.values.ctaType === "CTA" ||
        formik.values.ctaType === "DOUBLE_CTA") &&
      formik.values.saveUserStatePathCTA;

    if (!isDropdownCta && !isSingleOrDoubleWithSaveResult) {
      return;
    }

    fetchUserStatePaths();
  }, [
    formik.values.ctaType,
    formik.values.saveUserStatePathCTA,
    fetchUserStatePaths,
  ]);

  // Create a families whitelist
  const WHITEBOARD_FAMILY_ID = "fam-2f38b747-2a5d-4f6c-a0b2-2cb5673cd6ea";

  const familiesWhitelist = {
    [SNAM_COMPANY_ID]: {
      "client": [
        "fam-e0de01b3-ebf9-4bbe-b60f-838eea38bc76", // Family easyPop
      ],
      "teams_app": [
        "fam-dc423757-effc-4510-ac5a-9c9f4c9ec268", // Family easyPop
      ]
    },
    "default": {
      "client": [
        "fam-0a44232d-c114-4898-8108-3441516c93bf", // Family1
        "fam-6fae4cea-82c4-4f2f-89c8-a04973c7fbfa", // Legacy
        "fam-4ce490f9-30c2-4f85-8ca7-251101203fc6", // Family2
      ],
      "teams_app": [
        "fam-038da0d7-6481-4368-b1f4-a692e34929d2", // Family 1 Teams
        "fam-44197fb8-7a0b-4079-a76f-25210e68db4e", // Family 2 Teams
      ]
    },
    [CDP_COMPANY_ID]: {
      client: [
        "fam-0a44232d-c114-4898-8108-3441516c93bf", // Family1
        "fam-6fae4cea-82c4-4f2f-89c8-a04973c7fbfa", // Legacy
        "fam-4ce490f9-30c2-4f85-8ca7-251101203fc6", // Family2
        WHITEBOARD_FAMILY_ID,
      ],
      teams_app: [
        "fam-038da0d7-6481-4368-b1f4-a692e34929d2", // Family 1 Teams
        "fam-44197fb8-7a0b-4079-a76f-25210e68db4e", // Family 2 Teams
      ],
    },
    [DA_COMPANY_ID]: {
      client: [
        WHITEBOARD_FAMILY_ID
      ],
      teams_app: [],
    },
  };
  const familiesBlacklist = {
    [SNAM_COMPANY_ID]: {
      client: [WHITEBOARD_FAMILY_ID], // hide WhiteBoard for SNAM
      teams_app: [],
    },
    default: {
      client: [],
      teams_app: [],
    },
  };
  const filteredTemplateFamilies = useMemo(() => {
    const currentTemplateFamilies = formik.values.viewType === "client" ? templateFamilies : teamsTemplateFamilies;

    const userCompanies = getUserCompanies(user);
    const companyBucket = isSnamOnlyUser(user)
      ? SNAM_COMPANY_ID
      : isCdpOnlyUser(user)
        ? CDP_COMPANY_ID
        : "default";

    if (userCompanies.includes(DA_COMPANY_ID)) {
      return currentTemplateFamilies;
    }

    const allowedFamilyIds =
      familiesWhitelist[companyBucket]?.[formik.values.viewType] || [];
    const deniedFamilyIds =
      familiesBlacklist[companyBucket]?.[formik.values.viewType] || [];

    return currentTemplateFamilies
      .filter((fam) => allowedFamilyIds.includes(fam.tFamilyId))
      .filter((fam) => !deniedFamilyIds.includes(fam.tFamilyId));
  }, [formik.values.viewType, templateFamilies, teamsTemplateFamilies, user?.companies]);

  const nudgeSpecialConditionTypes = useMemo(() => {
    if (!isCdpOnlyUser(user)) {
      return SPECIAL_CONDITION_TYPES;
    }
    return CDP_SPECIAL_CONDITION_TYPES;
  }, [user]);

  const semanticTemplateCatalogue = useMemo(() => {
    return (
      filteredTemplateFamilies.filter(
        (f) => f.tFamilyId === formik.values.templateFamilyId
      )[0]?.semanticTemplateCatalogue ?? []
    );
  }, [filteredTemplateFamilies, formik.values.templateFamilyId]);

  const teamsSemanticTemplateCatalogue = useMemo(() => {
    return (
      filteredTemplateFamilies.filter(
        (f) => f.tFamilyId === formik.values.teams.templateFamilyId
      )[0]?.semanticTemplateCatalogue ?? []
    );
  }, [filteredTemplateFamilies, formik.values.teams.templateFamilyId]);

  const currentSemanticTemplate = useMemo(() => {
    if(formik.values.viewType === "client") {
      return semanticTemplates?.find(
        (t) => t.templateId === formik.values.semanticTemplateId
      ) || semanticTemplates?.[0] || null;
    } else {
      return teamsSemanticTemplates?.find(
        (t) => t.templateId === formik.values.teams.semanticTemplateId
      ) || teamsSemanticTemplates?.[0] || null;
    }
  }, [formik.values.viewType, formik.values.semanticTemplateId, formik.values.teams.semanticTemplateId, semanticTemplates, teamsSemanticTemplates]);

  const isWhiteBoardFamily =
    formik.values.viewType === "client" &&
    formik.values.templateFamilyId === WHITEBOARD_FAMILY_ID;
  const whiteBoardCtaShadowEnabledValue =
    currentSemanticTemplate?.userCustomizable?.ctashadow?.enabledValue ||
    "0 2px 8px 0 rgba(0, 0, 0, 0.20)";
  /*const animationTemplates = useMemo(() => {
    return loadAnimationTemplates();
  }, []);*/

  /*useEffect(() => {
    if (formik.values.animationId && animationTemplates?.[formik.values.animationId && currentSemanticTemplate?.userCustomizable?.disableAnimationPropertiesFields?.default]) {
      const template = animationTemplates[formik.values.animationId];
      formik.setFieldValue('cssAnimationStartDelay', template.lottieProperties?.cssAnimationStartDelay ?? null);
      formik.setFieldValue('animationLoop', template.lottieProperties?.loop ?? false);
      formik.setFieldValue('animationPlayReverse', template.lottieProperties?.direction ?? false);
    }
  }, [formik.values.animationId]);*/

  // Load default values for extra values client and teams_app
  useEffect(() => {
    if((formik.values.viewType === "client" && interaction?.semanticTemplateId === currentSemanticTemplate?.templateId) || (formik.values.viewType === "teams_app" && interaction?.teams?.semanticTemplateId === currentSemanticTemplate?.templateId)) {
      return;
    }

   // Load default values with overwriteField
   if(formik.values.viewType === "client") {
    if(currentSemanticTemplate?.userCustomizable?.image1width?.overwriteField && currentSemanticTemplate?.userCustomizable?.image1width?.default !== formik.values?.image1width) {
      formik.setFieldValue("image1width", currentSemanticTemplate?.userCustomizable?.image1width?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image1height?.overwriteField && currentSemanticTemplate?.userCustomizable?.image1height?.default !== formik.values?.image1height) {
      formik.setFieldValue("image1height", currentSemanticTemplate?.userCustomizable?.image1height?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image1top?.overwriteField && currentSemanticTemplate?.userCustomizable?.image1top?.default !== formik.values?.image1top) {
      formik.setFieldValue("image1top", currentSemanticTemplate?.userCustomizable?.image1top?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image1left?.overwriteField && currentSemanticTemplate?.userCustomizable?.image1left?.default !== formik.values?.image1left) {
      formik.setFieldValue("image1left", currentSemanticTemplate?.userCustomizable?.image1left?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image2width?.overwriteField && currentSemanticTemplate?.userCustomizable?.image2width?.default !== formik.values?.image2width) {
      formik.setFieldValue("image2width", currentSemanticTemplate?.userCustomizable?.image2width?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image2height?.overwriteField && currentSemanticTemplate?.userCustomizable?.image2height?.default !== formik.values?.image2height) {
      formik.setFieldValue("image2height", currentSemanticTemplate?.userCustomizable?.image2height?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image2top?.overwriteField && currentSemanticTemplate?.userCustomizable?.image2top?.default !== formik.values?.image2top) {
      formik.setFieldValue("image2top", currentSemanticTemplate?.userCustomizable?.image2top?.default ?? null);
    }
    if(currentSemanticTemplate?.userCustomizable?.image2left?.overwriteField && currentSemanticTemplate?.userCustomizable?.image2left?.default !== formik.values?.image2left) {
      formik.setFieldValue("image2left", currentSemanticTemplate?.userCustomizable?.image2left?.default ?? null);
    }

    // Also reset animation properties if disableAnimationPropertiesFields is true
    const defaultAnimationId = currentSemanticTemplate?.userCustomizable?.animation?.default ?? null;
    if(currentSemanticTemplate?.userCustomizable?.disableAnimationPropertiesFields?.default && formik.values?.animationId !== defaultAnimationId) {
      formik.setFieldValue("animationId", defaultAnimationId);
      formik.setFieldValue("animationLoop", null);
      formik.setFieldValue("animationPlayReverse", null);
      formik.setFieldValue("animationSpeed", null);
      formik.setFieldValue("animationColor", null);
      formik.setFieldValue("cssAnimationStartDelay", null);
    }
   }

   if(formik.values.viewType === "client" && currentSemanticTemplate?.userCustomizable?.images?.image1?.disabled) {
      formik.setFieldValue("images.image1", null);
   } else if(formik.values.viewType === "teams_app" && currentSemanticTemplate?.userCustomizable?.image1?.disabled) {
    formik.setFieldValue("teams.image1", null);
   }

   if(formik.values.viewType === "client" && currentSemanticTemplate?.userCustomizable?.images?.image2?.disabled) {
    formik.setFieldValue("images.image2", null);
   } else if(formik.values.viewType === "teams_app" && currentSemanticTemplate?.userCustomizable?.image2?.disabled) {
    formik.setFieldValue("teams.image2", null);
   }

   if(formik.values.viewType === "client" && currentSemanticTemplate?.userCustomizable?.images?.image?.disabled) {
    formik.setFieldValue("imageId", null);
   } else if(formik.values.viewType === "teams_app" && currentSemanticTemplate?.userCustomizable?.mainImage?.disabled) {
    formik.setFieldValue("teams.mainImage", null);
   }

   if(formik.values.viewType === "client" && currentSemanticTemplate?.userCustomizable?.images?.bg1?.disabled) {
    formik.setFieldValue("images.bg1", null);
   } else if(formik.values.viewType === "teams_app" && currentSemanticTemplate?.userCustomizable?.backgroundImage?.disabled) {
    formik.setFieldValue("teams.backgroundImage", null);
   }

   if(formik.values.viewType === "client" && currentSemanticTemplate?.userCustomizable?.images?.bg2?.disabled) {
    formik.setFieldValue("images.bg2", null);
   }

    if(formik.values.viewType === "teams_app" && currentSemanticTemplate?.userCustomizable) {
      const extras = currentSemanticTemplate.userCustomizable;
      const currentTeams = formik.values.teams || {};
      const newTeams = { ...currentTeams };

      Object.entries(extras).forEach(([fieldKey, fieldConfig]) => {
        if(fieldConfig.overwriteField === true) {
          const newValue = fieldConfig.default ?? null;
          if(newTeams[fieldKey] !== newValue) {
            newTeams[fieldKey] = newValue;
          }
        }
      });

      if(JSON.stringify(newTeams) !== JSON.stringify(currentTeams)) {
        formik.setFieldValue("teams", newTeams);
      }
    }
  }, [currentSemanticTemplate, formik.values.viewType, interaction?.semanticTemplateId, interaction?.teams?.semanticTemplateId]);

  useEffect(() => {
    if(formik.values.viewType === "client" && semanticTemplateCatalogue.length > 0) {
      const currentTemplateId = formik.values.semanticTemplateId;
      const isTemplateValid = semanticTemplateCatalogue.find(template => template.templateId === currentTemplateId);
      if(!isTemplateValid) {
        formik.setFieldValue("semanticTemplateId", semanticTemplateCatalogue[0].templateId);
      }

      console.log("currentTemplate", currentTemplateId);
    }

    if(formik.values.viewType === "teams_app" && filteredTemplateFamilies.length > 0) {
      const currentTemplateFamilyId = formik.values.teams.templateFamilyId;
      const isTemplateFamilyValid = filteredTemplateFamilies.find(family => family.tFamilyId === currentTemplateFamilyId);
      if(!isTemplateFamilyValid) {
        formik.setFieldValue("teams.templateFamilyId", filteredTemplateFamilies[0].tFamilyId);
      }
    }
  }, [
    formik.values.viewType,
    formik.values.teams,
    filteredTemplateFamilies,
    semanticTemplateCatalogue
  ]);

  useEffect(() => {
    if(formik.values.viewType === "teams_app" && teamsSemanticTemplateCatalogue.length > 0) {
      const currentTemplateId = formik.values.teams.semanticTemplateId;
      const isTemplateValid = teamsSemanticTemplateCatalogue.find(template => template.templateId === currentTemplateId);
      if(!isTemplateValid) {
        formik.setFieldValue("teams.semanticTemplateId", teamsSemanticTemplateCatalogue[0].templateId);
      }
    }
  }, [
    formik.values.viewType,
    formik.values.teams.templateFamilyId,
    teamsSemanticTemplateCatalogue
  ]);

  //Feature removed in task Simplify UI of tip creation in content portal (24-01-2024)
  // const isSemanticPreviewFieldDisabled = useCallback(
  //   (fieldName) => {
  //     return (
  //       (semanticTemplateCatalogue && semanticTemplateCatalogue?.length) <= 0 ||
  //       !formik.values?.semanticPreview?.semanticPreviewTemplateId ||
  //       formik.values.semanticPreview.semanticPreviewTemplateId ===
  //         NO_PREVIEW_ID ||
  //       !semanticPreviewTemplates?.[0]?.allowedCustomization?.[fieldName]
  //     );
  //   },
  //   [
  //     semanticTemplateCatalogue,
  //     formik.values.semanticPreview.semanticPreviewTemplateId,
  //     semanticPreviewTemplates,
  //   ]
  // );

  // Feature removed in task Simplify UI of tip creation in content portal (24-01-2024)
  // const semanticPreviewTemplateCatalogue = useMemo(() => {
  //   const arr =
  //     semanticTemplates.filter(
  //       (t) => t.templateId === formik.values.semanticTemplateId
  //     )[0]?.semanticPreviewTemplateCatalogue ?? [];

  //   return arr;
  // }, [semanticTemplates, formik.values.semanticTemplateId]);

  const handleDropdownDataChange = useCallback(
    (i, name) => (e) => {
      const newValue = [...(formik.values.dropdownData || [])];
      newValue[i] = {
        id: i === 0 ? "placeholder" : `option_${i}`,
        label: "",
        value: "",
        ...newValue[i],
        [name]: (typeof e === "string" ? e : e?.target?.value) || "",
      };

      formik.setFieldValue("dropdownData", newValue);
      formik.setFieldTouched("dropdownData", true);
    },
    [formik]
  );

  const handleDropdownDataDelete = useCallback(
    (i) => () => {
      const newValue = [...formik.values.dropdownData];
      newValue.splice(i, 1);

      formik.setFieldValue("dropdownData", newValue);
      formik.setFieldTouched("dropdownData", true);
    },
    [formik]
  );

  const history = useHistory();

  useConfirmLeave();

  //setting property IMAGE IMAGE
  const handleImageChangeImageID = useCallback(
    ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("imageIdOriginal", url);
        formikMethodsRef.current.setFieldTouched("imageIdOriginal", true);
      }
      formikMethodsRef.current.setFieldValue("imageId", url);
      formikMethodsRef.current.setFieldTouched("imageId", true);
    },
    []
  );

  const handleImageChangeMainImage = useCallback(
    ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("mainImageOriginal", url);
        formikMethodsRef.current.setFieldTouched("mainImageOriginal", true);
      }
       // Get image dimensions
       const img = new Image();
       img.onload = () => {
         const width = img.naturalWidth;
         const height = img.naturalHeight;
         let newWidth = width;
         let newHeight = height;
         if (formikMethodsRef.current.values?.viewType === "teams_app"  && formikMethodsRef.current.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e") {
          if(width > 70) {
            const aspectRatio = width / height;
            newHeight = Math.round(70 / aspectRatio);
            newWidth = 70;
          }
          formikMethodsRef.current.setFieldValue("teams.imageHeight", `${newHeight}px`);
          formikMethodsRef.current.setFieldTouched("teams.imageHeight", true);
          formikMethodsRef.current.setFieldValue("teams.imageWidth", `${newWidth}px`);
           formikMethodsRef.current.setFieldTouched("teams.imageWidth", true);
           
           // Store the original aspect ratio based on the actual image dimensions
           // Note: width and height are swapped in the form values, so we calculate aspect ratio as height/width
           // (since imageWidth stores height and imageHeight stores width in the form)
           if (width > 0) {
             lastValidAspectRatiosRef.current["teams.image"] = newWidth / newHeight;
           }
         }
       };
       img.onerror = () => {
         console.error("Failed to load image:", url);
       };
       img.src = url;

      formikMethodsRef.current.setFieldValue("teams.mainImage", url);
      formikMethodsRef.current.setFieldTouched("teams.mainImage", true);
    },
    []
  );

  const handleImageChangeBG1 = useCallback(
    ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("images.bg1Original", url);
        formikMethodsRef.current.setFieldTouched("images.bg1Original", true);
      }
      formikMethodsRef.current.setFieldValue(`images.bg1`, url);
      formikMethodsRef.current.setFieldTouched(`images.bg1`, true);
    },
    []
  );

  const applyWhiteBoardCardDimensions = useCallback(
    async ({ requestedHeight, imageUrl }) => {
      const setCardDimensions = async ({ height, width }) => {
        await formikMethodsRef.current.setFieldValue("cardheight", height);
        await formikMethodsRef.current.setFieldValue("cardwidth", width);
        formikMethodsRef.current.setFieldTouched("cardheight", true);
        formikMethodsRef.current.setFieldTouched("cardwidth", true);
      };

      // Returning if no image is uploaded
      if (!imageUrl) {
        return;
      }
      const heightValue = parsePxToNumber(requestedHeight);
      let originalWidth;
      let originalHeight;

      // Loading original dimensions
      try {
        const originalSize = await loadImageOriginalSize(imageUrl);
        originalWidth = originalSize?.width;
        originalHeight = originalSize?.height;
      } catch (error) {
        console.error("Failed to get original image dimensions:", error);
        return;
      }

      if (!originalWidth || !originalHeight) {
        return;
      }

      // Using the original image dimensions when the height is not specified
      if (!heightValue) {
        await setCardDimensions({
          height: `${originalHeight}px`,
          width: `${originalWidth}px`,
        });
        console.info("[WhiteBoard] applied original dimensions (empty height)", {
          height: `${originalHeight}px`,
          width: `${originalWidth}px`,
        });
        return;
      }

      // precaution to avoid setting a height greater than 800px
      const boundedHeight = Math.min(heightValue, 800);
      await setCardDimensions({ height: `${boundedHeight}px`, width: null });

      // computing the width based on the original image proportions
      const ratio = boundedHeight / originalHeight;
      const computedWidth = Math.round(originalWidth * ratio);
      await setCardDimensions({
        height: `${boundedHeight}px`,
        width: `${computedWidth}px`,
      });
    },
    []
  );

  const applyWhiteBoardCtaPictureDimensions = useCallback(
    async ({ requestedHeight, imageUrl }) => {
      if (!imageUrl) {
        return;
      }
      const parsedHeight = parsePxToNumber(requestedHeight);
      let originalWidth;
      let originalHeight;
      try {
        const originalSize = await loadImageOriginalSize(imageUrl);
        originalWidth = originalSize?.width;
        originalHeight = originalSize?.height;
      } catch (error) {
        console.error("Failed to get CTA image dimensions:", error);
        return;
      }
      if (!originalWidth || !originalHeight) {
        return;
      }
      if (!parsedHeight) {
        await formikMethodsRef.current.setFieldValue(
          "ctapictureheight",
          `${originalHeight}px`
        );
        await formikMethodsRef.current.setFieldValue(
          "ctapicturewidth",
          `${originalWidth}px`
        );
        formikMethodsRef.current.setFieldTouched("ctapictureheight", true);
        formikMethodsRef.current.setFieldTouched("ctapicturewidth", true);
        return;
      }
      const boundedHeight = Math.min(parsedHeight, 800);
      const ratio = boundedHeight / originalHeight;
      const computedWidth = Math.round(originalWidth * ratio);
      await formikMethodsRef.current.setFieldValue(
        "ctapictureheight",
        `${boundedHeight}px`
      );
      await formikMethodsRef.current.setFieldValue(
        "ctapicturewidth",
        `${computedWidth}px`
      );
      formikMethodsRef.current.setFieldTouched("ctapictureheight", true);
      formikMethodsRef.current.setFieldTouched("ctapicturewidth", true);
    },
    []
  );

  const applyWhiteBoardCta2PictureDimensions = useCallback(
    async ({ requestedHeight, imageUrl }) => {
      if (!imageUrl) {
        return;
      }
      const parsedHeight = parsePxToNumber(requestedHeight);
      let originalWidth;
      let originalHeight;
      try {
        const originalSize = await loadImageOriginalSize(imageUrl);
        originalWidth = originalSize?.width;
        originalHeight = originalSize?.height;
      } catch (error) {
        console.error("Failed to get CTA 2 image dimensions:", error);
        return;
      }
      if (!originalWidth || !originalHeight) {
        return;
      }
      if (!parsedHeight) {
        await formikMethodsRef.current.setFieldValue(
          "cta2pictureheight",
          `${originalHeight}px`
        );
        await formikMethodsRef.current.setFieldValue(
          "cta2picturewidth",
          `${originalWidth}px`
        );
        formikMethodsRef.current.setFieldTouched("cta2pictureheight", true);
        formikMethodsRef.current.setFieldTouched("cta2picturewidth", true);
        return;
      }
      const boundedHeight = Math.min(parsedHeight, 800);
      const ratio = boundedHeight / originalHeight;
      const computedWidth = Math.round(originalWidth * ratio);
      await formikMethodsRef.current.setFieldValue(
        "cta2pictureheight",
        `${boundedHeight}px`
      );
      await formikMethodsRef.current.setFieldValue(
        "cta2picturewidth",
        `${computedWidth}px`
      );
      formikMethodsRef.current.setFieldTouched("cta2pictureheight", true);
      formikMethodsRef.current.setFieldTouched("cta2picturewidth", true);
    },
    []
  );

  const handleImageChangeBG2 = useCallback(
    async ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("images.bg2Original", url);
        formikMethodsRef.current.setFieldTouched("images.bg2Original", true);
      }
      formikMethodsRef.current.setFieldValue(`images.bg2`, url);
      formikMethodsRef.current.setFieldTouched(`images.bg2`, true);

      const values = formikMethodsRef.current.values;
      if (values?.viewType === "client" && values?.templateFamilyId === WHITEBOARD_FAMILY_ID) {
        // computing dimensions again when the image is changed
        whiteBoardAutoHeightModeRef.current = !parsePxToNumber(values.cardheight);
        await applyWhiteBoardCardDimensions({
          requestedHeight: values.cardheight,
          imageUrl: url,
        });
      }
    },
    [applyWhiteBoardCardDimensions, WHITEBOARD_FAMILY_ID]
  );

  const handleImageChangeCTA = useCallback(
    async ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("images.ctaOriginal", url);
        formikMethodsRef.current.setFieldTouched("images.ctaOriginal", true);
      }
      formikMethodsRef.current.setFieldValue("images.cta", url);
      formikMethodsRef.current.setFieldTouched("images.cta", true);
      const values = formikMethodsRef.current.values;
      if (values?.viewType === "client" && values?.templateFamilyId === WHITEBOARD_FAMILY_ID) {
        whiteBoardAutoCtaHeightModeRef.current = !parsePxToNumber(values.ctapictureheight);
        await applyWhiteBoardCtaPictureDimensions({
          requestedHeight: values.ctapictureheight,
          imageUrl: url,
        });
      }
    },
    [applyWhiteBoardCtaPictureDimensions, WHITEBOARD_FAMILY_ID]
  );

  const handleImageChangeCTA2 = useCallback(
    async ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("images.cta2Original", url);
        formikMethodsRef.current.setFieldTouched("images.cta2Original", true);
      }
      formikMethodsRef.current.setFieldValue("images.cta2", url);
      formikMethodsRef.current.setFieldTouched("images.cta2", true);
      const values = formikMethodsRef.current.values;
      if (values?.viewType === "client" && values?.templateFamilyId === WHITEBOARD_FAMILY_ID) {
        whiteBoardAutoCta2HeightModeRef.current = !parsePxToNumber(values.cta2pictureheight);
        await applyWhiteBoardCta2PictureDimensions({
          requestedHeight: values.cta2pictureheight,
          imageUrl: url,
        });
      }
    },
    [applyWhiteBoardCta2PictureDimensions, WHITEBOARD_FAMILY_ID]
  );

  const handleImageChangeBackgroundImage = useCallback(
    ({ url, source }) => {
      if (source !== "crop") {
        formikMethodsRef.current.setFieldValue("teams.backgroundImageOriginal", url);
        formikMethodsRef.current.setFieldTouched("teams.backgroundImageOriginal", true);
      }
      formikMethodsRef.current.setFieldValue(`teams.backgroundImage`, url);
      formikMethodsRef.current.setFieldTouched(`teams.backgroundImage`, true);
    },
    []
  );

  const handleImageResetImageID = useCallback(() => {
    formikMethodsRef.current.setFieldValue("imageIdOriginal", null);
    formikMethodsRef.current.setFieldTouched("imageIdOriginal", true);
    formikMethodsRef.current.setFieldValue("imageId", "");
    formikMethodsRef.current.setFieldTouched("imageId", true);
  }, []);

  const handleImageResetMainImage = useCallback(() => {
    formikMethodsRef.current.setFieldValue("teams.mainImageOriginal", null);
    formikMethodsRef.current.setFieldTouched("teams.mainImageOriginal", true);
    formikMethodsRef.current.setFieldValue("teams.mainImage", "");
    formikMethodsRef.current.setFieldTouched("teams.mainImage", true);
  }, []);

  const handleImageChangeImage1 = useCallback(
    ({ url, source }) => {
      // Get image dimensions
      const img = new Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        let newWidth = width;
        let newHeight = height;
        
        if (formikMethodsRef.current.values?.viewType === "teams_app"  && formikMethodsRef.current.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e") {
          
          if(width > 70) {
            const aspectRatio = width / height;
            newWidth = 70;
            newHeight = Math.round(70 / aspectRatio);
          }
          formikMethodsRef.current.setFieldValue("teams.image1Width", `${newWidth}px`);
          formikMethodsRef.current.setFieldTouched("teams.image1Width", true);
          formikMethodsRef.current.setFieldValue("teams.image1Height", `${newHeight}px`);
          formikMethodsRef.current.setFieldTouched("teams.image1Height", true);
          
          // Store the original aspect ratio based on the actual image dimensions
          if (height > 0) {
            lastValidAspectRatiosRef.current["teams.image1"] = newWidth / newHeight;
          }
        }
      };
      img.onerror = () => {
        console.error("Failed to load image:", url);
      };
      img.src = url;

      if (formikMethodsRef.current.values?.viewType === "client") {
        if (source !== "crop") {
          formikMethodsRef.current.setFieldValue("images.image1Original", url);
          formikMethodsRef.current.setFieldTouched("images.image1Original", true);
        }
        formikMethodsRef.current.setFieldValue("images.image1", url);
        formikMethodsRef.current.setFieldTouched("images.image1", true);
      } else {
        if (source !== "crop") {
          formikMethodsRef.current.setFieldValue("teams.image1Original", url);
          formikMethodsRef.current.setFieldTouched("teams.image1Original", true);
        }
        formikMethodsRef.current.setFieldValue("teams.image1", url);
        formikMethodsRef.current.setFieldTouched("teams.image1", true);
      }
    },
    []
  );

  const handleImageResetImage1 = useCallback(() => {
    if (formikMethodsRef.current.values?.viewType === "client") {
      formikMethodsRef.current.setFieldValue("images.image1Original", null);
      formikMethodsRef.current.setFieldTouched("images.image1Original", true);
      formikMethodsRef.current.setFieldValue("images.image1", "");
      formikMethodsRef.current.setFieldTouched("images.image1", true);
    } else {
      formikMethodsRef.current.setFieldValue("teams.image1Original", null);
      formikMethodsRef.current.setFieldTouched("teams.image1Original", true);
      formikMethodsRef.current.setFieldValue("teams.image1", null);
      formikMethodsRef.current.setFieldTouched("teams.image1", true);
    }
  }, []);

  const handleImageChangeImage2 = useCallback(
    ({ url, source }) => {
      // Get image dimensions
      const img = new Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        let newWidth = width;
        let newHeight = height;
        
        if (formikMethodsRef.current.values?.viewType === "teams_app" && formikMethodsRef.current.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e") {
          
          if(width > 70) {
            const aspectRatio = width / height;
            newHeight = Math.round(70 / aspectRatio);
            newWidth = 70;
          }
          formikMethodsRef.current.setFieldValue("teams.image2Width", `${newWidth}px`);
          formikMethodsRef.current.setFieldTouched("teams.image2Width", true);
          formikMethodsRef.current.setFieldValue("teams.image2Height", `${newHeight}px`);
          formikMethodsRef.current.setFieldTouched("teams.image2Height", true);
          
          // Store the original aspect ratio based on the actual image dimensions
          if (height > 0) {
            lastValidAspectRatiosRef.current["teams.image2"] = newWidth / newHeight;
          }
        }
      };
      img.onerror = () => {
        console.error("Failed to load image:", url);
      };
      img.src = url;

      if (formikMethodsRef.current.values?.viewType === "client") {
        if (source !== "crop") {
          formikMethodsRef.current.setFieldValue("images.image2Original", url);
          formikMethodsRef.current.setFieldTouched("images.image2Original", true);
        }
        formikMethodsRef.current.setFieldValue("images.image2", url);
        formikMethodsRef.current.setFieldTouched("images.image2", true);
      } else {
        if (source !== "crop") {
          formikMethodsRef.current.setFieldValue("teams.image2Original", url);
          formikMethodsRef.current.setFieldTouched("teams.image2Original", true);
        }
        formikMethodsRef.current.setFieldValue("teams.image2", url);
        formikMethodsRef.current.setFieldTouched("teams.image2", true);
      }
    },
    []
  );

  const handleImageResetImage2 = useCallback(() => {
    if (formikMethodsRef.current.values?.viewType === "client") {
      formikMethodsRef.current.setFieldValue("images.image2Original", null);
      formikMethodsRef.current.setFieldTouched("images.image2Original", true);
      formikMethodsRef.current.setFieldValue("images.image2", "");
      formikMethodsRef.current.setFieldTouched("images.image2", true);
    } else {
      formikMethodsRef.current.setFieldValue("teams.image2Original", null);
      formikMethodsRef.current.setFieldTouched("teams.image2Original", true);
      formikMethodsRef.current.setFieldValue("teams.image2", null);
      formikMethodsRef.current.setFieldTouched("teams.image2", true);
    }
  }, []);

  const handleImageResetBG1 = useCallback(() => {
    formikMethodsRef.current.setFieldValue("images.bg1Original", null);
    formikMethodsRef.current.setFieldTouched("images.bg1Original", true);
    formikMethodsRef.current.setFieldValue(`images.bg1`, "");
    formikMethodsRef.current.setFieldTouched(`images.bg1`, true);
  }, []);

  const handleImageDimensionChange = useCallback(
    (formik, originalOnChange, formikFieldId, isWidthField) => (e) => {
      // Apply only on teams cards
      if (formik.values?.viewType !== "teams_app") {
        originalOnChange(e);
        return;
      }

      // Determine the corresponding field names
      const widthFieldName = `${formikFieldId}Width`;
      const heightFieldName = `${formikFieldId}Height`;

      // Helper function to parse dimension values - returns null if invalid (empty or just "px")
      const parseDimensionValue = (value) => {
        const cleaned = (value || "").replace("px", "").trim();
        const parsed = parseInt(cleaned);
        return cleaned && !isNaN(parsed) && parsed > 0 ? parsed : null;
      };

      // Get current values before calling originalOnChange
      const currentWidth = parseDimensionValue(get(formik.values, widthFieldName));
      const currentHeight = parseDimensionValue(get(formik.values, heightFieldName));

      // Call the original onChange first to update formik values
      originalOnChange(e);

      // Parse the new value (remove 'px' if present)
      const newValue = parseDimensionValue(e.target.value);

      // Determine which aspect ratio to use
      let aspectRatio = null;
      
      // Always prioritize stored aspect ratio if available (from original image dimensions)
      if (lastValidAspectRatiosRef.current[formikFieldId]) {
        // Use the stored aspect ratio to preserve the original image aspect ratio
        aspectRatio = lastValidAspectRatiosRef.current[formikFieldId];
      } else if (currentWidth && currentHeight) {
        // Fallback: if we don't have a stored one but both dimensions are valid, calculate and store it
        // This should only happen on first interaction if image was uploaded before aspect ratio storage was added
        aspectRatio = currentWidth / currentHeight;
        lastValidAspectRatiosRef.current[formikFieldId] = aspectRatio;
      }

      // Calculate and update the corresponding dimension if we have a valid aspect ratio and new value
      if (aspectRatio && newValue) {
        let updatedFieldName;
        let newDimensionValue;

        if (isWidthField) {
          // Width changed, calculate new height
          updatedFieldName = heightFieldName;
          newDimensionValue = Math.round(newValue / aspectRatio);
        } else {
          // Height changed, calculate new width
          updatedFieldName = widthFieldName;
          newDimensionValue = Math.round(newValue * aspectRatio);
        }

        formik.setFieldValue(updatedFieldName, `${newDimensionValue}px`);
        formik.setFieldTouched(updatedFieldName, true);
      }
    },
    []
  );

  // Memoize props for ImageUpload to prevent unnecessary re-renders and image reloads
  const memoizedImageUploadButtonProps = useMemo(
    () => ({
      children: "Upload",
    }),
    []
  );

  const memoizedImageUploadCaption = useMemo(
    () => (
      <Typography
        color="textSecondary"
        style={{ color: "#BFBFBF" }}
      >
        Upload .jpg or .png files.
      </Typography>
    ),
    []
  );

  const memoizedImageUploadCustomPathInfo = useMemo(
    () => ({ journeyId: journey?.id }),
    [journey?.id]
  );

  const memoizedImageUploadStyles = useMemo(
    () => ({ width: 200 }),
    []
  );

  const handleImageResetBG2 = useCallback(() => {
    formikMethodsRef.current.setFieldValue("images.bg2Original", null);
    formikMethodsRef.current.setFieldTouched("images.bg2Original", true);
    formikMethodsRef.current.setFieldValue(`images.bg2`, "");
    formikMethodsRef.current.setFieldTouched(`images.bg2`, true);
    const values = formikMethodsRef.current.values;
    const isWhiteBoardFamily =
      values?.viewType === "client" && values?.templateFamilyId === WHITEBOARD_FAMILY_ID;
    if (isWhiteBoardFamily) {
      formikMethodsRef.current.setFieldValue("cardheight", null);
      formikMethodsRef.current.setFieldTouched("cardheight", true);
      formikMethodsRef.current.setFieldValue("cardwidth", null);
      formikMethodsRef.current.setFieldTouched("cardwidth", true);
      whiteBoardAutoHeightModeRef.current = false;
    }
  }, []);

  const handleImageResetCTA = useCallback(() => {
    formikMethodsRef.current.setFieldValue("images.ctaOriginal", null);
    formikMethodsRef.current.setFieldTouched("images.ctaOriginal", true);
    formikMethodsRef.current.setFieldValue("images.cta", "");
    formikMethodsRef.current.setFieldTouched("images.cta", true);
    formikMethodsRef.current.setFieldValue("ctapictureheight", null);
    formikMethodsRef.current.setFieldTouched("ctapictureheight", true);
    formikMethodsRef.current.setFieldValue("ctapicturewidth", null);
    formikMethodsRef.current.setFieldTouched("ctapicturewidth", true);
    whiteBoardAutoCtaHeightModeRef.current = false;
  }, []);

  const handleImageResetCTA2 = useCallback(() => {
    formikMethodsRef.current.setFieldValue("images.cta2Original", null);
    formikMethodsRef.current.setFieldTouched("images.cta2Original", true);
    formikMethodsRef.current.setFieldValue("images.cta2", "");
    formikMethodsRef.current.setFieldTouched("images.cta2", true);
    formikMethodsRef.current.setFieldValue("cta2pictureheight", null);
    formikMethodsRef.current.setFieldTouched("cta2pictureheight", true);
    formikMethodsRef.current.setFieldValue("cta2picturewidth", null);
    formikMethodsRef.current.setFieldTouched("cta2picturewidth", true);
    whiteBoardAutoCta2HeightModeRef.current = false;
  }, []);

  const handleWhiteBoardCardHeightChange = useCallback(
    (e) => {
      const rawValue = e.target.value;
      const parsed = parsePxToNumber(rawValue);

      whiteBoardAutoHeightModeRef.current = !parsed;
      if (!parsed) {
        formikMethodsRef.current.setFieldValue("cardheight", null);
        formikMethodsRef.current.setFieldTouched("cardheight", true);
        formikMethodsRef.current.setFieldValue("cardwidth", null);
        formikMethodsRef.current.setFieldTouched("cardwidth", true);
        return;
      }

      const boundedHeight = Math.min(parsed, 800);
      formikMethodsRef.current.setFieldValue("cardheight", `${boundedHeight}px`);
      formikMethodsRef.current.setFieldTouched("cardheight", true);
    },
    []
  );

  // to compute only when the user loses focus from the field to avoid flickering
  const handleWhiteBoardCardHeightBlur = useCallback(async () => {
    const imageUrl = formikMethodsRef.current.values?.images?.bg2 || null;
    await applyWhiteBoardCardDimensions({
      requestedHeight: formikMethodsRef.current.values?.cardheight,
      imageUrl,
    });
  }, [applyWhiteBoardCardDimensions]);

  const handleWhiteBoardCtaPictureHeightChange = useCallback((e) => {
    const parsed = parsePxToNumber(e.target.value);
    whiteBoardAutoCtaHeightModeRef.current = !parsed;
    if (!parsed) {
      formikMethodsRef.current.setFieldValue("ctapictureheight", null);
      formikMethodsRef.current.setFieldTouched("ctapictureheight", true);
      formikMethodsRef.current.setFieldValue("ctapicturewidth", null);
      formikMethodsRef.current.setFieldTouched("ctapicturewidth", true);
      return;
    }
    const boundedHeight = Math.min(parsed, 800);
    formikMethodsRef.current.setFieldValue("ctapictureheight", `${boundedHeight}px`);
    formikMethodsRef.current.setFieldTouched("ctapictureheight", true);
  }, []);

  const handleWhiteBoardCtaPictureHeightBlur = useCallback(async () => {
    const imageUrl = formikMethodsRef.current.values?.images?.cta || null;
    await applyWhiteBoardCtaPictureDimensions({
      requestedHeight: formikMethodsRef.current.values?.ctapictureheight,
      imageUrl,
    });
  }, [applyWhiteBoardCtaPictureDimensions]);

  const handleWhiteBoardCta2PictureHeightChange = useCallback((e) => {
    const parsed = parsePxToNumber(e.target.value);
    whiteBoardAutoCta2HeightModeRef.current = !parsed;
    if (!parsed) {
      formikMethodsRef.current.setFieldValue("cta2pictureheight", null);
      formikMethodsRef.current.setFieldTouched("cta2pictureheight", true);
      formikMethodsRef.current.setFieldValue("cta2picturewidth", null);
      formikMethodsRef.current.setFieldTouched("cta2picturewidth", true);
      return;
    }
    const boundedHeight = Math.min(parsed, 800);
    formikMethodsRef.current.setFieldValue("cta2pictureheight", `${boundedHeight}px`);
    formikMethodsRef.current.setFieldTouched("cta2pictureheight", true);
  }, []);

  const handleWhiteBoardCta2PictureHeightBlur = useCallback(async () => {
    const imageUrl = formikMethodsRef.current.values?.images?.cta2 || null;
    await applyWhiteBoardCta2PictureDimensions({
      requestedHeight: formikMethodsRef.current.values?.cta2pictureheight,
      imageUrl,
    });
  }, [applyWhiteBoardCta2PictureDimensions]);

  const handleImageResetBackgroundImage = useCallback(() => {
    formikMethodsRef.current.setFieldValue("teams.backgroundImageOriginal", null);
    formikMethodsRef.current.setFieldTouched("teams.backgroundImageOriginal", true);
    formikMethodsRef.current.setFieldValue(`teams.backgroundImage`, "");
    formikMethodsRef.current.setFieldTouched(`teams.backgroundImage`, true);
  }, []);

  const simulationDids = useMemo(
    () => parseDidList(simulationDeviceIds),
    [simulationDeviceIds]
  );

  const isChannelValidityAny = formik.values.channelValidity === "any";

  const simulationChannelValidity = isChannelValidityAny
    ? simulationDestinationChannel
    : formik.values.channelValidity;

  const canSendSimulation =
    simulationDids.length > 0 &&
    !isSimulateSemanticLoading &&
    (!isChannelValidityAny || Boolean(simulationDestinationChannel));

  const handleSimulationDeviceIdsChange = useCallback(
    (e) => {
      setSimulationDeviceIds(e.target.value);
    },
    [setSimulationDeviceIds]
  );

  const handleSimulationDestinationChannelChange = useCallback(
    (e) => {
      setSimulationDestinationChannel(e.target.value);
    },
    []
  );

  const handleSendSimulation = useCallback(async () => {
    if (!canSendSimulation) {
      return;
    }

    try {
      const response = await simulateSemantic({
        semanticId: formik.values.id,
        dids: simulationDids,
        channelValidity: simulationChannelValidity,
      });

      const failedResults = (response?.results || []).filter(
        (result) => !result.ok
      );
      if (failedResults.length > 0) {
        enqueueSnackbar(
          `Simulation failed for ${failedResults.length} device ID${
            failedResults.length === 1 ? "" : "s"
          }: ${failedResults
            .map((result) => result.error || result.did)
            .join(", ")
            .slice(0, 200)}`,
          { variant: "warning" }
        );
      }
    } catch {
      console.error("Simulation send error");
    }
  }, [
    canSendSimulation,
    simulateSemantic,
    formik.values.id,
    simulationDids,
    simulationChannelValidity,
    enqueueSnackbar,
  ]);

  const title = interaction.type === "NUDGE" ? "Nudge" : "Tip";
  const titleLowerCased = title.toLowerCase();

  const messageContentTitle = useMemo(
    () => aiResult?.title ?? formik.values.title ?? "",
    [aiResult?.title, formik.values.title]
  );

  const messageContentText = useMemo(() => {
    if (formik.values.type === "PRIME") {
      return aiResult?.text ?? formik.values.text ?? "";
    }

    return formik.values.text ?? "";
  }, [aiResult?.text, formik.values.text, formik.values.type]);

  const hasUnsupportedMessageTitleMarkdown = useMemo(
    () =>
      formik.values.viewType === "teams_app" &&
      hasUnsupportedTeamsMarkdown(messageContentTitle),
    [formik.values.viewType, messageContentTitle]
  );

  const hasUnsupportedMessageTextMarkdown = useMemo(
    () =>
      formik.values.viewType === "teams_app" &&
      hasUnsupportedTeamsMarkdown(messageContentText),
    [formik.values.viewType, messageContentText]
  );

  const modals = useModals();

  const handleInteractionClick = useCallback(
    (e, semanticId) => {
      if (!semanticId) {
        return;
      }

      if (!formik.dirty) {
        history.replace(
          `/journeys/${journeyId}/${locale}/${interaction.type.toLowerCase()}s/${semanticId}`
        );
        return;
      }

      modals.openConfirmation({
        closeCTATitle: "Cancel",
        confirmCTATitle: "Yes",
        onConfirm: () => {
          history.replace(
            `/journeys/${journeyId}/${locale}/${interaction.type.toLowerCase()}s/${semanticId}`
          );
        },
        text: `You have unsaved changes. Are you sure you want to proceed?`,
        title: "Go to another interaction?",
      });
    },
    [formik.dirty, history, interaction.type, journeyId, locale, modals]
  );

  const handleCreateMaterial = useCallback(
    (column) => (e) => {
      e.preventDefault();
      const newMaterial = {
        id: `sem-${uuidv4()}`,
        isNew: true,
        order: 0,
      };
      modals.openModal(modals.modalTypes.EditMaterial, {
        journey,
        locale,
        material: newMaterial,
        journeys,
        onClose: async (value) => {
          if (value) {
            return;
          }
          await formik.setFieldValue(column, formik.values[column]);
          await formik.setFieldTouched(column);
        },
        onConfirm: async (material) => {
          await updateJourneyMaterial({
            ...newMaterial,
            ...material,
            journeyId,
          });
          await formik.setFieldValue(column, newMaterial.id);
          await formik.setFieldTouched(column);
        },
      });
    },
    [
      modals,
      journey,
      locale,
      journeys,
      formik,
      updateJourneyMaterial,
      journeyId,
    ]
  );

  const handleCreateSpecialLink = useCallback(
    (column) => (e) => {
      e.preventDefault();
      modals.openModal(modals.modalTypes.EditSpecialLink, {
        isNew: true,
        onClose: async (value) => {
          if (value) {
            return;
          }

          await formik.setFieldValue(column, formik.values[column]);
          await formik.setFieldTouched(column);
        },
        onConfirm: async (specialLink) => {
          const newSpecialLink = await updateSpecialLink({
            isNew: true,
            ...specialLink,
          });
          await formik.setFieldValue(column, newSpecialLink.id);
          await formik.setFieldTouched(column);
        },
      });
    },
    [formik, modals, updateSpecialLink]
  );

  const handleInteractionDelete = useCallback(() => {
    modals.openConfirmation({
      closeCTATitle: "Cancel",
      confirmCTATitle: "Delete",
      onConfirm: async () => {
        const index = interactions.findIndex(
          (item) => item.id === interaction.id
        );
        await deleteJourneySemantic({ id: interaction.id, journeyId });

        if (index === 0) {
          history.replace(
            `/journeys/${journeyId}/${locale}/${
              interaction.type === "NUDGE" ? "contextual" : "tips"
            }`
          );
          return;
        }

        history.replace(
          `/journeys/${journeyId}/${locale}/${interaction.type.toLowerCase()}s/${
            interactions[index - 1].id
          }`
        );
      },
      text: `You are about to permanently delete tip ${
        interactions.length > 1 ? interactionIndex + 1 : ""
      } from this flow.`,
      title: "Delete the tip?",
    });
  }, [
    deleteJourneySemantic,
    history,
    interaction.id,
    interaction.type,
    interactionIndex,
    interactions,
    journeyId,
    locale,
    modals,
  ]);

  const handleAdd = useCallback(
    async (newSemantic) => {
      if (
        trigger?.contentType === "onboarding" ||
        trigger?.contentType === "step_guide"
      ) {
        await updateJourneySemantic(
          {
            cta2Target: newSemantic.id,
            cta2Text: "Next ➡",
            cta2Type: "Semantic",
            id: interactions[interactions.length - 1].id,
            journeyId,
          },
          { optimisticUpdates: false }
        );
      }
      await updateJourneySemantic(newSemantic, {
        optimisticUpdates: false,
      });

      history.push(`/journeys/${journeyId}/${locale}/nudges/${newSemantic.id}`);
    },
    [
      history,
      interactions,
      journeyId,
      locale,
      trigger?.contentType,
      updateJourneySemantic,
    ]
  );

  const {
    isLoading: isAddingNewInteraction,
    handleConfirm: handleAddInteraction,
  } = useModal({
    onConfirm: handleAdd,
  });

  const handleAddNewInteraction = useCallback(async () => {
    if (interaction.type === "PRIME") {
      const id = `sem-${uuidv4()}`;
      history.push(`/journeys/${journeyId}/${locale}/primes/${id}`, {
        flowId: interaction.flowId,
        isNew: true,
        type: "PRIME",
      });
      return;
    }

    const id = `sem-${uuidv4()}`;
    const params = {
      cta1Target: interactions[interactions.length - 1].id,
      cta1Text: "⬅ Back",
      cta1Type: "Semantic",
      cta2Text: "Finish",
      cta2Type: "Close",
      ctaType: "DOUBLE_CTA",
      flowId: interaction.flowId,
      id,
      index: interactions.length,
      isFirstInFlow: false,
      isNew: true,
      journeyId,
      semanticId: id,
      showX: true,
      text: `Deep dive into the tip's topic and showcase **the value ${
        interactions.length + 1
      } for the user.**`,
      type: interaction.type,
      ...(interaction.stimulusId && {
        stimulusId: interaction.stimulusId,
      }),
    };

    if (!formik.dirty) {
      await handleAddInteraction(params);
      return;
    }

    modals.openConfirmation({
      closeCTATitle: "Cancel",
      confirmCTATitle: "Yes",
      onConfirm: () => handleAddInteraction(params),
      text: `You have unsaved changes. Are you sure you want to proceed?`,
      title: "Add new interaction?",
    });
  }, [
    interaction.type,
    interaction.flowId,
    interaction.stimulusId,
    interactions,
    journeyId,
    formik.dirty,
    modals,
    history,
    locale,
    handleAddInteraction,
  ]);

  const theme = useTheme();

  const { containerRef: previewContainerRef, height } = useStickyHeight();

  const { flowRelationsByRelationId } = useMemo(
    () => getData({ semantics, flowRelations, days: journey?.days }),
    [semantics, flowRelations, journey?.days]
  );

  const handleAssociationChange = useCallback(
    (e, value, reason) => {
      if (
        !["clear", "select-option", "remove-option"].includes(reason) &&
        reason !== undefined
      ) {
        return;
      }

      const nextRelations = value.map((option) => ({
        relationId: option.id,
        type:
          option.groupColumn === "Day slots" ? "daySlot" : "scheduledSlot",
      }));

      formik.setFieldValue("relations", nextRelations);
      formik.setFieldTouched("relations", true);

      const firstScheduledOption = value.find(
        (option) => option.groupColumn === "Scheduled Slots"
      );

      formik.setFieldValue(
        "relation",
        firstScheduledOption
          ? {
              relationId: firstScheduledOption.id,
              type: "scheduledSlot",
            }
          : null
      );
      formik.setFieldTouched("relation", true);
    },
    [formik]
  );

  const relationsOptions = useMemo(() => {
    const currentFlowId = formik.values.flowId;

    const daySlotOptions = Object.entries(daySlotsByDayId || {}).flatMap(
      ([dayId, slots]) => {
        const dayMeta = daysById[dayId];
        if (!dayMeta) {
          return [];
        }
        const dayNumber = dayMeta.day;

        return (slots || [])
          .filter((slot) => !slot.flowId || slot.flowId === currentFlowId)
          .map((slot) => ({
            ...slot,
            day: dayNumber,
            groupColumn: "Day slots",
          }));
      }
    );
    // Showing the option if it is not associated to any flow
    // or if it is associated to the current flow
    const scheduledSlotOptions = scheduledSlots
      .filter(({ id }) => {
        const relationsForSlot = flowRelationsByRelationId[id] || [];
        if (!relationsForSlot.length) {
          return true;
        }

        return relationsForSlot.some(
          (relation) => relation.flowId === currentFlowId
        );
      })
      .map((scheduledSlot) => ({
        ...scheduledSlot,
        groupColumn: "Scheduled Slots",
      }));

    return [...daySlotOptions, ...scheduledSlotOptions];
  }, [
    daySlotsByDayId,
    daysById,
    formik.values.flowId,
    scheduledSlots,
    flowRelationsByRelationId,
  ]);

  useEffect(() => {
    if (
      (formik.values.viewType === "client" && !templateFamilies) ||
      !templateFamilies.length
    ) {
      fetchTemplateFamilies();
    }
    if (
      (formik.values.viewType === "teams_app" && !teamsTemplateFamilies) ||
      !teamsTemplateFamilies.length
    ) {
      fetchTeamsTemplateFamilies();
    }
  }, [
    formik.values.viewType,
    fetchTeamsTemplateFamilies,
    fetchTemplateFamilies,
    teamsTemplateFamilies,
    templateFamilies,
  ]);

  useEffect(() => {
    // Fetching semanticTemplate
    if (
      formik.values.viewType === "client" &&
      formik.values?.semanticTemplateId &&
      semanticTemplates?.[0]?.templateId !== formik.values.semanticTemplateId
    ) {
      fetchSemanticTemplates({
        semanticTemplateId: formik.values.semanticTemplateId,
      });
    }
    if (
      formik.values.viewType === "teams_app" &&
      formik.values?.teams?.semanticTemplateId &&
      teamsSemanticTemplates?.[0]?.templateId !==
        formik.values.teams.semanticTemplateId
    ) {
      fetchTeamsSemanticTemplates({
        teamsSemanticTemplateId: formik.values.teams.semanticTemplateId,
      });
    }
  }, [
    fetchSemanticTemplates,
    fetchTeamsSemanticTemplates,
    formik.values.semanticTemplateId,
    formik.values.teams.semanticTemplateId,
    formik.values.viewType,
    semanticTemplates,
    teamsSemanticTemplates,
  ]);

  useEffect(() => {
    if (formik.values.semanticPreview.semanticPreviewTemplateId) {
      fetchSemanticPreviewTemplates({
        semanticPreviewTemplateId:
          formik.values.semanticPreview.semanticPreviewTemplateId,
      });
      // clean-up all the related fields
      formik.values.semanticPreview.title = "";
      // interaction.semanticPreview.title = "";
      formik.values.semanticPreview.text = "";
      // interaction.semanticPreview.text = "";
      formik.values.semanticPreview.cta1Text = "";
    }
  }, [
    fetchSemanticPreviewTemplates,
    formik.values.semanticPreview.semanticPreviewTemplateId,
  ]);
  /*  const tipGroups = [
    {
        id:"123",
        name: "test1"
    },
    {
      id:"321",
      name:"test2"
    },
] */
  // it is already fetched by parent component
  // useEffect(() => {
  //   if (formik.values.type === "NUDGE" && formik.values.isFirstInFlow) {
  //     if (!listofusers && !isListofusersLoading) {
  //       console.log("fetching listofusers");
  //       fetchListofusers();
  //     }
  //   }
  // }, [
  //   formik.values.type,
  //   formik.values.isFirstInFlow,
  //   isListofusersLoading,
  //   listofusers,
  //   fetchListofusers,
  // ]);

  useEffect(() => {
    fetchTipGroups();
    getJourneyDaySlots({ journeyId });
  }, []);

  /*useEffect(() => {
    if (formik.values.viewType === "teams_app" && !teamsGalleryImages.length) {
      fetchTeamsGalleryImages();
    }
  }, [
    formik.values.viewType,
    fetchTeamsGalleryImages,
    teamsGalleryImages.length,
  ]);*/
  return (
    <div>
      {wizardVisible ? (
        <AiIntegration
          aiResult={updateAiServiceResult}
          journeyId={journey.id}
          journeyLanguage={journey.locale}
          setWizardVisible={setWizardVisible}
        />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid container item>
                <Timestamps
                  copiedFromEntity={interaction.type.toLowerCase()}
                  copiedFromEntityId={interaction.copiedFromSemanticId}
                  copiedFromJourneyId={interaction.copiedFromJourneyId}
                  createdAt={interaction.createdAt}
                  createdBy={interaction.createdBy}
                  locale={locale}
                  updatedAt={interaction.updatedAt}
                  updatedBy={interaction.updatedBy}
                />
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      required
                      select
                      label="Channel Validity"
                      {...getFieldProps(formik, {
                        defaultValue: formik.values.channelValidity || "any",
                        name: "channelValidity",
                      })}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        Select Channel Validity
                      </MenuItem>
                      {CHANNEL_VALIDITY_OPTIONS.map(({ value, label }) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      select
                      label="View Type"
                      {...getFieldProps(formik, {
                        defaultValue: formik.values.viewType || "client",
                        disabled: Boolean(lockedViewType),
                        name: "viewType",
                        required: true,
                      })}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        Select View Type
                      </MenuItem>
                      <MenuItem value="client">Client View</MenuItem>
                      <MenuItem value="teams_app">Teams View</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={4}>
                    {interaction.type === "NUDGE" && (
                      <Typography variant="h6">{trigger?.name}</Typography>
                    )}
                    {interaction.type === "PRIME" && journey && (
                      <Autocomplete
                        fullWidth
                        multiple
                        filterOptions={filterOptions}
                        getOptionLabel={(option) => {
                          if (option.groupColumn === "Day slots") {
                            const title = option.flowId
                              ? primesByFlowId[option.flowId]?.[0]?.title || option.title
                              : option.title;

                            return `${title} - Day ${option.day}`;
                          }

                          return getScheduledSlotName({
                            datePeriod: option.datePeriod,
                            datetimeEnd: option.datetimeEnd,
                            datetimeStart: option.datetimeStart,
                            specificInterval: option?.specificInterval,
                          });
                        }}
                        groupBy={(option) => option.groupColumn}
                        loading={isScheduledSlotsLoading}
                        options={relationsOptions}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              ...params.InputProps,
                            }}
                            label="Associated to"
                            placeholder={
                              (formik.values.relations || []).length
                                ? undefined
                                : "Unassociated"
                            }
                            // style={{ maxWidth: 300 }}
                            variant="outlined"
                          />
                        )}
                        renderOption={(option, { inputValue }) => {
                          const isDaySlot = option.groupColumn === "Day slots";

                          const slotTitle = option.title || "Untitled day slot";

                          const primaryText = isDaySlot
                            ? primesByFlowId[option.flowId]?.[0]?.title ||
                              slotTitle
                            : getScheduledSlotDatetimeIntervalString({
                                datetimeEnd: option.datetimeEnd,
                                datetimeStart: option.datetimeStart,
                              });

                          return (
                            <ListItemText
                              primary={
                                isDaySlot ? (
                                  <Highlighter
                                    searchWords={[inputValue || ""]}
                                    textToHighlight={primaryText}
                                  />
                                ) : (
                                  primaryText
                                )
                              }
                              secondary={
                                isDaySlot
                                  ? `Day ${option.day}`
                                  : getScheduledSlotSpecificIntervalString({
                                      datePeriod: option.datePeriod,
                                      specificInterval: option.specificInterval,
                                    })
                              }
                            />
                          );
                        }}
                        value={relationsOptions.filter((option) => {
                          const relations = formik.values.relations || [];

                          if (option.groupColumn === "Day slots") {
                            return relations.some(
                              (rel) =>
                                rel.relationId === option.id &&
                                rel.type === "daySlot"
                            );
                          }

                          // Scheduled Slots
                          return relations.some(
                            (rel) =>
                              rel.relationId === option.id &&
                              rel.type === "scheduledSlot"
                          );
                        })}
                        onChange={handleAssociationChange}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {(user.groups.includes("Admins") ||
                !user.companies?.includes(DA_COMPANY_ID)) && (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {!(user.companies?.includes(SNAM_COMPANY_ID) &&
                      !user.groups.includes("Admins")) && (
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          select
                          label="Tip Group for analytics"
                          {...getFieldProps(formik, {
                            defaultValue: formik.values.tipgroup || "",
                            name: "tipgroup",
                            required: true,
                          })}
                          variant="outlined"
                        >
                          <MenuItem disabled value="">
                            Select Tip Group
                          </MenuItem>
                          {tipGroups.map((tipGroup, index) => (
                            <MenuItem key={index} value={tipGroup.id}>
                              {tipGroup.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    )}
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label="Title for PowerBI"
                        placeholder="Title for PowerBI"
                        variant="outlined"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.titleForPowerBI ||
                            "",
                          name: "titleForPowerBI",
                        })}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={8}>
              <Grid item xs={8}>
                <Grid container spacing={4}>
                  <Grid item style={{ paddingBottom: "0px" }} xs={12}>
                    <Grid container justify="space-between" spacing={2}>
                      <Grid item style={{ maxWidth: "100%" }}>
                        <Box
                          display="flex"
                          maxWidth="100%"
                          style={{ overflowX: "auto" }}
                        >
                          <ToggleButtonGroup
                            exclusive
                            size="small"
                            value={interaction.id}
                            onChange={handleInteractionClick}
                          >
                            {interactions.map(
                              ({ id, title, text, isFirstInFlow }, i) => (
                                <Tooltip
                                  key={id}
                                  title={
                                    <>
                                      {title && <b>{title}</b>}
                                      {text && <br />}
                                      {text && <br />}
                                      <i>{text}</i>
                                    </>
                                  }
                                >
                                  <ToggleButton
                                    selected={interaction.id === id}
                                    style={{
                                      ...(interaction.id === id && {
                                        borderColor: theme.palette.primary.main,
                                        borderWidth: 2,
                                      }),
                                    }}
                                    value={id}
                                  >
                                    {interaction.type === "PRIME" && "TIP "}
                                    {i + 1}
                                    {isFirstInFlow && <> (first of the flow)</>}
                                  </ToggleButton>
                                </Tooltip>
                              )
                            )}
                          </ToggleButtonGroup>
                        </Box>
                      </Grid>
                      {trigger?.contentType !== "feature_promotion" &&
                        !isNew && (
                          <Grid item>
                            <Grid container spacing={1}>
                              {journey &&
                                (interaction.type === "PRIME" ||
                                  !trigger?.contentType ||
                                  (!["onboarding", "step_guide"].includes(
                                    trigger?.contentType
                                  ) &&
                                    interactionIndex > 1 &&
                                    interactionIndex + 1 ===
                                      interactions.length)) && (
                                  <Grid item>
                                    <Tooltip
                                      interactive={interaction.isFirstInFlow}
                                      title={
                                        interaction.isFirstInFlow
                                          ? "First tip cannot be deleted. Mark another tip as first and then you can delete this tip."
                                          : null
                                      }
                                    >
                                      <span>
                                        <OutlinedButton
                                          disabled={
                                            isDisabled ||
                                            interaction.isFirstInFlow
                                          }
                                          onClick={handleInteractionDelete}
                                        >
                                          Delete{" "}
                                          {interaction.type === "PRIME" &&
                                            "TIP"}
                                        </OutlinedButton>
                                      </span>
                                    </Tooltip>
                                  </Grid>
                                )}
                              <Grid item>
                                <OutlinedButton
                                  disabled={
                                    isDisabled || isAddingNewInteraction
                                  }
                                  endIcon={
                                    isAddingNewInteraction && (
                                      <CircularProgress size={25} />
                                    )
                                  }
                                  startIcon={<AddIcon />}
                                  onClick={handleAddNewInteraction}
                                >
                                  Add new{" "}
                                  {interaction.type === "PRIME" && "TIP"}
                                </OutlinedButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                    </Grid>
                  </Grid>
                  {formik.values.type === "NUDGE" &&
                    formik.values.isFirstInFlow && (
                      <Grid item xs={12}>
                        <SpecialConditions
                          days={journey?.days?.length}
                          formik={formik}
                          isDisabled={isDisabled}
                          journeyId={journeyId}
                          journeys={journeys}
                          listofusers={listofusers}
                          userStatePaths={userStatePaths}
                          {...(formik.values.type === "PRIME" && {
                            defaultType: "activeDays",
                          })}
                          surveys={surveys}
                          trackedlm={materials.filter((m) => m.allowTracking)}
                          types={
                            formik.values.type === "PRIME"
                              ? ["activeDays"]
                              : nudgeSpecialConditionTypes
                          }
                        />
                      </Grid>
                    )}
                  {![formik.values, ...interactions].some(
                    ({ conditions, isFirstInFlow }) =>
                      isFirstInFlow && conditions?.length
                  ) && (
                    <Grid item style={{ paddingTop: "0px" }} xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            {...getFieldProps(formik, {
                              disabled: interaction.isFirstInFlow,
                              name: "isFirstInFlow",
                            })}
                            checked={
                              getFieldProps(formik, { name: "isFirstInFlow" })
                                .value
                            }
                          />
                        }
                        label={`First ${titleLowerCased} of the flow. Check here if this ${titleLowerCased} will be the first ${titleLowerCased} in the ${titleLowerCased} flow`}
                      />
                    </Grid>
                  )}
                  {formik.values.viewType === "client" && (
                    <>
                      {getFieldProps(formik, { name: "isFirstInFlow" })
                        .value === true && (
                        <Grid item style={{ paddingBottom: "0px" }} xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                {...getFieldProps(formik, {
                                  defaultValue: false,
                                  disabled:
                                    isDisabled ||
                                    !getFieldProps(formik, {
                                      name: "isFirstInFlow",
                                    }).value,
                                  name: "callRelatedCustomization",
                                })}
                                checked={
                                  getFieldProps(formik, {
                                    name: "callRelatedCustomization",
                                  }).value
                                }
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  formik.setFieldValue(
                                    "callRelatedCustomization",
                                    checked
                                  );
                                  if (checked) {
                                    if (!formik.values.callBehaviour) {
                                      formik.setFieldValue(
                                        "callBehaviour",
                                        "sendAnyway"
                                      );
                                    }
                                  } else {
                                    formik.setFieldValue("callBehaviour", null);
                                  }
                                }}
                              />
                            }
                            label={`Customized message sending if the user in in a call`}
                          />
                        </Grid>
                      )}

                      {getFieldProps(formik, { name: "isFirstInFlow" })
                        .value === true &&
                        !getFieldProps(formik, {
                          name: "callRelatedCustomization",
                        }).value &&
                        journey?.[`callBehaviour${title}s`] && (
                          <Grid item style={{ paddingTop: "0px" }} xs={12}>
                            <Alert severity="warning">
                              As per global Journey rule, if the user is in
                              call, this {title}{" "}
                              <i>
                                {journey?.[`callBehaviour${title}s`]
                                  ? getCallBehaviourOptions()[
                                      journey?.[`callBehaviour${title}s`]
                                    ]
                                  : "is sent anyway"}
                              </i>
                              {journey?.[`callBehaviour${title}s`] === "delay"
                                ? `, after ${
                                    journey?.[`afterCallDelay${title}s`]
                                  } seconds`
                                : ""}
                            </Alert>
                          </Grid>
                        )}
                    </>
                  )}
                  {getFieldProps(formik, { name: "isFirstInFlow" }).value ===
                    true &&
                    getFieldProps(formik, { name: "callRelatedCustomization" })
                      .value === true && (
                      <Grid item md={6} xs={12}>
                        <CallBehaviourSelect
                          required
                          label="If the user is in call, this message:"
                          {...getFieldProps(formik, {
                            defaultValue: "sendAnyway",
                            disabled: isDisabled,
                            name: "callBehaviour",
                          })}
                        ></CallBehaviourSelect>
                      </Grid>
                    )}
                  {getFieldProps(formik, { name: "isFirstInFlow" }).value ===
                    true &&
                    getFieldProps(formik, { name: "callRelatedCustomization" })
                      .value === true &&
                    getFieldProps(formik, { name: "callBehaviour" }).value ===
                      "delay" && (
                      <Grid item md={12} xs={12}>
                        <SelectorAlignedTypography>
                          Wait{"  "}
                          <SecondsSelectorWithinTypography
                            InputProps={{
                              inputProps: {
                                min: 0,
                                step: 1,
                              },
                            }}
                            {...getFieldProps(formik, {
                              disabled:
                                !getFieldProps(formik, {
                                  name: "callBehaviour",
                                }).value === "delay",
                              name: "afterCallDelay",
                            })}
                            placeholder="number"
                            type="number"
                          ></SecondsSelectorWithinTypography>{" "}
                          seconds after the call is finished before showing this
                          message.
                        </SelectorAlignedTypography>
                      </Grid>
                    )}
                  {/* Feature removed in task Simplify UI of tip creation in content portal (24-01-2024)
              {getFieldProps(formik, { name: "isFirstInFlow" }).value ===
                true && (
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        {...getFieldProps(formik, {
                          defaultValue: false,
                          disabled:
                            isDisabled ||
                            !getFieldProps(formik, {
                              name: "isFirstInFlow",
                            }).value,
                          name: "miniTipAutoProgress",
                        })}
                        checked={
                          getFieldProps(formik, {
                            name: "miniTipAutoProgress",
                          }).value
                        }
                      />
                    }
                    label={`After the card-preview is received, automatically open it into card after (in seconds): `}
                  />
                  <SecondsSelector
                    InputProps={{
                      inputProps: {
                        min: 0,
                        step: 1,
                      },
                    }}
                    {...getFieldProps(formik, {
                      disabled: !getFieldProps(formik, {
                        name: "miniTipAutoProgress",
                      }).value,
                      name: "miniTipAutoProgressDelay",
                    })}
                    placeholder="number"
                    type="number"
                  ></SecondsSelector>
                </Grid>
              )}
              {getFieldProps(formik, { name: "isFirstInFlow" }).value ===
                true &&
                journey?.miniTipAutoProgress === true &&
                !formik.values.miniTipAutoProgress && (
                  <Grid item xs={12}>
                    <Alert severity="warning">
                      {journey?.miniTipAutoProgressOnlyIfIgnored === true
                        ? `As per
                    global Journey rule, after the card-preview is received, if
                    the user has already received it, but not opened, at least ${
                      journey?.miniTipAutoProgressOnlyIfIgnoredTimes ??
                      "missing-value"
                    } times, it
                    automatically opens after ${
                      journey?.miniTipAutoProgressDelay ?? "missing-value"
                    } seconds`
                        : `As per global Journey rule, after the card-preview is received, it
                    automatically opens after ${
                      journey?.miniTipAutoProgressDelay ?? "missing-value"
                    } seconds`}
                    </Alert>
                  </Grid>
                )} */}
                  {getFieldProps(formik, { name: "isFirstInFlow" }).value ===
                    true &&
                    getFieldProps(formik, { name: "miniTipAutoProgress" })
                      .value === true && (
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              {...getFieldProps(formik, {
                                defaultValue: false,
                                disabled:
                                  isDisabled ||
                                  !getFieldProps(formik, {
                                    name: "isFirstInFlow",
                                  }).value,
                                name: "miniTipAutoProgressOnlyIfIgnored",
                              })}
                              checked={
                                getFieldProps(formik, {
                                  name: "miniTipAutoProgressOnlyIfIgnored",
                                }).value
                              }
                            />
                          }
                          label={`Apply the logic above only if the user has already received, but not opened, that card-preview at least this many times: `}
                        />
                        <TimesSelector
                          InputProps={{
                            inputProps: {
                              min: 1,
                              step: 1,
                            },
                          }}
                          {...getFieldProps(formik, {
                            defaultValue: 1,
                            disabled:
                              isDisabled ||
                              !getFieldProps(formik, {
                                name: "miniTipAutoProgressOnlyIfIgnored",
                              }).value,
                            name: "miniTipAutoProgressOnlyIfIgnoredTimes",
                          })}
                          placeholder="number"
                          type="number"
                        ></TimesSelector>
                      </Grid>
                    )}
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h3">Message layout</Typography>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <TemplateFamilySelect
                          required
                          label="Template Family"
                          {...getFieldProps(formik, {
                            defaultValue:
                              formik.values.templateFamilyId ||
                              formik.values.teams.templateFamilyId,
                            disabled: isDisabled,
                            name:
                              formik.values.viewType === "client"
                                ? "templateFamilyId"
                                : "teams.templateFamilyId",
                          })}
                          templatefamilies={filteredTemplateFamilies}
                          userCompanies={ user.companies }
                        ></TemplateFamilySelect>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <SemanticTemplateSelect
                          form={formik}
                          label="Card Template"
                          {...getFieldProps(formik, {
                            disabled:
                              (formik.values.viewType === "client" &&
                                semanticTemplateCatalogue?.length <= 0) ||
                              (formik.values.viewType === "teams_app" &&
                                teamsSemanticTemplateCatalogue?.length <= 0),
                            name:
                              formik.values.viewType === "client"
                                ? "semanticTemplateId"
                                : "teams.semanticTemplateId",
                            required: true,
                          })}
                          semantictemplatecatalogue={
                            formik.values.viewType === "client"
                              ? semanticTemplateCatalogue
                              : teamsSemanticTemplateCatalogue
                          }
                          templateFamily={
                            formik.values.viewType === "client"
                              ? templateFamilies.find(
                                  (family) =>
                                    formik.values.templateFamilyId ===
                                    family.tFamilyId
                                )?.tFamilyName
                              : teamsTemplateFamilies.find(
                                  (family) =>
                                    formik.values.teams.templateFamilyId ===
                                    family.tFamilyId
                                )?.tFamilyName
                          }
                        ></SemanticTemplateSelect>
                      </Grid>
                    </Grid>
                  </Grid>
                  {formik.values.viewType === "teams_app" && (
                    <>
                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                          label={"Title Color"}
                          {...getFieldProps(formik, {
                            defaultValue: formik.values.teams.titleColor || "Default",
                            name: "teams.titleColor",
                            required: true,
                          })}
                          variant="outlined"
                          {...props}
                        >
                          <MenuItem value="Default">Default</MenuItem>
                          <MenuItem value="Dark">
                            {(formik.values?.teams?.backgroundImage ||
                              formik.values?.teams?.backgroundColor) ? (
                              <strong>Dark</strong>
                            ) : (
                              "Dark"
                            )}
                          </MenuItem>
                          <MenuItem value="Light">
                            {(formik.values?.teams?.backgroundImage ||
                              formik.values?.teams?.backgroundColor) ? (
                              <strong>Light</strong>
                            ) : (
                              "Light"
                            )}
                          </MenuItem>
                          <MenuItem value="Accent">Accent</MenuItem>
                          <MenuItem value="Good">Good</MenuItem>
                          <MenuItem value="Warning">Warning</MenuItem>
                          <MenuItem value="Attention">Attention</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                          label={"Text Color"}
                          {...getFieldProps(formik, {
                            defaultValue: formik.values.teams.textColor || "Default",
                            name: "teams.textColor",
                            required: true,
                          })}
                          variant="outlined"
                          {...props}
                        >
                          <MenuItem value="Default">Default</MenuItem>
                          <MenuItem value="Dark">
                            {(formik.values?.teams?.backgroundImage ||
                              formik.values?.teams?.backgroundColor) ? (
                              <strong>Dark</strong>
                            ) : (
                              "Dark"
                            )}
                          </MenuItem>
                          <MenuItem value="Light">
                            {(formik.values?.teams?.backgroundImage ||
                              formik.values?.teams?.backgroundColor) ? (
                              <strong>Light</strong>
                            ) : (
                              "Light"
                            )}
                          </MenuItem>
                          <MenuItem value="Accent">Accent</MenuItem>
                          <MenuItem value="Good">Good</MenuItem>
                          <MenuItem value="Warning">Warning</MenuItem>
                          <MenuItem value="Attention">Attention</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                          {...getFieldProps(formik, {
                            name: "teams.titleSize",
                            required: true,
                          })}
                          label={"Title Size"}
                          variant="outlined"
                          {...props}
                        >
                          <MenuItem value="Default">Default</MenuItem>
                          <MenuItem value="Small">Small</MenuItem>
                          <MenuItem value="Medium">Medium</MenuItem>
                          <MenuItem value="Large">Large</MenuItem>
                          <MenuItem value="ExtraLarge">ExtraLarge</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                          {...getFieldProps(formik, {
                            name: "teams.textSize",
                            required: true,
                          })}
                          label={"Text Size"}
                          variant="outlined"
                          {...props}
                        >
                          <MenuItem value="Default">Default</MenuItem>
                          <MenuItem value="Small">Small</MenuItem>
                          <MenuItem value="Medium">Medium</MenuItem>
                          <MenuItem value="Large">Large</MenuItem>
                          <MenuItem value="ExtraLarge">ExtraLarge</MenuItem>
                        </TextField>
                      </Grid>

                    {(currentSemanticTemplate?.templateId === "crd-1f7a5ca6-3198-42bb-bc93-e77bcd1ddbed" || currentSemanticTemplate?.templateId === "crd-9fe9a579-738c-4010-95cf-615e67dae582") && (
                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          select
                          InputLabelProps={{ shrink: true }}
                          label={"Background Vertical Alignment"}
                          {...getFieldProps(formik, {
                            name: "teams.backgroundVerticalAlignment",
                            disabled: isDisabled,
                            required: true,
                          })}
                          variant="outlined"
                          {...props}
                        >
                          <MenuItem value="Default">Top</MenuItem>
                          <MenuItem value="Bottom">Bottom</MenuItem>
                        </TextField>
                      </Grid>
                      )}
                    </>
                  )}
                  {formik.values.viewType === "client" && (
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color1?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"Color Bubble"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              //defaultValue: formik.values.templateColors.color1 || formik.values.teams.backgroundColor,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color1?.disabled,
                              name: "templateColors.color1",
                            })}
                          ></TextField>
                        </Grid>
                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color2?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"Color Text"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue: formik.values.templateColors.color2,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color2?.disabled,
                              name: "templateColors.color2",
                            })}
                          ></TextField>
                        </Grid>
                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color3?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"Color Card"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue: formik.values.templateColors.color3,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color3?.disabled,
                              name: "templateColors.color3",
                            })}
                          ></TextField>
                        </Grid>

                        {formik.values.viewType === "client" &&
                          !isWhiteBoardFamily &&
                          selectedTemplate !== LEGACY_TEMPLATEFAMILY_ID && (
                            <Grid item md={2} style={{ display: currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color4?.hidden ? "none" : "block" }} xs={3}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                label={"Color Circle"}
                                placeholder="#HexColorCode"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.templateColors.color4,
                                  disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color4?.disabled,
                                  name: "templateColors.color4",
                                })}
                              ></TextField>
                            </Grid>
                          )}

                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color1cta?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"ColorCTAtext"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateColors.color1cta,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color1cta?.disabled,
                              name: "templateColors.color1cta",
                            })}
                          ></TextField>
                        </Grid>
                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color2cta?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"ColorCTABackground"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateColors.color2cta,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color2cta?.disabled,
                              name: "templateColors.color2cta",
                            })}
                          ></TextField>
                        </Grid>

                        <Grid item md={2} style={{ display: (isWhiteBoardFamily || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.colordecoration1?.hidden) ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.colordecoration1?.disabled}
                            label={"StrokeBackgroundColor"}
                            placeholder="#HexColorCode"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateColors.colordecoration1,
                              disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.colordecoration1?.disabled,
                              name: "templateColors.colordecoration1",
                            })}
                          ></TextField>
                        </Grid>
                        
                        <Grid item md={1} style={{ marginLeft: "15px", display: isWhiteBoardFamily ? "none" : "block" }} xs={1}>
                          <Grid
                            container
                            alignItems={
                              selectedTemplate === LEGACY_TEMPLATEFAMILY_ID
                                ? "center"
                                : ""
                            }
                            spacing={1}
                            style={{ flexDirection: "column" }}
                          >
                            <Grid item md={1} xs={1}>
                              <Typography
                                color="textSecondary"
                                variant="caption"
                              >
                                Pick&Copy
                              </Typography>
                            </Grid>
                            <Grid item md={1} xs={1}>
                              <input
                                type="color"
                                onChange={(e) =>
                                  navigator.clipboard.writeText(e.target.value)
                                }
                              ></input>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item md={2} style={{ display: isWhiteBoardFamily ? "none" : "block" }} xs={3} >
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"TitleFontSize"}
                            placeholder="ex.: 16px"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.titlefontsize,
                              disabled: isDisabled,
                              name: "templateFonts.titlefontsize",
                            })}
                          ></TextField>
                        </Grid>
                        {!isWhiteBoardFamily && (
                        <Grid item md={4} xs={12}>
                          <FontFamilySelect
                            availableFonts={currentSemanticTemplate?.userCustomizable?.vars?.templateFonts?.availableFonts?.default}
                            label="TitleFontFamily"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.titlefontfamily,
                              disabled: isDisabled,
                              name: "templateFonts.titlefontfamily",
                            })}
                          ></FontFamilySelect>
                        </Grid>
                        )}
                        <Grid item md={2} style={{ display: isWhiteBoardFamily ? "none" : "block" }} xs={3} >
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"TextFontSize"}
                            placeholder="ex.: 16px"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.textfontsize,
                              disabled: isDisabled,
                              name: "templateFonts.textfontsize",
                            })}
                          ></TextField>
                        </Grid>
                        {!isWhiteBoardFamily && (
                        <Grid item md={4} xs={12}>
                          <FontFamilySelect
                            availableFonts={currentSemanticTemplate?.userCustomizable?.vars?.templateFonts?.availableFonts?.default}
                            label="TextFontFamily"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.textfontfamily,
                              disabled: isDisabled,
                              name: "templateFonts.textfontfamily",
                            })}
                          ></FontFamilySelect>
                        </Grid>
                        )}
                        <Grid item md={2} style={{ display: isWhiteBoardFamily ? "none" : "block" }} xs={3}>
                          <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            label={"CtaFontSize"}
                            placeholder="ex.: 16px"
                            variant="outlined"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.ctafontsize,
                              disabled: isDisabled,
                              name: "templateFonts.ctafontsize",
                            })}
                          ></TextField>
                        </Grid>
                        <Grid item md={4} style={{ display: isWhiteBoardFamily ? "none" : "block" }} xs={12}>
                          <FontFamilySelect
                            availableFonts={currentSemanticTemplate?.userCustomizable?.vars?.templateFonts?.availableFonts?.default}
                            label="CtaFontFamily"
                            {...getFieldProps(formik, {
                              defaultValue:
                                formik.values.templateFonts.ctafontfamily,
                              disabled: isDisabled,
                              name: "templateFonts.ctafontfamily",
                            })}
                          ></FontFamilySelect>
                        </Grid>
                        {!isWhiteBoardFamily && currentSemanticTemplate?.userCustomizable?.availableAnimations && !currentSemanticTemplate?.userCustomizable?.disableAnimationPropertiesFields?.default && (
                          <>
                            <Grid item md={4} xs={12}>
                              <AnimationSelect
                                availableAnimations={currentSemanticTemplate?.userCustomizable?.availableAnimations ?? []}
                                label="Animation"
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.animationId,
                                  disabled: isDisabled,
                                  name: "animationId",
                                })}
                              ></AnimationSelect>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label={"Animation Color"}
                                placeholder="#HexColorCode"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.animationColor,
                                  disabled: isDisabled,
                                  name: "animationColor",
                                })}
                              ></TextField>
                            </Grid>

                            {/*<Grid item md={2} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label={"Animation Speed"}
                                placeholder="1"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.animationSpeed,
                                  disabled: isDisabled,
                                  name: "animationSpeed",
                                })}
                              ></TextField>
                            </Grid>

                            <Grid item md={2} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label={"CSS Animation Start Delay"}
                                placeholder="0 (in seconds)"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.cssAnimationStartDelay ?? animationTemplates?.[formik.values.animationId]?.lottieProperties?.cssAnimationStartDelay ?? null,
                                  disabled: isDisabled,
                                  name: "cssAnimationStartDelay",
                                })}
                              ></TextField>
                            </Grid>

                            <Grid item md={2} xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    disabled={isDisabled}
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.animationLoop ?? animationTemplates?.[formik.values.animationId]?.lottieProperties?.loop ?? false,
                                      disabled: isDisabled,
                                      name: "animationLoop",
                                    })}
                                  />
                                }
                                label="Loop animation"
                              />
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    disabled={isDisabled}
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.animationPlayReverse ?? animationTemplates?.[formik.values.animationId]?.lottieProperties?.direction ?? false,
                                      disabled: isDisabled,
                                      name: "animationPlayReverse",
                                    })}
                                  />
                                }
                                label="Play animation in reverse"
                              />
                            </Grid>*/}
                          </>
                        )}

                        {!isWhiteBoardFamily && (currentSemanticTemplate?.isShadow !== undefined && currentSemanticTemplate?.tFamilyId === "fam-4ce490f9-30c2-4f85-8ca7-251101203fc6") && (
                          <Grid item md={4} xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={formik.values.image1Shadow || false}
                                  color="primary"
                                  disabled={isDisabled}
                                  {...getFieldProps(formik, {
                                    defaultValue:
                                      formik.values.image1Shadow,
                                    disabled: isDisabled,
                                    name: "image1Shadow",
                                  })}
                                />
                              }
                              label="Image1 Shadow"
                            />
                          </Grid> 
                        )}
                      </Grid>
                    </Grid>
                  )}
                  {/* Feature removed in task Simplify UI of tip creation in content portal (24-01-2024)
              {formik.values.isFirstInFlow && (
                <Grid item xs={12}>
                  <Grid container spacing={2}>

                     <Grid item xs={12}>
                      <Typography variant="h6">
                        Card-Preview settings
                      </Typography>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <SemanticPreviewTemplateSelect
                        defaultsemanticpreviewtemplateid={
                          semanticTemplates?.[0]
                            ?.defaultSemanticPreviewTemplateId
                        }
                        label="Card-Preview Type"
                        // selectedFamily={formik.values.familyTemplate}
                        {...getFieldProps(formik, {
                          disabled:
                            semanticTemplateCatalogue?.length <= 0 ||
                            !semanticTemplates ||
                            !semanticTemplates.length ||
                            !semanticPreviewTemplateCatalogue,
                          name: "semanticPreview.semanticPreviewTemplateId",
                          required: formik.values.isFirstInFlow,
                        })}
                        semanticpreviewtemplatecatalogue={
                          semanticPreviewTemplateCatalogue
                        }
                      ></SemanticPreviewTemplateSelect>
                    </Grid>
                    {/* {getFieldProps(formik, { name: "templateFamilyId" })
                      .value === LEGACY_TEMPLATEFAMILY_ID &&
                    formik.values.type !== "PRIME" ? (
                      <Grid item md={6} xs={12}>
                        <Alert severity="info">
                          Note: by default there are <b>no previews</b> for{" "}
                          <b>nudges</b> in <b>Legacy</b> template family
                        </Alert>
                      </Grid>
                    ) : (
                      ""
                    )} */}
                  {/* {formik.values.templateFamilyId &&
                    formik.values.semanticTemplateId &&
                    formik.values.semanticPreview?.semanticPreviewTemplateId &&
                    semanticPreviewTemplateCatalogue.filter(
                      (t) =>
                        t.templateId ===
                          formik.values.semanticPreview
                            .semanticPreviewTemplateId && t.isActive === true
                    ).length <= 0 ? (
                      <Grid item md={6} xs={12}>
                        <Alert severity="warning">
                          Warning: incompatible Card-Template & Card-Preview
                          type
                        </Alert>
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid item xs={12}>
                      <MarkdownEditorV2
                        error={false}
                        placeHolder={`Card-Preview title`}
                        onChange={(val) =>
                          formik.setFieldValue("semanticPreview.title", val)
                        }
                        value={formik.values.semanticPreview?.title}
                      />
                      <FormHelperText>
                        This field has no character limit. For a better result,
                        we suggest a length around 14 characters. Your title is
                        currently{" "}
                        {removeMarkdown(
                          formik.values.semanticPreview.title || ""
                        )?.length ?? 0}{" "}
                        characters long.
                      </FormHelperText>
                    </Grid>
                    <Grid item md={2} xs={3}>
                      <TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label={"Preview TitleFontSize"}
                        placeholder="ex.: 16px"
                        variant="outlined"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.semanticPreview.titlefontsize,
                          disabled: isDisabled,
                          name: "semanticPreview.titlefontsize",
                        })}
                      ></TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FontFamilySelect
                        label="Preview TitleFontFamily"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.semanticPreview.titlefontfamily,
                          disabled: isDisabled,
                          name: "semanticPreview.titlefontfamily",
                        })}
                      ></FontFamilySelect>
                    </Grid>

                    <Grid item xs={12}>
                      <>
                        {formik.values.semanticPreview.text}
                        <MarkdownEditorV2
                          error={false}
                          placeHolder={`Deep dive into the ${title}'s topic and showcase the value for the user.`}
                          onChange={(val) =>
                            formik.setFieldValue(
                              "semanticPreview.text",
                              val
                            )
                          }
                          value={formik.values.semanticPreview?.text}
                        />
                        <FormHelperText>
                          This field has no character limit. For a better
                          result, we suggest a length around 60 characters. Your
                          text is currently{" "}
                          {removeMarkdown(
                            formik.values.semanticPreview.text || ""
                          )?.length ?? 0}{" "}
                          characters long.
                        </FormHelperText>
                      </>
                    </Grid>
                    <Grid item md={2} xs={3}>
                      <TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label={"Preview TextFontSize"}
                        placeholder="ex.: 16px"
                        variant="outlined"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.semanticPreview.textfontsize,
                          disabled: isDisabled,
                          name: "semanticPreview.textfontsize",
                        })}
                      ></TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FontFamilySelect
                        label="Preview TextFontFamily"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.semanticPreview.textfontfamily,
                          disabled: isDisabled,
                          name: "semanticPreview.textfontfamily",
                        })}
                      ></FontFamilySelect>
                    </Grid>
                    <Grid item md={4}></Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        Card-Preview cta settings
                      </Typography>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Input
                        label="Card-Preview CTA text"
                        maxLength={25}
                        placeholder="Be accurate, specific, explicit. Don't be vague."
                        {...getFieldProps(formik, {
                          disabled:
                            isDisabled ||
                            isSemanticPreviewFieldDisabled(
                              "semanticPreview.cta1Text"
                            ),
                          name: "semanticPreview.cta1Text",
                        })}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FontFamilySelect
                        label="Preview CtaFontFamily"
                        {...getFieldProps(formik, {
                          defaultValue:
                            formik.values.semanticPreview.ctafontfamily,
                          disabled: isDisabled,
                          name: "semanticPreview.ctafontfamily",
                        })}
                      ></FontFamilySelect>
                    </Grid>
                  </Grid>
                </Grid>
              )} */}
                  {(formik.values.viewType === "client" && !currentSemanticTemplate?.userCustomizable?.disableCloseButtonOptionInContentPortal?.default) && (
                    <Grid item xs={isWhiteBoardFamily ? 4 : 6}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                {...getFieldProps(formik, {
                                  defaultValue: true,
                                  name: "showX",
                                })}
                                checked={
                                  getFieldProps(formik, {
                                    name: "showX",
                                  }).value
                                }
                              />
                            }
                            label={`Show the X to close the message`}
                          />
                        </Grid>
                        {isWhiteBoardFamily && formik.values.showX && (
                          <>
                            <Grid item md={isWhiteBoardFamily ? 6 : 3} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label="Close Position X"
                                placeholder="ex.: 33px"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue: formik.values.closeposx,
                                  name: "closeposx",
                                })}
                              ></TextField>
                            </Grid>
                            <Grid item md={isWhiteBoardFamily ? 6 : 3} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label="Close Position Y"
                                placeholder="ex.: 32px"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  defaultValue: formik.values.closeposy,
                                  name: "closeposy",
                                })}
                              ></TextField>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {/* Image1 and Image2 selectors for specific template family (Family2, EasyPop, teams) */}
                        {!isWhiteBoardFamily && (currentSemanticTemplate?.userCustomizable?.image1 || currentSemanticTemplate?.userCustomizable?.images?.image1) && (
                          <>
                            <Grid item style={{ display: (formik.values?.viewType === "client" ? currentSemanticTemplate?.userCustomizable?.images?.image1?.hidden : currentSemanticTemplate?.userCustomizable?.image1?.hidden) ? "none" : "block" }} xs={6}>
                              <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                  <Typography variant="subtitle2">
                                    {currentSemanticTemplate?.userCustomizable?.images?.image1?.title || "IMAGE1"}
                                  </Typography>
                                </Grid>
                              </Grid>

                              {(() => {
                                const isImage1Disabled = formik.values?.viewType === "teams_app" 
                                  ? ((!currentSemanticTemplate?.userCustomizable?.image1 || currentSemanticTemplate?.userCustomizable?.image1?.disabled) || false)
                                  : (currentSemanticTemplate?.userCustomizable?.images?.image1?.disabled || false);
                                
                                return (
                                  <><ImageUpload
                                    showGalleryButton
                                    buttonProps={memoizedImageUploadButtonProps}
                                    caption={memoizedImageUploadCaption}
                                    customPathInfo={memoizedImageUploadCustomPathInfo}
                                    disabled={isDisabled || isImage1Disabled}
                                    galleryFieldName="image1"
                                    initialCropHeight={formik.values?.viewType === "client" ? formik.values?.image1height : formik.values?.teams?.image1Height}
                                    initialCropWidth={formik.values?.viewType === "client" ? formik.values?.image1width : formik.values?.teams?.image1Width}
                                    originalImage={formik.values?.viewType === "client"
                                      ? formik.values?.images?.image1Original
                                      : formik.values?.teams?.image1Original}
                                    showEditButton={true}
                                    styles={memoizedImageUploadStyles}
                                    value={formik.values?.viewType === "client"
                                      ? formik.values?.images?.image1
                                      : formik.values?.teams?.image1}
                                    onChange={handleImageChangeImage1}
                                    onReset={handleImageResetImage1}
                                  />
                                    <Grid container spacing={2} style={{ marginTop: "10px" }}>
                                      <Grid container item spacing={2}>
                                        <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image1width?.hidden ? "none" : "block" }} xs={12}>
                                          <TextField
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...(() => {
                                              const fieldName = formik.values?.viewType === "client" ? "image1width" : "teams.image1Width";
                                              const formikFieldId = formik.values?.viewType === "client" ? "image1" : "teams.image1";
                                              const fieldProps = getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image1width : formik.values?.teams?.image1Width,
                                                disabled: isDisabled || isImage1Disabled,
                                                name: fieldName,
                                              });
                                              const shouldApplyAspectRatio = maintainAspectRatioImage1 && formik.values?.viewType === "teams_app" && formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                              return {
                                                ...fieldProps,
                                                onChange: shouldApplyAspectRatio
                                                  ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, true)
                                                  : fieldProps.onChange,
                                              };
                                            })()}
                                            label="Image1 Width"
                                            placeholder="ex.: 16px"
                                            variant="outlined"
                                            
                                          ></TextField>
                                        </Grid>
                                        <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image1height?.hidden ? "none" : "block" }} xs={12}>
                                          <TextField
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...(() => {
                                              const fieldName = formik.values?.viewType === "client" ? "image1height" : "teams.image1Height";
                                              const formikFieldId = formik.values?.viewType === "client" ? "image1" : "teams.image1";
                                              const fieldProps = getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image1height : formik.values?.teams?.image1Height,
                                                disabled: isDisabled || isImage1Disabled,
                                                name: fieldName,
                                              });
                                              const shouldApplyAspectRatio = maintainAspectRatioImage1 && formik.values?.viewType === "teams_app" && formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                              return {
                                                ...fieldProps,
                                                onChange: shouldApplyAspectRatio
                                                  ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, false)
                                                  : fieldProps.onChange,
                                              };
                                            })()}
                                            label="Image1 Height"
                                            placeholder="ex.: 16px"
                                            variant="outlined"
                                          ></TextField>
                                        </Grid>
                                        {formik.values?.viewType === "teams_app" && formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e" && (
                                          <Grid item xs={12}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={maintainAspectRatioImage1}
                                                  color="primary"
                                                  disabled={isDisabled || isImage1Disabled}
                                                  onChange={(e) => setMaintainAspectRatioImage1(e.target.checked)}
                                                />
                                              }
                                              label="Maintain Aspect Ratio"
                                            />
                                          </Grid>
                                        )}
                                      </Grid>

                                      {formik.values?.viewType === "client" && (
                                        <Grid container item spacing={2}>
                                          <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image1left?.hidden ? "none" : "block" }} xs={12}>
                                            <TextField
                                              fullWidth
                                              InputLabelProps={{ shrink: true }}
                                              {...getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image1left : formik.values?.teams?.image1Left,
                                                disabled: isDisabled || isImage1Disabled || currentSemanticTemplate?.userCustomizable?.image1left?.disabled,
                                                name: formik.values?.viewType === "client" ? "image1left" : "teams.image1Left",
                                              })}
                                              label="Image1 X"
                                              placeholder="ex.: 16px"
                                              variant="outlined"
                                            ></TextField>
                                          </Grid>

                                          <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image1top?.hidden ? "none" : "block" }} xs={12}>
                                            <TextField
                                              fullWidth
                                              InputLabelProps={{ shrink: true }}
                                              {...getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image1top : formik.values?.teams?.image1Top,
                                                disabled: isDisabled || isImage1Disabled || currentSemanticTemplate?.userCustomizable?.image1top?.disabled,
                                                name: formik.values?.viewType === "client" ? "image1top" : "teams.image1Top",
                                              })}
                                              label="Image1 Y"
                                              placeholder="ex.: 16px"
                                              variant="outlined"
                                            ></TextField>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid></>
                                );
                                })()}
                            </Grid>
                          </>
                        )}
                        {!isWhiteBoardFamily && (currentSemanticTemplate?.userCustomizable?.image2 || currentSemanticTemplate?.userCustomizable?.images?.image2) && (
                          <>
                            <Grid item style={{ display: (formik.values?.viewType === "client" ? currentSemanticTemplate?.userCustomizable?.images?.image2?.hidden : currentSemanticTemplate?.userCustomizable?.image2?.hidden) ? "none" : "block" }} xs={6}>
                              <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                  <Typography variant="subtitle2">
                                    {currentSemanticTemplate?.userCustomizable?.images?.image2?.title || "IMAGE2"}
                                  </Typography>
                                </Grid>
                              </Grid>
                              {(() => {
                                const isImage2Disabled = formik.values?.viewType === "teams_app" 
                                  ? ((!currentSemanticTemplate?.userCustomizable?.image2 || currentSemanticTemplate?.userCustomizable?.image2?.disabled) || false)
                                  : (currentSemanticTemplate?.userCustomizable?.images?.image2?.disabled || false);

                                return (
                                  <><ImageUpload
                                    showGalleryButton
                                    buttonProps={memoizedImageUploadButtonProps}
                                    caption={memoizedImageUploadCaption}
                                    customPathInfo={memoizedImageUploadCustomPathInfo}
                                    disabled={isDisabled || isImage2Disabled}
                                    galleryFieldName="image2"
                                    initialCropHeight={formik.values?.viewType === "client" ? formik.values?.image2height : formik.values?.teams?.image2Height}
                                    initialCropWidth={formik.values?.viewType === "client" ? formik.values?.image2width : formik.values?.teams?.image2Width}
                                    originalImage={formik.values?.viewType === "client"
                                    ? formik.values?.images?.image2Original
                                    : formik.values?.teams?.image2Original}
                                    showEditButton={true}
                                    styles={memoizedImageUploadStyles}
                                    value={formik.values?.viewType === "client"
                                      ? formik.values?.images?.image2
                                      : formik.values?.teams?.image2}
                                    onChange={handleImageChangeImage2}
                                    onReset={handleImageResetImage2}
                                  /><Grid container spacing={2} style={{ marginTop: "10px" }}>
                                      <Grid container item spacing={2}>
                                        <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image2width?.hidden ? "none" : "block" }} xs={12}>
                                          <TextField
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...(() => {
                                              const fieldName = formik.values?.viewType === "client" ? "image2width" : "teams.image2Width";
                                              const formikFieldId = formik.values?.viewType === "client" ? "image2" : "teams.image2";
                                              const fieldProps = getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image2width : formik.values?.teams?.image2Width,
                                                disabled: isDisabled || isImage2Disabled,
                                                name: fieldName,
                                              });
                                              const shouldApplyAspectRatio = maintainAspectRatioImage2 && formik.values?.viewType === "teams_app" && formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                              return {
                                                ...fieldProps,
                                                onChange: shouldApplyAspectRatio
                                                  ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, true)
                                                  : fieldProps.onChange,
                                              };
                                            })()}
                                            label="Image2 Width"
                                            placeholder="ex.: 16px"
                                            variant="outlined"
                                          ></TextField>
                                        </Grid>
                                        <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image2height?.hidden ? "none" : "block" }} xs={12}>
                                          <TextField
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            {...(() => {
                                              const fieldName = formik.values?.viewType === "client" ? "image2height" : "teams.image2Height";
                                              const formikFieldId = formik.values?.viewType === "client" ? "image2" : "teams.image2";
                                              const fieldProps = getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image2height : formik.values?.teams?.image2Height,
                                                disabled: isDisabled || isImage2Disabled,
                                                name: fieldName,
                                              });
                                              const shouldApplyAspectRatio = maintainAspectRatioImage2 && formik.values?.viewType === "teams_app" && formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                              return {
                                                ...fieldProps,
                                                onChange: shouldApplyAspectRatio
                                                  ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, false)
                                                  : fieldProps.onChange,
                                              };
                                            })()}
                                            label="Image2 Height"
                                            placeholder="ex.: 16px"
                                            variant="outlined"
                                          ></TextField>
                                        </Grid>
                                        {formik.values?.viewType === "teams_app" &&  formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e" && (
                                          <Grid item xs={12}>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={maintainAspectRatioImage2}
                                                  color="primary"
                                                  disabled={isDisabled || isImage2Disabled}
                                                  onChange={(e) => setMaintainAspectRatioImage2(e.target.checked)}
                                                />
                                              }
                                              label="Maintain Aspect Ratio"
                                            />
                                          </Grid>
                                        )}
                                      </Grid>

                                      {formik.values?.viewType === "client" && (
                                        <Grid container item spacing={2}>
                                          <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image2left?.hidden ? "none" : "block" }} xs={12}>
                                            <TextField
                                              fullWidth
                                              InputLabelProps={{ shrink: true }}
                                              {...getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image2left : formik.values?.teams?.image2left,
                                                disabled: isDisabled || isImage2Disabled || currentSemanticTemplate?.userCustomizable?.image2left?.disabled,
                                                name: formik.values?.viewType === "client" ? "image2left" : "teams.image2Left",
                                              })}
                                              defaultValue={formik.values?.viewType === "client" ? formik.values?.image2left : formik.values?.teams?.image2left}
                                              label="Image2 X"
                                              placeholder="ex.: 16px"
                                              variant="outlined"
                                            ></TextField>
                                          </Grid>

                                          <Grid item lg={6} style={{ display: currentSemanticTemplate?.userCustomizable?.image2top?.hidden ? "none" : "block" }} xs={12}>
                                            <TextField
                                              fullWidth
                                              InputLabelProps={{ shrink: true }}
                                              {...getFieldProps(formik, {
                                                defaultValue: formik.values?.viewType === "client" ? formik.values?.image2top : formik.values?.teams?.image2top,
                                                disabled: isDisabled || isImage2Disabled || currentSemanticTemplate?.userCustomizable?.image2top?.disabled,
                                                name: formik.values?.viewType === "client" ? "image2top" : "teams.image2Top",
                                              })}
                                              label="Image2 Y"
                                              placeholder="ex.: 16px"
                                              variant="outlined"
                                            ></TextField>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid></>
                                );
                              })()}
                            </Grid>
                          </>
                        )}

                        {formik.values.viewType === "teams_app" &&
                          (formik.values?.teams?.backgroundImage ||
                            formik.values?.teams?.backgroundColor) &&
                          ((!formik.values?.teams?.textColor ||
                            formik.values?.teams?.textColor === "Default") ||
                            (!formik.values?.teams?.titleColor ||
                              formik.values?.teams?.titleColor ===
                                "Default")) && (
                          <Grid item xs={12}>
                            <Alert severity="warning">
                              If you upload a card background image or change the background color, set both 
                              <strong> Text Color</strong> and <strong>Title Color</strong> to a specific value (not Default). In Teams, Default can
                              change between light and dark themes, which may make text less readable or less
                              visible on custom backgrounds.
                            </Alert>
                          </Grid>
                        )}

                        {/* Main image */}
                        <Grid
                          item
                          style={{ display: ((formik.values.viewType === "client" ? currentSemanticTemplate?.userCustomizable?.images?.image?.hidden : currentSemanticTemplate?.userCustomizable?.mainImage?.hidden) || isWhiteBoardFamily) ? "none" : "block" }}
                          xs={formik.values.viewType === "teams_app" ? 6 : 6}
                        >
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <Typography variant="subtitle2">
                                {currentSemanticTemplate?.userCustomizable?.images?.image?.title || "MAIN IMAGE"}
                              </Typography>
                            </Grid>
                          </Grid>
                          {(() => {
                            const isMainImageDisabled = formik.values?.viewType === "teams_app" 
                              ? ((!currentSemanticTemplate?.userCustomizable?.mainImage || currentSemanticTemplate?.userCustomizable?.mainImage?.disabled) || false)
                              : (currentSemanticTemplate?.userCustomizable?.images?.image?.disabled || false);
                            return (
                              <>
                              {formik.values.viewType === "client" && (
                                <ImageUpload
                                  showGalleryButton
                                  buttonProps={memoizedImageUploadButtonProps}
                                  caption={memoizedImageUploadCaption}
                                  customPathInfo={memoizedImageUploadCustomPathInfo}
                                  disabled={isDisabled || isMainImageDisabled}
                                  galleryFieldName="client_image"
                                  originalImage={formik.values?.imageIdOriginal}
                                  showEditButton={true}
                                  styles={memoizedImageUploadStyles}
                                  value={formik.values.imageId}
                                  onChange={handleImageChangeImageID}
                                  onReset={handleImageResetImageID}
                                />
                              )}
                              {formik.values.viewType === "teams_app" && (
                                <ImageUpload
                                  showGalleryButton
                                  buttonProps={memoizedImageUploadButtonProps}
                                  caption={memoizedImageUploadCaption}
                                  customPathInfo={memoizedImageUploadCustomPathInfo}
                                  disabled={isDisabled || isMainImageDisabled}
                                  galleryFieldName="teams_mainImage"
                                  originalImage={formik.values?.teams?.mainImageOriginal}
                                  showEditButton={true}
                                  styles={memoizedImageUploadStyles}
                                  value={formik.values.teams.mainImage}
                                  onChange={handleImageChangeMainImage}
                                  onReset={handleImageResetMainImage}
                                />
                              )}
                              {formik.values.viewType === "teams_app" &&
                                formik.values?.teams?.mainImage && (
                                  <Grid
                                    container
                                    spacing={2}
                                    style={{ marginTop: "10px" }}
                                  >
                                    <Grid item md={3} style={{ display: currentSemanticTemplate?.userCustomizable?.imageWidth?.hidden ? "none" : "block" }} xs={12}>
                                      <TextField
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        {...(() => {
                                          const fieldName = "teams.imageWidth";
                                          const formikFieldId = "teams.image";
                                          const fieldProps = getFieldProps(formik, {
                                            defaultValue: formik.values?.teams?.imageWidth,
                                            disabled: isDisabled || isMainImageDisabled,
                                            name: fieldName,
                                          });
                                          const shouldApplyAspectRatio = maintainAspectRatioMainImage && 
                                            formik.values?.viewType === "teams_app" &&
                                            formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                          return {
                                            ...fieldProps,
                                            onChange: shouldApplyAspectRatio
                                              ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, true)
                                              : fieldProps.onChange,
                                          };
                                        })()}
                                        label="Image Width"
                                        placeholder="ex.: 16px"
                                        variant="outlined"
                                      ></TextField>
                                    </Grid>
                                    <Grid item md={3} style={{ display: currentSemanticTemplate?.userCustomizable?.imageHeight?.hidden ? "none" : "block" }} xs={12}>
                                      <TextField
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        {...(() => {
                                          const fieldName = "teams.imageHeight";
                                          const formikFieldId = "teams.image";
                                          const fieldProps = getFieldProps(formik, {
                                            defaultValue: formik.values?.teams?.imageHeight,
                                            disabled: isDisabled || isMainImageDisabled,
                                            name: fieldName,
                                          });
                                          const shouldApplyAspectRatio = maintainAspectRatioMainImage && 
                                            formik.values?.viewType === "teams_app" &&
                                            formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e";
                                          return {
                                            ...fieldProps,
                                            onChange: shouldApplyAspectRatio
                                              ? handleImageDimensionChange(formik, fieldProps.onChange, formikFieldId, false)
                                              : fieldProps.onChange,
                                          };
                                        })()}
                                        label="Image Height"
                                        placeholder="ex.: 16px"
                                        variant="outlined"
                                      ></TextField>
                                    </Grid>
                                    {formik.values?.viewType === "teams_app" &&
                                      formik.values?.teams?.templateFamilyId === "fam-44197fb8-7a0b-4079-a76f-25210e68db4e" && (
                                        <Grid item xs={12}>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={maintainAspectRatioMainImage}
                                                color="primary"
                                                disabled={isDisabled || isMainImageDisabled}
                                                onChange={(e) => setMaintainAspectRatioMainImage(e.target.checked)}
                                              />
                                            }
                                            label="Maintain Aspect Ratio"
                                          />
                                        </Grid>
                                      )}
                                  </Grid>
                                )}
                              </>
                            );
                          })()}
                        </Grid>

                        {/* Blob background */}
                        {formik.values.viewType === "client" && !isWhiteBoardFamily && (
                          (() => {
                            const isBlobBGDisabled = isDisabled || (currentSemanticTemplate?.userCustomizable?.images?.bg1?.disabled || false);
                            return (
                              <Grid item style={{ display: (formik.values.viewType === "client" ? currentSemanticTemplate?.userCustomizable?.images?.bg1?.hidden : currentSemanticTemplate?.userCustomizable?.backgroundImage?.hidden) ? "none" : "block" }} xs={6}>
                                <Grid container alignItems="center" spacing={1}>
                                  <Grid item>
                                    <Typography variant="subtitle2">
                                    {currentSemanticTemplate?.userCustomizable?.images?.bg1?.title || "BLOB BACKGROUND"}
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <InfoTooltip
                                      text="Scales the image (while preserving its ratio) to the smallest possible size to fill the container (that is: both its height and width completely cover the container), leaving no empty space. If the proportions of the background differ from the element, the image is cropped either vertically or horizontally."
                                      title="Image Dimensions"
                                    />
                                  </Grid>
                                </Grid>
                                <ImageUpload
                                  showGalleryButton
                                  buttonProps={memoizedImageUploadButtonProps}
                                  caption={memoizedImageUploadCaption}
                                  customPathInfo={
                                    memoizedImageUploadCustomPathInfo
                                  }
                                  disabled={isBlobBGDisabled}
                                  galleryFieldName="image_bg1"
                                  originalImage={formik.values?.images?.bg1Original}
                                  showEditButton={true}
                                  styles={memoizedImageUploadStyles}
                                  value={formik.values.images?.bg1}
                                  onChange={handleImageChangeBG1}
                                  onReset={handleImageResetBG1}
                                />
                              </Grid>
                              );
                            })()
                        )}

                        {/* Card background */}
                        {formik.values.viewType === "teams_app" && (
                          <Grid item style={{ display: currentSemanticTemplate?.userCustomizable?.backgroundImage?.hidden ? "none" : "block" }} xs={6}>
                            <Grid container alignItems="center" spacing={1}>
                              <Grid item>
                                <Typography variant="subtitle2">
                                  {currentSemanticTemplate?.userCustomizable?.images?.backgroundImage?.title || "CARD BACKGROUND"}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <InfoTooltip
                                  text="Scales the image (while preserving its ratio) to the smallest possible size to fill the container (that is: both its height and width completely cover the container), leaving no empty space. If the proportions of the background differ from the element, the image is cropped either vertically or horizontally."
                                  title="Image Dimensions"
                                />
                              </Grid>
                            </Grid>
                            <ImageUpload
                              showGalleryButton
                              buttonProps={memoizedImageUploadButtonProps}
                              caption={memoizedImageUploadCaption}
                              customPathInfo={memoizedImageUploadCustomPathInfo}
                              disabled={isDisabled || (currentSemanticTemplate?.userCustomizable?.backgroundImage?.disabled || false)}
                              galleryFieldName="image_background"
                              originalImage={formik.values?.teams?.backgroundImageOriginal}
                              showEditButton={true}
                              styles={memoizedImageUploadStyles}
                              value={formik.values.teams?.backgroundImage}
                              onChange={handleImageChangeBackgroundImage}
                              onReset={handleImageResetBackgroundImage}
                            />
                            {formik.values.viewType === "teams_app" && (
                              <Grid
                                container
                                spacing={2}
                                style={{ marginTop: "10px" }}
                              >
                                <Grid item md={6} xs={6}>
                                  <Grid
                                    container
                                    alignItems="left"
                                    spacing={1}
                                    style={{ flexDirection: "column" }}
                                  >
                                    <Grid item md={12} xs={12}>
                                      <Typography
                                        color="textSecondary"
                                        variant="caption"
                                      >
                                        Background color
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      container
                                      alignItems="center"
                                      spacing={1}
                                      style={{ flexDirection: "row" }}
                                    >
                                      <Grid item md={4} xs={4}>
                                        <input
                                          type="color"
                                          {...getFieldProps(formik, {
                                            disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.backgroundImage?.disabled,
                                            name: "teams.backgroundColor",
                                          })}
                                        ></input>
                                      </Grid>
                                      <Grid item md={5} xs={5}>
                                        <TextField
                                          fullWidth
                                          InputLabelProps={{ shrink: true }}
                                          label={""}
                                          placeholder="#HexCode"
                                          size="small"
                                          variant="outlined"
                                          {...getFieldProps(formik, {
                                            disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.backgroundImage?.disabled,
                                            name: "teams.backgroundColor",
                                          })}
                                        ></TextField>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        )}

                        {/* Card background */}
                        {formik.values.viewType === "client" && (
                          <Grid item style={{ display: currentSemanticTemplate?.userCustomizable?.images?.bg2?.hidden ? "none" : "block" }} xs={6}>
                            <Grid container alignItems="center" spacing={1}>
                              <Grid item>
                                <Typography variant="subtitle2">
                                {currentSemanticTemplate?.userCustomizable?.images?.bg2?.title || "CARD BACKGROUND"}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <InfoTooltip
                                  text="Scales the image (while preserving its ratio) to the smallest possible size to fill the container (that is: both its height and width completely cover the container), leaving no empty space. If the proportions of the background differ from the element, the image is cropped either vertically or horizontally."
                                  title="Image Dimensions"
                                />
                              </Grid>
                            </Grid>
                            <ImageUpload
                              showGalleryButton
                              buttonProps={memoizedImageUploadButtonProps}
                              caption={memoizedImageUploadCaption}
                              customPathInfo={memoizedImageUploadCustomPathInfo}
                              disabled={isDisabled || (currentSemanticTemplate?.userCustomizable?.images?.bg2?.disabled || false)}
                              galleryFieldName="image_bg2"
                              originalImage={formik.values?.images?.bg2Original}
                              showEditButton={true}
                              styles={memoizedImageUploadStyles}
                              value={formik.values.images?.bg2}
                              onChange={handleImageChangeBG2}
                              onReset={handleImageResetBG2}
                            />
                            {isWhiteBoardFamily && formik.values.images?.bg2 && (
                              <Grid container spacing={1} style={{ marginTop: "1rem" }}>
                                <Grid item lg={6} md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    disabled={isDisabled}
                                    inputProps={{ min: 1, max: 800, step: 1 }}
                                    label={"Card height (px)"}
                                    placeholder="ex.: 320"
                                    type="number"
                                    value={
                                      whiteBoardAutoHeightModeRef.current
                                        ? ""
                                        : parsePxToNumber(formik.values.cardheight) ?? ""
                                    }
                                    variant="outlined"
                                    onBlur={handleWhiteBoardCardHeightBlur}
                                    onChange={handleWhiteBoardCardHeightChange}
                                  ></TextField>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormHelperText>
                                    Optional. Max limit is 800px. When set, width is calculated proportionally from the uploaded image
                                  </FormHelperText>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        )}
                    </Grid>
                  </Grid>

                  <Grid item style={{ marginTop: "1rem", zIndex: "0" }} xs={12}>
                    <Grid item style={{ marginBottom: "1.5rem" }} xs={12}>
                      <Typography variant="h3">Message Content</Typography>
                    </Grid>
                    <MarkdownEditorV2
                      autoLink={false}
                      disableBlockTypeSelect={true}
                      disableBoldItalicUnderline={["underline"]}
                      disableCreateLink={true}
                      disableListsToggle={true}
                      error={false}
                      placeHolder={`${title} title - Try to catch the user's attention and introduce the ${title}'s topic.`}
                      showInfoTooltip={true}
                      value={aiResult ? aiResult.title : formik.values.title}
                      onChange={(val) => formik.setFieldValue("title", val)}
                    />
                    {hasUnsupportedMessageTitleMarkdown && (
                      <UnsupportedTeamsMarkdownAlert />
                    )}

                    <FormHelperText>
                      This field has no character limit. For a better result, we
                      suggest a length around 60 characters. Your title is
                      currently{" "}
                      {removeMarkdown(formik.values.title || "")?.length ?? 0}{" "}
                      characters long.
                    </FormHelperText>
                  </Grid>
                  <Grid item style={{ zIndex: "0" }} xs={12}>
                    {formik.values.type === "NUDGE" && (
                      <>
                        <MarkdownEditorV2
                          autoLink={false}
                          disableBlockTypeSelect={true}
                          disableBoldItalicUnderline={["underline"]}
                          disableCreateLink={true}
                          disableListsToggle={true}                          
                          error={false}
                          placeHolder={`${title} title - Enter ${title} text...`}
                          showInfoTooltip={true}
                          value={formik.values.text}
                          onChange={(val) => formik.setFieldValue("text", val)}
                        />
                        {hasUnsupportedMessageTextMarkdown && (
                          <UnsupportedTeamsMarkdownAlert />
                        )}
                      </>
                    )}

                    {formik.values.type === "PRIME" && !isWhiteBoardFamily && (
                      <>
                        <MarkdownEditorV2
                          autoLink={false}
                          disableBlockTypeSelect={true}
                          disableBoldItalicUnderline={["underline"]}
                          disableCreateLink={true}
                          disableListsToggle={true}
                          error={false}
                          placeHolder={`${title} text - Deep dive into the ${title}'s topic and showcase the value for the user.`}
                          showInfoTooltip={true}
                          value={aiResult ? aiResult.text : formik.values.text}
                          onChange={(val) => formik.setFieldValue("text", val)}
                        />
                        {hasUnsupportedMessageTextMarkdown && (
                          <UnsupportedTeamsMarkdownAlert />
                        )}
                        <FormHelperText>
                          This field has no character limit. For a better
                          result, we suggest a length around 250 characters.
                          Your text is currently{" "}
                          {removeMarkdown(formik.values.text || "")?.length ??
                            0}{" "}
                          characters long.
                        </FormHelperText>
                      </>
                    )}
                  </Grid>
                  {(interaction.type === "PRIME" ||
                    (interaction.type === "NUDGE" &&
                      (!contentTypeConfig ||
                        contentTypeConfig?.ctaTypes?.length > 1))) && (
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            style={{ marginTop: "1rem" }}
                            variant="h3"
                          >
                            CTA Configuration
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <ToggleButtonGroup
                            exclusive
                            size="small"
                            value={formik.values.ctaType}
                            onChange={handleTypeChange}
                          >
                            {(interaction.type === "PRIME" ||
                              (interaction.type === "NUDGE" &&
                                (!contentTypeConfig ||
                                  contentTypeConfig?.ctaTypes.includes(
                                    "CTA"
                                  )))) && (
                              <ToggleButton disabled={isDisabled} value="CTA">
                                Single CTA
                              </ToggleButton>
                            )}

                            {(interaction.type === "PRIME" ||
                              (interaction.type === "NUDGE" &&
                                (!contentTypeConfig ||
                                  contentTypeConfig?.ctaTypes.includes(
                                    "DOUBLE_CTA"
                                  )))) && (
                              <ToggleButton
                                disabled={isDisabled}
                                value="DOUBLE_CTA"
                              >
                                Double CTA
                              </ToggleButton>
                            )}

                            <ToggleButton
                              disabled={isDisabled || currentSemanticTemplate?.userCustomizable?.disableDropdownCTA}
                              style={{ display: currentSemanticTemplate?.userCustomizable?.disableDropdownCTA?.hidden ? "none" : "block" }}
                              value="DROPDOWN"
                            >
                              Dropdown menu
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Grid>
                        
                        {formik.values.viewType === "teams_app" && formik.values.teams.templateFamilyId === "fam-038da0d7-6481-4368-b1f4-a692e34929d2" && (
                          <Grid item md={3} xs={12}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              {...getFieldProps(formik, {
                                name: "teams.ctaHorizontalAlignment",
                                required: true,
                              })}
                              label={"CTA Horizontal Alignment"}
                              variant="outlined"
                              {...props}
                            >
                              <MenuItem value="left">Left</MenuItem>
                              <MenuItem value="center">Center</MenuItem>
                              <MenuItem value="right">Right</MenuItem>
                            </TextField>
                          </Grid>
                        )}
                        
                        {formik.values.viewType === "teams_app" &&
                          formik.values.teams.templateFamilyId === "fam-038da0d7-6481-4368-b1f4-a692e34929d2" &&
                          formik.values.teams?.ctaHorizontalAlignment === "center" &&
                          (formik.values.cta1Text?.length ?? 0) + (formik.values.cta2Text?.length ?? 0) > 25 && (
                          <Grid item xs={12}>
                            <Alert severity="warning">
                              CTA text is too long. With center alignment, both buttons may no longer fit on one line and the second button will appear on a new line. Keep the total length of both CTAs under 25 characters for best results.
                            </Alert>
                          </Grid>
                        )}

                        {currentSemanticTemplate?.userCustomizable?.ctashorizontalalignment?.disabled === false && (
                          <Grid item md={4} xs={12}>
                            <TextField
                                fullWidth
                                select
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled || currentSemanticTemplate?.userCustomizable?.ctashorizontalalignment?.disabled}
                                label={"CTA Position"}
                                {...getFieldProps(formik, {
                                  defaultValue:
                                    formik.values.ctashorizontalalignment,
                                  disabled: isDisabled || currentSemanticTemplate?.userCustomizable?.ctashorizontalalignment?.disabled,
                                  name: "ctashorizontalalignment",
                                })}
                                variant="outlined"
                              >
                                <MenuItem key={"left"} value={"left"}>
                                  Left
                                </MenuItem>
                                <MenuItem key={"center"} value={"center"}>
                                  Center
                                </MenuItem>
                                <MenuItem key={"right"} value={"right"}>
                                  Right
                                </MenuItem>
                              </TextField>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  )}
                  {isWhiteBoardFamily &&
                    (formik.values.ctaType === "CTA" ||
                      formik.values.ctaType === "DOUBLE_CTA" ||
                      formik.values.ctaType === "DROPDOWN") && (
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography variant="subtitle2">CTA Picture</Typography>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <ImageUpload
                              showGalleryButton
                              buttonProps={memoizedImageUploadButtonProps}
                              caption={memoizedImageUploadCaption}
                              customPathInfo={memoizedImageUploadCustomPathInfo}
                              disabled={isDisabled}
                              galleryFieldName="image_cta"
                              originalImage={formik.values?.images?.ctaOriginal}
                              showEditButton={true}
                              styles={memoizedImageUploadStyles}
                              value={formik.values.images?.cta}
                              onChange={handleImageChangeCTA}
                              onReset={handleImageResetCTA}
                            />
                          </Grid>
                          {formik.values.images?.cta && (
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                inputProps={{ min: 1, max: 800, step: 1 }}
                                label={"CTA Picture height (px)"}
                                placeholder="ex.: 48"
                                type="number"
                                value={
                                  whiteBoardAutoCtaHeightModeRef.current
                                    ? ""
                                    : parsePxToNumber(formik.values.ctapictureheight) ?? ""
                                }
                                variant="outlined"
                                onBlur={handleWhiteBoardCtaPictureHeightBlur}
                                onChange={handleWhiteBoardCtaPictureHeightChange}
                              ></TextField>
                            </Grid>
                          )}
                          {formik.values.ctaType === "DOUBLE_CTA" && (
                            <>
                              <Grid item xs={12}>
                                <Typography variant="subtitle2">CTA 2 Picture</Typography>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <ImageUpload
                                  showGalleryButton
                                  buttonProps={memoizedImageUploadButtonProps}
                                  caption={memoizedImageUploadCaption}
                                  customPathInfo={memoizedImageUploadCustomPathInfo}
                                  disabled={isDisabled}
                                  galleryFieldName="image_cta2"
                                  originalImage={formik.values?.images?.cta2Original}
                                  showEditButton={true}
                                  styles={memoizedImageUploadStyles}
                                  value={formik.values.images?.cta2}
                                  onChange={handleImageChangeCTA2}
                                  onReset={handleImageResetCTA2}
                                />
                              </Grid>
                              {formik.values.images?.cta2 && (
                                <Grid item md={3} xs={12}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    disabled={isDisabled}
                                    inputProps={{ min: 1, max: 800, step: 1 }}
                                    label={"CTA 2 Picture height (px)"}
                                    placeholder="ex.: 48"
                                    type="number"
                                    value={
                                      whiteBoardAutoCta2HeightModeRef.current
                                        ? ""
                                        : parsePxToNumber(formik.values.cta2pictureheight) ?? ""
                                    }
                                    variant="outlined"
                                    onBlur={handleWhiteBoardCta2PictureHeightBlur}
                                    onChange={handleWhiteBoardCta2PictureHeightChange}
                                  ></TextField>
                                </Grid>
                              )}
                            </>
                          )}
                          <Grid item xs={12}>
                            <Typography variant="subtitle2">
                              CTA 1 style
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={formik.values.ctashadow !== "none"}
                                  color="primary"
                                  onChange={(event) => {
                                    const nextValue = event.target.checked
                                      ? whiteBoardCtaShadowEnabledValue
                                      : "none";
                                    formik.setFieldValue("ctashadow", nextValue);
                                    formik.setFieldTouched("ctashadow", true);
                                  }}
                                />
                              }
                              label="Enable/Disable Shadow"
                            />
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label={"CtaFontSize"}
                              placeholder="ex.: 16px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.templateFonts.ctafontsize,
                                disabled: isDisabled,
                                name: "templateFonts.ctafontsize",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <FontFamilySelect
                              availableFonts={currentSemanticTemplate?.userCustomizable?.vars?.templateFonts?.availableFonts?.default}
                              label="CtaFontFamily"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.templateFonts.ctafontfamily,
                                disabled: isDisabled,
                                name: "templateFonts.ctafontfamily",
                              })}
                            ></FontFamilySelect>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label={"ColorCTAtext"}
                              placeholder="#HexColorCode"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.templateColors.color1cta,
                                disabled:
                                  isDisabled ||
                                  currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color1cta?.disabled,
                                name: "templateColors.color1cta",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label={"ColorCTABackground"}
                              placeholder="#HexColorCode"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.templateColors.color2cta,
                                disabled:
                                  isDisabled ||
                                  currentSemanticTemplate?.userCustomizable?.vars?.rootCssVars?.color2cta?.disabled,
                                name: "templateColors.color2cta",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="CtaStrokeColor"
                              placeholder="#B9B9B9"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctastrokecolor,
                                disabled: isDisabled,
                                name: "ctastrokecolor",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="CtaStrokeWidth"
                              placeholder="ex.: 1px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctastrokewidth,
                                disabled: isDisabled,
                                name: "ctastrokewidth",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="CTA width"
                              placeholder="ex.: 180px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctawidth,
                                disabled: isDisabled,
                                name: "ctawidth",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="CTA height"
                              placeholder="ex.: 40px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctaheight,
                                disabled: isDisabled,
                                name: "ctaheight",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              label="CTA Position"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctaposition,
                                disabled: isDisabled,
                                name: "ctaposition",
                              })}
                            >
                              <MenuItem value="left">Left</MenuItem>
                              <MenuItem value="right">Right</MenuItem>
                              <MenuItem value="center">Center</MenuItem>
                              <MenuItem value="custom">Custom</MenuItem>
                            </TextField>
                          </Grid>
                          {formik.values.ctaposition === "custom" && (
                            <>
                              <Grid item md={2} xs={3}>
                                <TextField
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  label="CTA Position X"
                                  placeholder="ex.: 20px"
                                  variant="outlined"
                                  {...getFieldProps(formik, {
                                    defaultValue: formik.values.ctaposx,
                                    disabled: isDisabled,
                                    name: "ctaposx",
                                  })}
                                ></TextField>
                              </Grid>
                              <Grid item md={2} xs={3}>
                                <TextField
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  label="CTA Position Y"
                                  placeholder="ex.: 20px"
                                  variant="outlined"
                                  {...getFieldProps(formik, {
                                    defaultValue: formik.values.ctaposy,
                                    disabled: isDisabled,
                                    name: "ctaposy",
                                  })}
                                ></TextField>
                              </Grid>
                            </>
                          )}
                          <Grid item xs={12}>
                            <Typography variant="subtitle2">Corner shape</Typography>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              label="Top Left Type"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornertoplefttype,
                                disabled: isDisabled,
                                name: "ctacornertoplefttype",
                              })}
                            >
                              <MenuItem value="Cut">Cut</MenuItem>
                              <MenuItem value="Round">Round</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="Top Left"
                              placeholder="ex.: 8px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornertopleftvalue,
                                disabled: isDisabled,
                                name: "ctacornertopleftvalue",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              label="Top Right Type"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornertoprighttype,
                                disabled: isDisabled,
                                name: "ctacornertoprighttype",
                              })}
                            >
                              <MenuItem value="Cut">Cut</MenuItem>
                              <MenuItem value="Round">Round</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="Top Right"
                              placeholder="ex.: 8px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornertoprightvalue,
                                disabled: isDisabled,
                                name: "ctacornertoprightvalue",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item xs={12}></Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              label="Bottom Left Type"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornerbottomlefttype,
                                disabled: isDisabled,
                                name: "ctacornerbottomlefttype",
                              })}
                            >
                              <MenuItem value="Cut">Cut</MenuItem>
                              <MenuItem value="Round">Round</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="Bottom Left"
                              placeholder="ex.: 8px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue: formik.values.ctacornerbottomleftvalue,
                                disabled: isDisabled,
                                name: "ctacornerbottomleftvalue",
                              })}
                            ></TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              select
                              InputLabelProps={{ shrink: true }}
                              label="Bottom Right Type"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue:
                                  formik.values.ctacornerbottomrighttype,
                                disabled: isDisabled,
                                name: "ctacornerbottomrighttype",
                              })}
                            >
                              <MenuItem value="Cut">Cut</MenuItem>
                              <MenuItem value="Round">Round</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={2} xs={3}>
                            <TextField
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              label="Bottom Right"
                              placeholder="ex.: 8px"
                              variant="outlined"
                              {...getFieldProps(formik, {
                                defaultValue:
                                  formik.values.ctacornerbottomrightvalue,
                                disabled: isDisabled,
                                name: "ctacornerbottomrightvalue",
                              })}
                            ></TextField>
                          </Grid>
                          {formik.values.ctaType === "DOUBLE_CTA" && (
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    {...getFieldProps(formik, {
                                      defaultValue: true,
                                      name: "applysamectastyle",
                                    })}
                                    checked={
                                      getFieldProps(formik, {
                                        name: "applysamectastyle",
                                      }).value
                                    }
                                  />
                                }
                                label="Apply same style for both CTAs"
                              />
                            </Grid>
                          )}
                          {formik.values.ctaType === "DOUBLE_CTA" &&
                            !formik.values.applysamectastyle && (
                              <>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle2">
                                    CTA 2 style
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formik.values.cta2shadow !== "none"}
                                        color="primary"
                                        onChange={(event) => {
                                          const nextValue = event.target.checked
                                            ? whiteBoardCtaShadowEnabledValue
                                            : "none";
                                          formik.setFieldValue("cta2shadow", nextValue);
                                          formik.setFieldTouched("cta2shadow", true);
                                        }}
                                      />
                                    }
                                    label="Enable/Disable Shadow"
                                  />
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label={"CtaFontSize"}
                                    placeholder="ex.: 16px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2fontsize,
                                      disabled: isDisabled,
                                      name: "cta2fontsize",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <FontFamilySelect
                                    availableFonts={currentSemanticTemplate?.userCustomizable?.vars?.templateFonts?.availableFonts?.default}
                                    label="CtaFontFamily"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2fontfamily,
                                      disabled: isDisabled,
                                      name: "cta2fontfamily",
                                    })}
                                  ></FontFamilySelect>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label={"ColorCTAtext"}
                                    placeholder="#HexColorCode"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2colortext,
                                      disabled: isDisabled,
                                      name: "cta2colortext",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label={"ColorCTABackground"}
                                    placeholder="#HexColorCode"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2colorbackground,
                                      disabled: isDisabled,
                                      name: "cta2colorbackground",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="CtaStrokeColor"
                                    placeholder="#B9B9B9"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2strokecolor,
                                      disabled: isDisabled,
                                      name: "cta2strokecolor",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="CtaStrokeWidth"
                                    placeholder="ex.: 1px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2strokewidth,
                                      disabled: isDisabled,
                                      name: "cta2strokewidth",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="CTA width"
                                    placeholder="ex.: 180px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2width,
                                      disabled: isDisabled,
                                      name: "cta2width",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="CTA height"
                                    placeholder="ex.: 40px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2height,
                                      disabled: isDisabled,
                                      name: "cta2height",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    select
                                    InputLabelProps={{ shrink: true }}
                                    label="CTA Position"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue: formik.values.cta2position,
                                      disabled: isDisabled,
                                      name: "cta2position",
                                    })}
                                  >
                                    <MenuItem value="left">Left</MenuItem>
                                    <MenuItem value="right">Right</MenuItem>
                                    <MenuItem value="center">Center</MenuItem>
                                    <MenuItem value="custom">Custom</MenuItem>
                                  </TextField>
                                </Grid>
                                {formik.values.cta2position === "custom" && (
                                  <>
                                    <Grid item md={2} xs={3}>
                                      <TextField
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        label="CTA Position X"
                                        placeholder="ex.: 20px"
                                        variant="outlined"
                                        {...getFieldProps(formik, {
                                          defaultValue: formik.values.cta2posx,
                                          disabled: isDisabled,
                                          name: "cta2posx",
                                        })}
                                      ></TextField>
                                    </Grid>
                                    <Grid item md={2} xs={3}>
                                      <TextField
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        label="CTA Position Y"
                                        placeholder="ex.: 20px"
                                        variant="outlined"
                                        {...getFieldProps(formik, {
                                          defaultValue: formik.values.cta2posy,
                                          disabled: isDisabled,
                                          name: "cta2posy",
                                        })}
                                      ></TextField>
                                    </Grid>
                                  </>
                                )}
                                <Grid item xs={12}>
                                  <Typography variant="subtitle2">Corner shape</Typography>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    select
                                    InputLabelProps={{ shrink: true }}
                                    label="Top Left Type"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornertoplefttype,
                                      disabled: isDisabled,
                                      name: "cta2cornertoplefttype",
                                    })}
                                  >
                                    <MenuItem value="Cut">Cut</MenuItem>
                                    <MenuItem value="Round">Round</MenuItem>
                                  </TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Top Left"
                                    placeholder="ex.: 8px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornertopleftvalue,
                                      disabled: isDisabled,
                                      name: "cta2cornertopleftvalue",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    select
                                    InputLabelProps={{ shrink: true }}
                                    label="Top Right Type"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornertoprighttype,
                                      disabled: isDisabled,
                                      name: "cta2cornertoprighttype",
                                    })}
                                  >
                                    <MenuItem value="Cut">Cut</MenuItem>
                                    <MenuItem value="Round">Round</MenuItem>
                                  </TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Top Right"
                                    placeholder="ex.: 8px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornertoprightvalue,
                                      disabled: isDisabled,
                                      name: "cta2cornertoprightvalue",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item xs={12}></Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    select
                                    InputLabelProps={{ shrink: true }}
                                    label="Bottom Left Type"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornerbottomlefttype,
                                      disabled: isDisabled,
                                      name: "cta2cornerbottomlefttype",
                                    })}
                                  >
                                    <MenuItem value="Cut">Cut</MenuItem>
                                    <MenuItem value="Round">Round</MenuItem>
                                  </TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Bottom Left"
                                    placeholder="ex.: 8px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornerbottomleftvalue,
                                      disabled: isDisabled,
                                      name: "cta2cornerbottomleftvalue",
                                    })}
                                  ></TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    select
                                    InputLabelProps={{ shrink: true }}
                                    label="Bottom Right Type"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornerbottomrighttype,
                                      disabled: isDisabled,
                                      name: "cta2cornerbottomrighttype",
                                    })}
                                  >
                                    <MenuItem value="Cut">Cut</MenuItem>
                                    <MenuItem value="Round">Round</MenuItem>
                                  </TextField>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label="Bottom Right"
                                    placeholder="ex.: 8px"
                                    variant="outlined"
                                    {...getFieldProps(formik, {
                                      defaultValue:
                                        formik.values.cta2cornerbottomrightvalue,
                                      disabled: isDisabled,
                                      name: "cta2cornerbottomrightvalue",
                                    })}
                                  ></TextField>
                                </Grid>
                              </>
                            )}
                        </Grid>
                      </Grid>
                    )}
                  {formik.values.ctaType === "DROPDOWN" &&
                    formik.values.dropdownData
                      ?.slice(1)
                      .some(
                        ({ ctaType }) =>
                          ctaType && !["Semantic", "Close"].includes(ctaType)
                      ) && (
                      <Grid item xs={12}>
                        <AlertWithShowMore severity="warning">
                          {({ showMore, isShowMore }) => (
                            <>
                              This configuration will not work in teams app.{" "}
                              <Link
                                style={{ cursor: "pointer" }}
                                onClick={showMore}
                              >
                                {isShowMore ? "Hide more" : "Discover more"}
                              </Link>
                              {isShowMore && (
                                <Box pt={3}>
                                  Dropdown options can do one of the following
                                  only: redirecting to another semantic OR
                                  closing.
                                </Box>
                              )}
                            </>
                          )}
                        </AlertWithShowMore>
                      </Grid>
                    )}
                  {[
                    formik.values.cta1Type,
                    formik.values.cta2Type,
                    ...(formik.values.dropdownData || []).map(
                      ({ ctaType }) => ctaType
                    ),
                  ].some((ctaType) =>
                    [
                      "Prompt",
                      "Prompt Tool",
                      "News",
                      "NewsPage",
                      "Dashboard Step",
                      "Bloom Seed",
                      "AI Skilling Prompt",
                      "Cyber Tip",
                    ].includes(ctaType)
                  ) && (
                    <Grid item xs={12}>
                      <Alert severity="warning">
                        The selected CTA action is not supported in preview
                        mode. Save your changes and test in the live environment
                        to verify its behavior.
                      </Alert>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    {formik.values.ctaType === "CTA" && (
                      <CTA
                        aiResult={aiResult}
                        aiSkillingPrompts={aiSkillingPrompts}
                        copilotNews={copilotNews}
                        cyberTipsCdpPrompts={cyberTipsCdpPrompts}
                        formik={formik}
                        handleCreateMaterial={handleCreateMaterial(
                          "cta1LinkId"
                        )}
                        handleCreateSpecialLink={handleCreateSpecialLink(
                          "cta1LinkId"
                        )}
                        interactions={interactions}
                        isCopilotNewsLoading={isCopilotNewsLoading}
                        isDisabled={isDisabled}
                        isListJourneyBenefitsLoading={
                          isListJourneyBenefitsLoading
                        }
                        isListJourneyNewsLoading={isListJourneyNewsLoading}
                        isMaterialsLoading={isMaterialsLoading}
                        isRichTextEnabled={isWhiteBoardFamily}
                        isSpecialLinksLoading={isSpecialLinksLoading}
                        isSurveysLoading={isSurveysLoading}
                        journeyBenefits={journeyBenefits}
                        journeyNews={journeyNews}
                        materials={materials}
                        prompts={prompts}
                        seeds={seeds}
                        specialLinks={specialLinks}
                        steps={journey?.steps ?? []}
                        surveys={surveys}
                        tools={tools}
                        types={contentTypeConfig?.cta1Types}
                        user={user}
                      />
                    )}
                    {formik.values.ctaType === "DOUBLE_CTA" && (
                      <CTA
                        aiResult={aiResult}
                        aiSkillingPrompts={aiSkillingPrompts}
                        copilotNews={copilotNews}
                        cyberTipsCdpPrompts={cyberTipsCdpPrompts}
                        formik={formik}
                        handleCreateMaterial={handleCreateMaterial(
                          "cta1LinkId"
                        )}
                        handleCreateSpecialLink={handleCreateSpecialLink(
                          "cta1LinkId"
                        )}
                        index={1}
                        interactions={interactions}
                        isCopilotNewsLoading={isCopilotNewsLoading}
                        isDisabled={isDisabled}
                        isListJourneyBenefitsLoading={
                          isListJourneyBenefitsLoading
                        }
                        isListJourneyNewsLoading={isListJourneyNewsLoading}
                        isMaterialsLoading={isMaterialsLoading}
                        isRichTextEnabled={isWhiteBoardFamily}
                        isSpecialLinksLoading={isSpecialLinksLoading}
                        journeyBenefits={journeyBenefits}
                        journeyNews={journeyNews}
                        materials={materials}
                        prompts={prompts}
                        seeds={seeds}
                        specialLinks={specialLinks}
                        steps={journey?.steps ?? []}
                        surveys={surveys}
                        tools={tools}
                        types={contentTypeConfig?.cta1Types}
                        user={user}
                      />
                    )}
                    {formik.values.ctaType === "DOUBLE_CTA" && (
                      <CTA
                        aiResult={aiResult}
                        aiSkillingPrompts={aiSkillingPrompts}
                        copilotNews={copilotNews}
                        cyberTipsCdpPrompts={cyberTipsCdpPrompts}
                        formik={formik}
                        handleCreateMaterial={handleCreateMaterial(
                          "cta2LinkId"
                        )}
                        handleCreateSpecialLink={handleCreateSpecialLink(
                          "cta2LinkId"
                        )}
                        index={2}
                        interactions={interactions}
                        isCopilotNewsLoading={isCopilotNewsLoading}
                        isDisabled={isDisabled}
                        isListJourneyBenefitsLoading={
                          isListJourneyBenefitsLoading
                        }
                        isListJourneyNewsLoading={isListJourneyNewsLoading}
                        isMaterialsLoading={isMaterialsLoading}
                        isRichTextEnabled={isWhiteBoardFamily}
                        isSpecialLinksLoading={isSpecialLinksLoading}
                        journeyBenefits={journeyBenefits}
                        journeyNews={journeyNews}
                        materials={materials}
                        prompts={prompts}
                        seeds={seeds}
                        specialLinks={specialLinks}
                        steps={journey?.steps ?? []}
                        surveys={surveys}
                        tools={tools}
                        types={contentTypeConfig?.cta2Types}
                        user={user}
                      />
                    )}
                    {(formik.values.ctaType === "CTA" ||
                      formik.values.ctaType === "DOUBLE_CTA") && (
                      <Grid container spacing={4}>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formik.values.saveUserStatePathCTA}
                                color="primary"
                                {...getFieldProps(formik, {
                                  defaultValue: false,
                                  disabled: isDisabled,
                                  name: "saveUserStatePathCTA",
                                })}
                              />
                            }
                            label="Save result in a user field"
                          />
                        </Grid>
                        {formik.values.saveUserStatePathCTA && (
                          <>
                            <Grid item xs={6}>
                              <UserStatePathSelect
                                required
                                isLoading={isUserStatePathsLoading}
                                journeys={journeys.filter(
                                  (journey) => locale === journey.locale
                                )}
                                label="Field assigned"
                                userStatePaths={userStatePaths}
                                value={formik.values.userStatePath}
                                onChange={(value) => {
                                  formik.setFieldValue("userStatePath", value);
                                  formik.setFieldTouched("userStatePath", true);
                                }}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Input
                                fullWidth
                                required
                                InputLabelProps={{ shrink: true }}
                                disabled={isDisabled}
                                label="Value on CTA 1 clicked"
                                variant="outlined"
                                {...getFieldProps(formik, {
                                  name: "userPathValueCta1",
                                })}
                              />
                            </Grid>
                            {formik.values.ctaType === "DOUBLE_CTA" && (
                              <Grid item md={6} xs={12}>
                                <Input
                                  fullWidth
                                  required
                                  InputLabelProps={{ shrink: true }}
                                  disabled={isDisabled}
                                  label="Value on CTA 2 clicked"
                                  variant="outlined"
                                  {...getFieldProps(formik, {
                                    name: "userPathValueCta2",
                                  })}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                    )}
                    {formik.values.ctaType === "DROPDOWN" && (
                      <Grid container spacing={4}>
                        <Grid item md={6} xs={12}>
                          <Input
                            {...getFieldProps(formik, {
                              name: "dropdownData.0.label",
                            })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={isDisabled}
                            label="Placeholder text"
                            maxLength={25}
                            value={formik.values.dropdownData?.[0]?.label || ""}
                            variant="outlined"
                            onChange={handleDropdownDataChange(0, "label")}
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          {isWhiteBoardFamily ? (
                            <MarkdownEditorV2
                              autoLink={false}
                              disableBlockTypeSelect={true}
                              disableBoldItalicUnderline={["underline"]}
                              disableCreateLink={true}
                              disableListsToggle={true}
                              error={false}
                              placeHolder="CTA text"
                              value={formik.values.cta1Text || ""}
                              onChange={(val) => {
                                formik.setFieldValue("cta1Text", val);
                                formik.setFieldTouched("cta1Text", true);
                              }}
                            />
                          ) : (
                            <Input
                              label="CTA text"
                              placeholder="Be accurate, specific, explicit. Don't be vague."
                              {...getFieldProps(formik, {
                                disabled: isDisabled,
                                name: "cta1Text",
                              })}
                            />
                          )}
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <UserStatePathSelect
                            required
                            isLoading={isUserStatePathsLoading}
                            journeys={journeys.filter(
                              (journey) => locale === journey.locale
                            )}
                            label="Field assigned"
                            userStatePaths={userStatePaths}
                            value={formik.values.userStatePath}
                            onChange={(value) => {
                              if (
                                [formik.values.userStatePath, value].some(
                                  (value) => value === "currentJourney"
                                )
                              ) {
                                formik.values.dropdownData
                                  .slice(1)
                                  .forEach((_, i) => {
                                    formik.setFieldValue(
                                      `dropdownData.${i + 1}.value`,
                                      ""
                                    );
                                    formik.setFieldTouched(
                                      `dropdownData.${i + 1}.value`,
                                      true
                                    );
                                  });
                              }

                              formik.setFieldValue("userStatePath", value);
                              formik.setFieldTouched("userStatePath", true);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="h6">Options</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            {(formik.values.dropdownData || [])
                              .slice(1)
                              .map(({ value, label, id }, i) => (
                                <Option
                                  key={id}
                                  aiSkillingPrompts={aiSkillingPrompts}
                                  copilotNews={copilotNews}
                                  cyberTipsCdpPrompts={cyberTipsCdpPrompts}
                                  formik={formik}
                                  i={i}
                                  interactions={interactions}
                                  isCopilotNewsLoading={isCopilotNewsLoading}
                                  isDeleteEnabled={
                                    formik.values.dropdownData?.length > 2
                                  }
                                  isDisabled={isDisabled}
                                  isListJourneyBenefitsLoading={
                                    isListJourneyBenefitsLoading
                                  }
                                  isListJourneyNewsLoading={
                                    isListJourneyNewsLoading
                                  }
                                  isMaterialsLoading={isMaterialsLoading}
                                  isSpecialLinksLoading={isSpecialLinksLoading}
                                  isSurveysLoading={isSurveysLoading}                                  
                                  journeyBenefits={journeyBenefits}
                                  journeyNews={journeyNews}
                                  journeys={journeys}
                                  label={label}
                                  locale={locale}
                                  materials={materials}
                                  prompts={prompts}
                                  seeds={seeds}
                                  specialLinks={specialLinks}
                                  steps={journey?.steps}
                                  surveys={surveys}
                                  tools={tools}
                                  user={user}
                                  value={value}
                                  onCreateMaterial={handleCreateMaterial(
                                    `dropdownData.${i + 1}.ctaTarget`
                                  )}
                                  onCreateSpecialLink={handleCreateSpecialLink(
                                    `dropdownData.${i + 1}.ctaTarget`
                                  )}
                                  onDropdownDataChange={
                                    handleDropdownDataChange
                                  }
                                  onDropdownDataDelete={
                                    handleDropdownDataDelete
                                  }
                                />
                              ))}
                            <Grid item xs={12}>
                              <Button
                                color="primary"
                                disabled={isDisabled}
                                startIcon={<AddIcon />}
                                variant="outlined"
                                onClick={handleDropdownDataChange(
                                  formik.values.dropdownData?.length || 1,
                                  "value"
                                )}
                              >
                                Add option
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Sticky
                  scrollElement=".scrollarea"
                  stickyStyle={{ top: theme.spacing(4) + 92 }}
                >
                  <div ref={previewContainerRef}>
                    <Grid container id="preview" justify="flex-end">
                      <Grid item>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            flexDirection: "column",
                            height,
                          }}
                        >
                          <Grid item>
                            <Title variant="h5">Preview</Title>
                            <Subtitle color="textSecondary">
                              Save all the changes in order to see your latest
                              modifications to this {title}.
                            </Subtitle>
                          </Grid>
                          <Preview
                            semantic={formik.values}
                            src={`${
                              process.env
                                .REACT_APP_account_content_dashboard_render_url
                              //`http://localhost:3001/`
                            }?silent=true&preview=true&props=${window.btoa(
                              JSON.stringify({
                                did: `preview_${locale}`,
                                leafVersion: "24.0.220",
                                semanticId: formik.values.id,
                              })
                            )}&rerender=${getPreviewRerenderToken(interaction)}
                        `}
                            title="preview"
                            userId={`preview_${locale}`}
                            viewType={formik.values.viewType}
                          >
                            {/*
                          leafVersion is mandatory to show the preview (ex mini-tip)
                          leafVersion 24.0.220 is used just from here
                          if you omit leafVersion, preview won't be displayed
                          rerender param only triggers a new re-render (url changes)
                        */}
                            {({
                              iframe,
                              isExportImageProcessing,
                              isSizeReceived,
                              reload,
                              callExportImageLambda,
                            }) => (
                              <>
                                <Grid item>
                                  <Grid container spacing={1}>
                                    <Grid item>
                                      {/* <Box display="flex"> */}
                                      <Button
                                        color="primary"
                                        endIcon={<AutorenewIcon />}
                                        size="small"
                                        variant="outlined"
                                        onClick={reload}
                                      >
                                        RESET
                                      </Button>
                                    </Grid>
                                    {/* <Box ml={2}>
                                  <Button
                                    color="primary"
                                    endIcon={<GetAppIcon />}
                                    size="small"
                                    variant="outlined"
                                    onClick={openExportImage}
                                  >
                                    Export
                                  </Button>
                                </Box> */}
                                    {/* </Box> */}
                                    <Grid item>
                                      {/* <Box ml={2}> */}
                                      <Button
                                        color="primary"
                                        disabled={
                                          !isSizeReceived ||
                                          isExportImageProcessing
                                        }
                                        endIcon={<ImageIcon />}
                                        size="small"
                                        variant="outlined"
                                        onClick={callExportImageLambda}
                                      >
                                        Export
                                      </Button>
                                      {/* </Box> */}
                                    </Grid>
                                    {isExportImageProcessing && (
                                      <Grid item>
                                        <Subtitle color="textSecondary">
                                          ..it may take up to ~ 20s
                                        </Subtitle>
                                        <Grid item xs={12}>
                                          <LinearProgress />
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  style={{ flex: 1, overflow: "auto" }}
                                  xs={12}
                                >
                                  {iframe}
                                </Grid>
                              </>
                            )}
                          </Preview>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </Sticky>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Title variant="h5">Simulation</Title>
                    <Subtitle color="textSecondary" variant="body2">
                      Send this {titleLowerCased} to specific users by entering
                      their device IDs (DIDs).
                    </Subtitle>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      multiline
                      InputLabelProps={{ shrink: true }}
                      InputProps={multilineInputProps}
                      helperText={`${simulationDids.length} device ID${
                        simulationDids.length === 1 ? "" : "s"
                      }`}
                      label="Device IDs for simulation"
                      margin="none"
                      minRows={4}
                      placeholder={"device-id-1\ndevice-id-2"}
                      value={simulationDeviceIds}
                      variant="outlined"
                      onChange={handleSimulationDeviceIdsChange}
                    />
                  </Grid>
                  {isChannelValidityAny && (
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        required
                        select
                        label="Destination channel"
                        margin="none"
                        value={simulationDestinationChannel}
                        variant="outlined"
                        onChange={handleSimulationDestinationChannelChange}
                      >
                        {SIMULATION_DESTINATION_CHANNEL_OPTIONS.map(
                          ({ value, label }) => (
                            <MenuItem key={value} value={value}>
                              {label}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  )}
                  {simulationChannelValidity === "client" && (
                    <Grid item xs={12}>
                      <Typography color="textSecondary" variant="caption">
                        Users should have the simulation feature enabled in the
                        user dashboard to be able to receive the tip.
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      disabled={!canSendSimulation}
                      variant="contained"
                      onClick={handleSendSimulation}
                    >
                      {isSimulateSemanticLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : (
                        "Send simulation"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid
                item
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                xs={8}
              >
                {(user.groups.includes("Admins") ||
                  !user.companies?.includes(
                    "9aa46b2c-5fa6-4f0c-839d-35527dd19386"
                  )) && (
                  <>
                    <Grid>
                      <Typography style={{ fontWeight: "bold" }} variant="h6">
                        Looking for some inspiration? h{"(A)"}i is here to help
                        you!
                      </Typography>
                    </Grid>
                    <Button
                      color="primary"
                      style={{ marginLeft: "2%" }}
                      variant="contained"
                      onClick={handleAiClick}
                    >
                      Start the experience!
                    </Button>
                  </>
                )}
              </Grid> */}
              <Grid item xs={12}>
                <SaveButtons formik={formik} isNew={isNew} />
              </Grid>
              {/* <Grid container direction="column">
            <Grid
              item
              alignItems="center"
              justifyContent="center"
              p={2}
              style={{ paddingLeft: "30px", paddingRight: "30px" }}
              xs={8}
            >
              <AnalyticsReport
                elementOfInterest={formik.values.id}
                reportSelector={"semantic"}
              ></AnalyticsReport>
            </Grid>
          </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const EditInteraction = () => {
  const match = useRouteMatch();
  const { journeyId, locale, semanticId } = match.params;

  const { state } = useLocation();

  const {
    semantics,
    fetchSemantics,
    isSemanticsLoading,
    fetchJourneys,
    journeys,
    isJourneysLoading,
    // user,
    isTriggerConfigsLoading,
    isTriggersLoading,
    fetchTriggers,
    fetchTriggerConfigs,
    fetchGroups,
    isGroupsLoading,
    groups,
    triggers,
    triggerConfigs,
    fetchFlowRelations,
    isFlowRelationsLoading,
    flowRelations,
    scheduledSlots,
    fetchScheduledSlots,
    isScheduledSlotsLoading,
    fetchUserStatePaths,
    fetchAllSurveysForUser: fetchSurveys,
    materials,
    fetchMaterials,
    isMaterialsLoading,
    // tools,
    // fetchTools,
    // isToolsLoading,
    // prompts,
    // seeds,
    // aiSkillingPrompts,
    // fetchPrompts,
    // isPromptsLoading,
    listofusers,
    fetchListofusers,
    isListofusersLoading,
  } = useAppContext();

  // Track fetch attempts to prevent infinite loops when API returns empty arrays
  const fetchAttemptsRef = useRef({
    flowRelationsKeyLoaded: null,
    semanticsKeyLoaded: null,
    scheduledSlotsKeyLoaded: null,
    journeysKeyLoaded: null,
  });

  // Reset fetch attempts when journeyId or locale changes
  useEffect(() => {
    fetchAttemptsRef.current = {
      flowRelationsKeyLoaded: null,
      semanticsKeyLoaded: null,
      scheduledSlotsKeyLoaded: null,
      journeysKeyLoaded: null,
    };
  }, [journeyId, locale]);

  useEffect(() => {
    const flowRelationsKey = `${journeyId}-${locale}`;
    if (
      !flowRelations.length &&
      !isFlowRelationsLoading &&
      fetchAttemptsRef.current.flowRelationsKeyLoaded !== flowRelationsKey
    ) {
      fetchAttemptsRef.current.flowRelationsKeyLoaded = flowRelationsKey;
      fetchFlowRelations({ journeyId, locale });
    }

    const semanticsKey = `${journeyId}-${locale}`;
    if (
      !semantics.length &&
      !isSemanticsLoading &&
      fetchAttemptsRef.current.semanticsKeyLoaded !== semanticsKey
    ) {
      fetchAttemptsRef.current.semanticsKeyLoaded = semanticsKey;
      fetchSemantics({ journeyId, locale });
    }

    if (
      !scheduledSlots.length &&
      !isScheduledSlotsLoading &&
      fetchAttemptsRef.current.scheduledSlotsKeyLoaded !== journeyId
    ) {
      fetchAttemptsRef.current.scheduledSlotsKeyLoaded = journeyId;
      fetchScheduledSlots({ journeyId });
    }

    if (
      !journeys.length &&
      !isJourneysLoading &&
      fetchAttemptsRef.current.journeysKeyLoaded !== "all"
    ) {
      fetchAttemptsRef.current.journeysKeyLoaded = "all";
      fetchJourneys();
    }
    // if (!tools.length && !isToolsLoading) {
    //   fetchTools();
    // }
    // if (!prompts.length && !isPromptsLoading) {
    //   fetchPrompts();
    // }
    // if (!seeds.length && !isPromptsLoading) {
    //   fetchPrompts("allitude");
    // }
    // if (!aiSkillingPrompts.length && !isPromptsLoading) {
    //   fetchPrompts("aiskilling");
    // }
  }, [
    journeyId,
    locale,
    journeys.length,
    isJourneysLoading,
    semantics.length,
    isSemanticsLoading,
    flowRelations.length,
    isFlowRelationsLoading,
    scheduledSlots.length,
    isScheduledSlotsLoading,
    fetchFlowRelations,
    fetchSemantics,
    fetchScheduledSlots,
    fetchJourneys,
    // tools.length,
    // isToolsLoading,
    // prompts.length,
    // isPromptsLoading,
    // seeds.length,
    // aiSkillingPrompts.length,
  ]);

  const { isNew, type, flowId, stimulusId } = state || {};
  const interaction = useMemo(
    () =>
      isNew && type === "PRIME"
        ? {
            cta1Type: "Close",
            cta2Type: "Close",
            ctaType: "CTA",
            flowId: flowId || `flow-${uuidv4()}`,
            id: semanticId,
            index: 0,
            isFirstInFlow: !flowId,
            isNew,
            journeyId,
            semanticId,
            semanticPreview: {},
            showX: true,
            stimulusId: "S_P999",
            templateColors: {},
            type,
          }
        : isNew && type === "NUDGE"
        ? {
            cta1Type: "Close",
            cta2Type: "Close",
            ctaType: "CTA",
            flowId: flowId || `flow-${uuidv4()}`,
            id: semanticId,
            index: 0,
            isFirstInFlow: true,
            isNew,
            journeyId,
            semanticId,
            semanticPreview: {},
            showX: true,
            stimulusId,
            templateColors: {},
            type,
          }
        : semantics?.find((semantic) => semantic.id === semanticId),
    [flowId, isNew, journeyId, semanticId, semantics, stimulusId, type]
  );

  useEffect(() => {
    if (interaction?.type === "NUDGE" && !triggerConfigs.length) {
      fetchTriggerConfigs({ journeyId });
    }

    if (interaction?.type === "NUDGE" && !triggers.length) {
      fetchTriggers({ journeyId });
    }

    if (interaction?.type === "NUDGE" && !Object.keys(groups).length) {
      fetchGroups({ journeyId });
    }

    if (interaction?.type === "NUDGE" && interaction.isFirstInFlow) {
      if (!materials && !isMaterialsLoading)
        fetchMaterials({ journeyId, locale });
      fetchSurveys({ journeyId });
      fetchUserStatePaths();
      if (!listofusers && !isListofusersLoading) fetchListofusers();
    }
  }, [interaction, journeyId, locale]);

  const journey = useMemo(
    () =>
      journeys.find(
        (journey) => journey.id === journeyId && journey.locale === locale
      ),
    [journeyId, locale, journeys]
  );

  if (
    isSemanticsLoading ||
    isJourneysLoading ||
    !journeys.length ||
    isTriggersLoading ||
    isTriggerConfigsLoading ||
    isFlowRelationsLoading ||
    isGroupsLoading
  ) {
    return <Loader />;
  }

  if ((!isNew && !semantics.length) || !journeys.length || !interaction) {
    return (
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        width="100%"
      >
        <Typography variant="subtitle1">Interaction is not found 😢</Typography>
      </Box>
    );
  }

  const isDisabled = journey.isDisabled;

  const interactions = orderBy(
    semantics
      .filter(({ id, type, flowId }) =>
        type === interaction.type && flowId
          ? flowId === interaction.flowId
          : id === interaction.id
      )
      .map(
        ({
          isFirstInFlow,
          miniTipAutoProgress,
          miniTipAutoProgressOnlyIfIgnored,
          ...semantic
        }) => ({
          ...semantic,
          isFirstInFlow: Boolean(isFirstInFlow),
          miniTipAutoProgressOnlyIfIgnored: Boolean(
            miniTipAutoProgressOnlyIfIgnored
          ),
          miniTipAutoProgress: Boolean(miniTipAutoProgress),
        })
      ),
    ["isFirstInFlow", "createdAt"],
    ["desc", "asc"]
  );

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {isDisabled && (
        <Alert severity="info">
          Digital Attitude Journey interactions is not editable! Copy Journey to
          edit 💡
        </Alert>
      )}
      {isDisabled && (
        <Alert severity="info">
          {`Interaction's Journey is not editable!
          Copy it to edit 💡`}
        </Alert>
      )}
      <Box
        boxSizing="border-box"
        display="flex"
        flexDirection="column"
        height="100%"
        p={4}
        width="100%"
      >
        <Interaction
          key={interaction?.id}
          interaction={interaction}
          interactions={interactions}
          isDisabled={isDisabled}
          isNew={isNew}
          journey={journey}
          journeyId={journeyId}
          listofusers={listofusers}
          locale={locale}
        />
      </Box>
    </Box>
  );
};

export default EditInteraction;
